export const eng = {
  shiftCashPost: {
    shiftsAvailableForCheckoutH1: "Shifts Available For Checkout",
    shiftsAvailableForDepositH1: "Shifts Available For Deposit",
    totalCashNotice: "Total cash to be deposited to the bank: ",
    noShiftAvailable: "No shift available.",
    paginationNext: "Next",
    paginationPrev: "Prev",
    loadShifts: "Load Shifts",
    depositToBankButton: "Deposit Cash in the Bank",
    printDepositButton: "Print Deposit Report",
    loading: "Loading...",

    ui: {
      pageSubtitle:
        "Collector enters cash per employee, locks the shift, then deposits the prepared cash group to the bank.",
      checkoutShifts: "Checkout shifts",
      checkoutDraftTotal: "Checkout draft total",
      readyForDeposit: "Ready for deposit",
      employees: "Employees",
      firstShift: "First Shift",
      lastShift: "Last Shift",
      page: "Page",
      checkoutHint: "Enter cash amounts and notes for each employee.",
      depositHint: "Review saved cash entries before depositing to the bank.",
      entered: "Entered",
      empty: "Empty",
      emptyOrZero: "Empty / Zero",
      status: "Status",
      employeeCashEntry: "Employee cash entry",
      optionalNote: "Optional note",
      depositFailedTitle: "Deposit Failed"
    },

    alerts: {
      invalidNumber: "Please enter a valid number.",
      operationFailed: "Operation failed.",
      noDepositShifts: "There are no shifts to deposit in the bank."
    },

    checkModal: {
      title: "Confirm Cash Deposit",
      buttonText: "Deposit to bank",
      questionText: "Do you want to deposit the total cash in the bank?",
    },

    failedModal: {
      title: "Connection Failed",
      buttonText: "Retry",
      questionText: "Couldn't get shifts from the server.",
    },

    depositPostFailedModal: {
      title: "Deposit Failed",
      buttonText: "Retry",
      questionText:
        "The server could not be reached and therefore the cash deposit could not be saved. Would you like to try again?",
    },
  },
  navigation: {
    home: "Home",
    login: "Login",
    logout: "Logout",
    cash: "Cash",
    creditCard: "Credit Card",
    shiftReview: "Shifts",
    companyUsers: "Company Users",
    contact: "Contact",
    about: "About",
    solutions: "Solutions",
    pricing: "Pricing",
    blog: "Blog",
    fraud: "Fraud Prevention",
    deposit: "Deposit Verification",
    cardVerify: "Card Payment Verification",
    shiftReport: "Shift Report",
    salesAnalytics: "Sales Analytics",
    liveSales: "Live Sales",
    tanks: "Tank Stock",
    mySubscription: "My Subscription",
    admin: {
      title: "Admin",
      shifts: "Shifts",
      deposits: "Cash Operations",
      creditCards: "Credit Card Operations",
      employeeDeficit: "Employee Deficits",
      companyUsers: "Company Users",
      reconciliationV2: "Reconciliation",
      paymentTypeCorrection: "Payment Type Correction",
      fuelGrossProfit: "Fuel Gross Profit",
      saleEarnings: "Sale Earnings",
      settlementCheck: "Settlement Check"
    }
  },
  salesAnalytics: {
    title: "Sales Analytics",
    subtitle:
      "Analyze your station's fuel sales: KPIs, trends, breakdowns and a filterable transaction table.",
    filters: {
      title: "Filters",
      quickRange: "Quick range",
      presets: {
        THIS_MONTH: "This month",
        LAST_MONTH: "Last month",
        THIS_QUARTER: "This quarter",
        LAST_QUARTER: "Last quarter",
        THIS_YEAR: "This year",
        LAST_YEAR: "Last year"
      },
      saleType: "Sale type",
      paymentMethod: "Payment",
      employee: "Employee",
      allEmployees: "All employees",
      apply: "Apply",
      reset: "Reset",
      advanced: "More filters",
      optional: "Any",
      invalidWindow: "The end date must not be before the start date.",
      dateMode: { all: "All dates", period: "Period", window: "Date range" },
      period: "Period",
      periodValues: { DAY: "Day", WEEK: "Week", MONTH: "Month", YEAR: "Year" },
      referenceDate: "Reference date",
      from: "From",
      to: "To",
      shiftId: "Shift ID",
      fuelType: "Fuel type",
      paymentType: "Payment type",
      pumpNr: "Pump no.",
      nozzleNr: "Nozzle no.",
      loyaltyCardType: "Loyalty card type",
      plate: "Plate",
      ecrPlate: "ECR plate",
      fleetCode: "Fleet code",
      minTotal: "Min revenue",
      maxTotal: "Max revenue",
      minAmount: "Min litres",
      maxAmount: "Max litres"
    },
    kpis: {
      transactions: "Transactions",
      revenue: "Revenue",
      volume: "Volume",
      averageTicket: "Average ticket",
      averageUnitPrice: "Avg. unit price"
    },
    trend: {
      title: "Sales trend",
      metric: "Metric",
      revenue: "Revenue",
      volume: "Volume",
      transactions: "Transactions",
      granularity: "Granularity",
      granularityValues: {
        HOUR: "Hourly",
        DAY: "Daily",
        WEEK: "Weekly",
        MONTH: "Monthly",
        YEAR: "Yearly"
      },
      chartType: { line: "Line", bar: "Bar" },
      empty: "No sales in this range."
    },
    breakdown: {
      title: "Breakdown",
      dimension: "Group by",
      dimensionValues: {
        FUEL_TYPE: "Fuel type",
        PAYMENT_TYPE: "Payment type",
        PUMP: "Pump",
        NOZZLE: "Nozzle",
        LOYALTY_CARD_TYPE: "Loyalty card",
        FLEET: "Fleet",
        EMPLOYEE: "Employee"
      },
      employeeNote: "Retail attendant sales only (reconciles with Shift Review).",
      chartType: { pie: "Pie", bar: "Bar" },
      empty: "No sales to break down.",
      unknown: "Unspecified",
      cols: {
        name: "Type",
        transactions: "Sales",
        volume: "Volume",
        revenue: "Revenue",
        share: "Share"
      }
    },
    fuelTypes: {
      "5": "AdBlue",
      "6": "VP95/Unleaded",
      "7": "VP Diesel",
      "8": "LPG"
    },
    table: {
      title: "Transactions",
      rowsPerPage: "Rows",
      page: "Page",
      of: "of",
      prev: "Previous",
      next: "Next",
      empty: "No transactions match the filter.",
      totalRows: "transactions",
      corrected: "corrected",
      columns: {
        dateTime: "Date / time",
        shift: "Shift",
        fuelType: "Fuel",
        plate: "Plate",
        ecrPlate: "ECR plate",
        pump: "Pump",
        nozzle: "Nozzle",
        amount: "Litres",
        unitPrice: "Unit price",
        total: "Revenue",
        paymentType: "Payment",
        receipt: "Receipt"
      },
      detail: {
        fullUnitPrice: "List unit price",
        rawPaymentType: "Raw payment type",
        fleetCode: "Fleet code",
        fleetName: "Fleet name",
        loyaltyCardType: "Loyalty card type",
        loyaltyCardNo: "Loyalty card no.",
        redemption: "Loyalty redemption",
        discountAmount: "Discount",
        earnedPoints: "Earned points",
        earnedMoney: "Earned money"
      }
    },
    common: {
      loading: "Loading...",
      error: "Could not load sales data.",
      retry: "Retry"
    },
    review: {
      title: "Sales Review",
      subtitle:
        "Review every individual sale matching the filter; expand a row for full detail.",
      reviewSales: "Review sales",
      backToDashboard: "← Back to dashboard"
    },
    insights: {
      title: "When do we sell?",
      profile: "Group by",
      profileValues: {
        HOUR_OF_DAY: "Hour of day",
        DAY_OF_WEEK: "Day of week",
        DAY_OF_MONTH: "Day of month",
        MONTH_OF_YEAR: "Month of year"
      },
      metric: "Metric",
      revenue: "Revenue",
      volume: "Volume",
      transactions: "Transactions",
      peak: "Peak",
      empty: "No sales in this range."
    },
    segments: {
      title: "Sales by segment",
      revenue: "Revenue",
      volume: "Volume",
      transactions: "Transactions",
      empty: "No sales in this range.",
      note: "Segments can overlap (e.g. a loyalty sale also counts as retail), so they don't add up to the grand total. Click a bar to filter by that segment."
    },
    categories: {
      all: "All",
      cash: "Cash",
      credit: "Credit (company/distributor)",
      creditCard: "Credit Card"
    },
    saleTypes: {
      all: "All",
      EMPLOYEE: "Retail",
      DISTRIBUTOR: "Distributor",
      COMPANY: "Company",
      PARTNER_CARD: "Partner card",
      GIFT_CARD: "Gift card",
      MOBILE: "Mobile",
      TEST: "Test"
    },
    live: {
      title: "Live Sales",
      subtitle:
        "Live view of the current open shift: filter by date or shift to review imported sales.",
      provisional:
        "Provisional live preview of the open shift, not the final, reconciled shift figures.",
      todayCombinedNote:
        "Today so far = today's imported (closed) shifts + the live open shift. The live portion is provisional.",
      openAnalytics: "Open analytics",
      liveTag: "live",
      importedTag: "imported",
      imported: "IMPORTED",
      viewingImported:
        "Viewing finalized (imported) sales for the selected scope.",
      live: "LIVE",
      paused: "PAUSED",
      pause: "Pause",
      resume: "Resume",
      refresh: "Refresh",
      refreshing: "Refreshing…",
      refreshEvery: "Refresh every",
      shiftStatus: "Shift",
      count: "Sales",
      lastReceipt: "Last receipt",
      lastSale: "Last sale",
      updated: "Updated",
      statusValues: { OPEN: "Open", CLOSED: "Closed", UNKNOWN: "Unknown" },
      share: {
        button: "Share image",
        title: "Live Shift Sales",
        asOf: "as of",
        generated: "Generated",
        brand: "Shift Tracker",
        filename: "live-sales",
        shareText: "Live shift sales summary"
      },
      window: {
        label: "Time window",
        values: {
          CURRENT_SHIFT: "Current shift",
          TODAY: "Today",
          H1: "Last hour",
          M30: "Last 30 min",
          M15: "Last 15 min",
          M5: "Last 5 min"
        },
        truncated:
          "Showing the most recent 200 sales; the selected window may contain more."
      }
    }
  },
  tanks: {
    title: "Tank Stock",
    subtitle:
      "Live fuel tank levels and per-shift history, visualized and refreshed automatically.",
    live: "LIVE",
    paused: "PAUSED",
    refresh: "Refresh",
    refreshing: "Refreshing…",
    pause: "Pause",
    resume: "Resume",
    refreshEvery: "Refresh every",
    asOf: "As of",
    baselineShift: "Baseline shift",
    indicativeLabel: "Figures",
    indicative: "Live / indicative",
    loading: "Loading…",
    error: "Could not load tank data.",
    noSnapshot: "No tank snapshot yet; figures appear once the first shift is imported.",
    dispensed: "Dispensed",
    dispensedShift: "Dispensed this shift",
    deliveredShift: "Delivered this shift",
    capacityUnknown: "Capacity unknown",
    freeSpace: "Available space",
    unloadWarning: "Below the safe unloading margin",
    unloadDanger: "Not safe to unload a tanker compartment",
    legend: {
      title: "Safe to unload?",
      intro: "Empty space available for a fuel delivery:",
      ok: "Safe, with margin",
      warning: "Tight margin",
      danger: "Do not unload",
    },
    compact: "Compact",
    detailed: "Detailed",
    share: {
      button: "Share",
      failed: "Could not create the image. Please try again.",
      filename: "tank-stock",
      shareText: "Tank stock",
      title: "Tank Stock",
      asOf: "As of",
      generated: "Generated",
      brand: "Shift Tracker",
      available: "Available",
      current: "Current",
      free: "Free space",
      capacity: "Capacity",
      fill: "Fill",
      more: "+{n} more tanks",
      note: "Live / indicative: estimated book value, not a physical dip."
    },
    tank: "Tank",
    allTanks: "All tanks",
    trendTitle: "Tank trend (per shift)",
    metricValues: {
      consumption: "Consumption",
      delivery: "Deliveries",
      stock: "Stock"
    },
    historyTitle: "Per-shift readings",
    historyEmpty: "No readings for this selection.",
    historyCols: {
      shift: "Shift",
      recordedAt: "Recorded",
      tank: "Tank",
      previous: "Start",
      dispensed: "Dispensed",
      delivery: "Delivered",
      current: "End stock"
    },
    totalRows: "readings",
    prev: "Previous",
    next: "Next",
    page: "Page",
    of: "of",
    orders: {
      title: "Order suggestions",
      advisory: "Estimated / advisory",
      basis: "Based on the last {weeks} weeks",
      strategy: "Strategy",
      strategyValues: {
        MINIMIZE_INVENTORY: "Minimize inventory",
        NEUTRAL: "Neutral",
        MAXIMIZE_CAPACITY: "Maximize capacity"
      },
      strategyHelp: {
        MINIMIZE_INVENTORY: "smallest safe order: run lean (price drop expected)",
        NEUTRAL: "cover demand to the next delivery, plus a buffer",
        MAXIMIZE_CAPACITY: "fill up to ~{pct}% of capacity (price rise expected)"
      },
      strategyTooltip: {
        MINIMIZE_INVENTORY: "Use this when you expect a price drop",
        NEUTRAL: "Use this when you expect prices to stay neutral",
        MAXIMIZE_CAPACITY: "Use this when you expect a price rise"
      },
      strategyHint: "When do I use each? ▸ Maximize capacity: expecting a price rise · Neutral: prices steady · Minimize inventory: expecting a price drop",
      arrives: "Tanker arrives",
      nextDelivery: "Next delivery",
      target: "Target",
      clear: "Clear",
      intraday: "Next ~{h}h",
      coverTo: "Covers next ~{h}h",
      order: "Order",
      noOrder: "No order needed",
      capacityUnknownCta: "Set tank capacity for an estimate",
      urgent: "Urgent",
      willRunDry: "will run dry",
      now: "Now",
      atArrival: "At arrival",
      intradayBaseline: "next ~{h}h",
      empty: "No order suggestions yet.",
      loading: "Loading…"
    }
  },
  fuelCost: {
    title: "Fuel Gross Profit",
    subtitle:
      "Cost of goods sold from your delivery invoices against the Turpak sales: gross profit per shift, day and month, plus the distributor settlement invoices.",
    loading: "Loading…",
    error: "Could not load the gross profit report.",
    actions: {
      exportExcel: "Export to Excel",
      exporting: "Exporting…",
      exportError: "The Excel export failed.",
      recompute: "Rebuild ledger",
      recomputing: "Rebuilding…"
    },
    status: {
      upToDate: "Ledger up to date",
      dirty: "Ledger rebuilding",
      lastRun: "Last rebuild",
      lastCosted: "Last costed shift",
      waiting: "Receipts waiting",
      noOpening: "No opening balance",
      notSold: "Not sold",
      noOpeningNotice: "Nothing is costed until an opening balance is entered for:",
      error: "Error"
    },
    filters: {
      from: "From",
      to: "To",
      granularity: "View",
      day: "Day",
      month: "Month",
      shift: "Shift",
      fuel: "Fuel",
      allFuels: "All fuels",
      apply: "Apply",
      quickRange: "Quick range",
      invalidRange: "Enter a valid date range (from must not be after to).",
      presets: {
        thisMonth: "This month",
        lastMonth: "Last month",
        last3Months: "Last 3 months",
        thisYear: "This year"
      }
    },
    kpis: {
      soldLiters: "Litres sold",
      sales: "sales",
      netRevenue: "Net revenue (excl. KDV)",
      outputKdv: "Output KDV",
      cogs: "Cost of goods sold",
      stockVariance: "Incl. stock variance",
      salesMinusCogs: "Sales minus COGS",
      perLiter: "per litre",
      settlement: "Settlement invoices",
      revenueShare: "Revenue share",
      loyaltyReimbursement: "Loyalty reimbursement",
      priceDifference: "Price difference",
      grossProfit: "Gross profit",
      provisional: "Provisional litres"
    },
    table: {
      title: "Breakdown",
      period: "Period",
      fuel: "Fuel",
      soldLiters: "Litres",
      netRevenue: "Net revenue",
      cogs: "COGS",
      salesMinusCogs: "Sales minus COGS",
      marginPerLiter: "Margin / L",
      marginPercent: "Margin %",
      receipts: "Received L",
      variance: "Variance L",
      closing: "Closing L",
      avgCost: "Avg cost",
      settlementRow: "Settlement",
      grossProfit: "Gross profit",
      flags: "Flags",
      total: "Total",
      empty: "No costed shifts in this range. Enter the opening balances and upload the delivery invoices to start."
    },
    flags: {
      PROVISIONAL: "Provisional cost",
      NEGATIVE_STOCK: "Negative stock",
      NO_TANK_READING: "No tank reading",
      VARIANCE_OVER_TOLERANCE: "Variance over tolerance",
      NO_SALES: "No sales",
      NO_COST_BASIS: "No cost basis",
      KDV_RATE_MISSING: "KDV rate missing",
      PROVISIONAL_UNPRICED: "Unpriced delivery",
      TANK_NOT_GAUGED: "Tank not gauged",
      REVENUE_SHARE_UNPRICED: "Share not estimated"
    },
    setup: {
      title: "Costing setup",
      missing: "missing",
      show: "Show",
      hide: "Hide",
      openingHelp:
        "One opening balance per fuel: the stock at the start of the first costed shift and its purchase cost excl. KDV. Replacing a balance rebuilds the ledger from that shift; a balance at a later shift removes the costing of every earlier shift, closed months included, until a balance at an earlier shift is entered again.",
      fuel: "Fuel",
      effectiveShift: "First costed shift",
      liters: "Litres",
      unitCost: "Unit cost excl. KDV",
      save: "Save",
      replace: "Replace",
      saving: "Saving…",
      current: "Current",
      failed: "Could not save.",
      settings: "Settings",
      settingsHelp:
        "Saving a change to any setting but the closed-through date rebuilds the ledger. A new receipt basis or LPG density also books the litres of every invoice already uploaded again. A new LPG density leaves the opening balances as entered: an LPG opening worked out from kilograms must be entered again (litres: kilograms ÷ new density; unit cost: price per kilogram × new density).",
      receiptBasis: "Receipt basis",
      basisAmbient: "Ambient litres (delivery note)",
      basisL15: "Invoiced litres at 15 °C",
      lpgDensity: "LPG density (kg/L)",
      loyaltyReimbursed: "Loyalty discounts are reimbursed by the distributor",
      tolerance: "Shrinkage tolerance",
      gasoline: "gasoline",
      diesel: "diesel",
      lpg: "LPG",
      closedThrough: "Closed through",
      settlementParams: {
        title: "Settlement parameters",
        help:
          "What the distributor settles on each sale: these drive the per-sale earnings and the expected settlement figures. Shares and rates are entered as percentages.",
        revenueShareRetail: "Revenue share, retail (%)",
        revenueShareCompany: "Revenue share, company accounts (%)",
        revenueShareTts: "Revenue share, TTS (%)",
        sharesHelp:
          "The revenue share estimate is your share of the margin between the reference (refinery) price and the pump price excl. KDV on every litre of gasoline and diesel sold; the distributor pays it monthly as a premium invoice.",
        ttsFleetDiscount: "TTS fleet discount (%)",
        fleetDiscountHelp:
          "The discount the distributor grants its fleet customers on the pump price; it is deducted before a TTS sale's margin is shared.",
        cardCommissionRate: "Card commission (%)",
        commissionHelp:
          "The commission the distributor keeps on partner (3), mobile (6, 7) and gift (9) card sales, on the KDV-inclusive total.",
        referenceGap: "Reference gap (TL/L excl. KDV)",
        referenceGapGasoline: "Gasoline",
        referenceGapDiesel: "Diesel",
        gapHelp:
          "When no reference price covers a date, the reference stands in as the purchase price minus this gap; leave a grade blank to leave its sales unestimated.",
        invalidPercent: "Enter a percentage between 0 and 100.",
        invalidNumber: "Enter a number or leave the field blank."
      },
      referencePrices: {
        title: "Reference prices",
        help:
          "The distributor's announced reference (refinery) price per grade, excl. KDV, from an effective date. Saving a price for the same grade and date replaces it.",
        fuel: "Fuel",
        effectiveFrom: "Effective from",
        price: "Price excl. KDV (TL/L)",
        source: "Source",
        note: "Note",
        add: "Save price",
        saving: "Saving…",
        delete: "Delete",
        deleteConfirm:
          "Delete this reference price? Sales from its effective date fall back to the next older price or the reference gap.",
        empty: "No reference prices entered yet.",
        failed: "Could not save the reference price.",
        deleteFailed: "Could not delete the reference price.",
        sources: {
          MANUAL: "Manual",
          EMAIL: "E-mail"
        }
      }
    },
    upload: {
      title: "Upload e-Invoices",
      help:
        "Drop the e-Fatura XML files or a ZIP of them: the distributor's delivery and fee invoices and your own invoices to the distributor. Duplicates are skipped, fuel lines become receipts and the ledger rebuilds.",
      dropHere: "Drop XML or ZIP files here",
      choose: "Choose files",
      upload: "Upload",
      uploading: "Uploading…",
      unsupported: "Only .xml and .zip files can be uploaded.",
      failed: "The upload failed.",
      result: "Result",
      created: "stored",
      duplicates: "duplicates",
      rejected: "rejected",
      receipts: "receipts booked",
      skipped: "entries skipped",
      file: "File",
      outcome: "Outcome",
      invoice: "Invoice",
      reason: "Reason",
      outcomes: {
        CREATED: "Stored",
        DUPLICATE: "Duplicate",
        REJECTED: "Rejected"
      }
    },
    invoices: {
      title: "Invoices",
      direction: "Direction",
      all: "All",
      INCOMING: "Incoming",
      OUTGOING: "Outgoing",
      date: "Date",
      number: "Number",
      party: "Counterparty",
      netAmount: "Net amount",
      payable: "Payable",
      lines: "Lines",
      status: "Status",
      xml: "XML",
      void: "Void",
      voidConfirm: "Void this invoice? Its receipts are voided and the ledger is rebuilt.",
      empty: "No invoices uploaded yet.",
      statuses: {
        PARSED: "Parsed",
        NEEDS_REVIEW: "Needs review",
        BOOKED: "Booked",
        VOIDED: "Voided"
      }
    },
    receipts: {
      title: "Fuel receipts",
      help:
        "Litres that entered stock and what they cost: from invoices, manual entries, or tank-measured deliveries still waiting for their invoice (provisional).",
      date: "Date",
      fuel: "Fuel",
      liters: "Litres",
      unitCost: "Unit cost",
      cost: "Cost excl. KDV",
      source: "Source",
      status: "Status",
      shift: "Costing shift",
      note: "Note",
      unplaced: "awaiting delivery",
      inOpeningStock: "in the opening stock",
      empty: "No receipts in this range.",
      manual: "Add a manual receipt",
      add: "Add",
      saving: "Saving…",
      failed: "Could not add the receipt.",
      void: "Void",
      voidConfirm: "Void this receipt? The ledger is rebuilt from the day before its delivery day.",
      sources: {
        INVOICE: "Invoice",
        MANUAL: "Manual",
        PROVISIONAL_TANK: "Tank (provisional)"
      },
      statuses: {
        BOOKED: "Booked",
        PROVISIONAL: "Provisional",
        VOIDED: "Voided"
      }
    },
    earnings: {
      title: "Sale Earnings",
      subtitle:
        "What every single fuel sale earns once the cost of goods and the distributor settlement are counted: find the most and least profitable channels, attendants, customers and payment types, and the sales that lose money.",
      formula:
        "Gross profit = net revenue excl. KDV - cost of goods sold + loyalty reimbursement + revenue share - card commission",
      formulaNote:
        "A sale's cost of goods is its litres at the average cost. The stock variance against the tank readings, and the revaluation of litres sold while the book stood oversold, belong to the shift, not to any one sale: the gross profit report counts them, so for the same dates and grade, with no other filter, its cost of goods sold differs from this page's total by exactly those two: a stock loss, or a revaluation at a higher delivery price, raises it; a measured gain, or a revaluation at a lower delivery price, lowers it.",
      loading: "Loading…",
      error: "Could not load the sale earnings.",
      filters: {
        from: "From",
        to: "To",
        fuel: "Fuel",
        allFuels: "All fuels",
        channel: "Channel",
        allChannels: "All channels",
        paymentType: "Payment type",
        allPaymentTypes: "All payment types",
        cardType: "Card type",
        allCardTypes: "All card types",
        negativeOnly: "Only loss-making sales",
        search: "Search",
        searchPlaceholder: "Attendant, plate, fleet, receipt no",
        shift: "Shift",
        apply: "Apply",
        clear: "Clear filters",
        invalidRange: "Enter a valid date range (from must not be after to)."
      },
      channels: {
        RETAIL: "Retail",
        TTS: "TTS (distributor fleet)",
        COMPANY: "Company account"
      },
      cardTypes: {
        "0": "No card",
        "3": "Partner card",
        "9": "Gift card",
        "6": "Mobile (6)",
        "7": "Mobile (7)"
      },
      kpis: {
        sales: "Sales",
        liters: "Litres",
        netRevenue: "Net revenue (excl. KDV)",
        grossRevenue: "incl. KDV",
        cogs: "Cost of goods sold",
        salesMinusCogs: "Sales minus COGS",
        loyaltyReimbursement: "Loyalty reimbursement",
        revenueShare: "Revenue share",
        cardCommission: "Card commission",
        grossProfit: "Gross profit",
        perLiter: "per litre",
        margin: "margin",
        negativeRows: "Loss-making sales",
        negativeSum: "total loss"
      },
      breakdown: {
        title: "Breakdown",
        dimension: "Group by",
        hint: "Click a row to filter the sales by that group.",
        empty: "No sales match the filters.",
        emptyGroup: "(not recorded)",
        total: "Total",
        dimensions: {
          CHANNEL: "Channel",
          FUEL: "Fuel",
          ATTENDANT: "Attendant",
          CUSTOMER: "Customer",
          PAYMENT_TYPE: "Payment type",
          CARD_TYPE: "Card type",
          PUMP: "Pump",
          DAY: "Day",
          MONTH: "Month",
          HOUR: "Hour of day",
          SHIFT: "Shift"
        },
        columns: {
          label: "Group",
          sales: "Sales",
          negative: "Loss-making",
          liters: "Litres",
          netRevenue: "Net revenue",
          cogs: "COGS",
          loyaltyReimbursement: "Reimbursement",
          revenueShare: "Share",
          cardCommission: "Commission",
          grossProfit: "Gross profit",
          perLiter: "Per litre",
          marginPercent: "Margin %",
          shareOfTotal: "Of total %"
        }
      },
      table: {
        title: "Sales",
        empty: "No sales match the filters.",
        provisional: "Provisional",
        provisionalHint: "Costed against a provisional (uninvoiced) delivery.",
        unpriced: "Unpriced",
        unpricedHint: "No reference price for this date: the revenue share is not estimated.",
        columns: {
          saleAt: "Time",
          shift: "Shift",
          fuel: "Fuel",
          channel: "Channel",
          attendant: "Attendant",
          plate: "Plate",
          fleet: "Fleet",
          pumpNozzle: "Pump / nozzle",
          receipt: "Receipt no",
          paymentType: "Payment",
          cardType: "Card",
          liters: "Litres",
          grossRevenue: "Paid incl. KDV",
          loyaltyDiscount: "Loyalty discount",
          netRevenue: "Net revenue",
          costRate: "Cost / L",
          cogs: "COGS",
          loyaltyReimbursement: "Reimbursement",
          revenueShare: "Share",
          cardCommission: "Commission",
          grossProfit: "Gross profit",
          perLiter: "Per litre",
          marginPercent: "Margin %",
          flags: "Flags"
        }
      },
      actions: {
        exportExcel: "Export to Excel",
        exporting: "Exporting…",
        exportError: "The Excel export failed."
      }
    },
    settlement: {
      title: "Settlement Check",
      subtitle:
        "Verify the distributor's settlement documents against your own data: the expected figure of every 10-day, weekly (AdBlue) and monthly period, computed from your sales, next to the uploaded e-Fatura.",
      loading: "Loading…",
      error: "Could not load the settlement check.",
      empty: "No settlement periods touch this range.",
      emptyType: "No periods of this type in the range.",
      filters: {
        from: "From",
        to: "To",
        apply: "Apply",
        invalidRange: "Enter a valid date range (from must not be after to)."
      },
      summary: {
        title: "Periods by status",
        generatedAt: "Computed"
      },
      statuses: {
        MATCHED: "Matched",
        DIFFERS: "Differs",
        MISSING_ACTUAL: "Invoice missing",
        NOT_DUE: "Not due yet",
        UNESTIMATED: "Not estimated",
        NOT_COMPARED: "Not compared",
        EXPECTED_CREDIT_UNBILLED: "Credit not declared"
      },
      types: {
        TTS_SALE: {
          title: "TTS sales invoice",
          description: "Every 10 days you invoice the distributor the fleet (TTS) litres sold at the pump price."
        },
        PARTNER_SALE: {
          title: "Partner card sales invoice",
          description: "Every 10 days you invoice the distributor the litres paid with partner cards at the pump price."
        },
        ADBLUE_SALE: {
          title: "AdBlue sales invoice",
          description: "Weekly windows (days 1-7, 8-14, 15-21, 22-28 and 29 to month end): you invoice the distributor the AdBlue sold to the fleet in each window."
        },
        LOYALTY_REIMBURSEMENT: {
          title: "Loyalty reimbursement",
          description: "Monthly: the loyalty discounts you granted at the pump that the distributor pays back, excl. KDV."
        },
        REVENUE_SHARE: {
          title: "Revenue share (premium)",
          description:
            "Monthly: your share of the margin between the reference price and the pump price; an estimate until the invoice arrives."
        },
        PRICE_DIFFERENCE: {
          title: "Depot price difference",
          description:
            "When the distributor lowers its delivery price: the litres invoiced on or after the cut at the old price times the decrease, as a credit to you; increases are never charged."
        }
      },
      directions: {
        OUTGOING: "You invoice the distributor",
        INCOMING: "The distributor invoices you"
      },
      columns: {
        period: "Period",
        dueDate: "Due",
        expected: "Expected",
        actual: "Actual",
        difference: "Difference",
        status: "Status",
        liters: "litres",
        exclKdv: "excl. KDV",
        kdv: "KDV",
        inclKdv: "incl. KDV",
        invoice: "Invoice",
        issueDate: "issued",
        noExpected: "No estimate",
        partialData: "Partial: the imported sales do not cover the whole period",
        noActual: "No invoice",
        details: "Details",
        hideDetails: "Hide"
      },
      lines: {
        title: "Expected detail",
        label: "Item",
        rows: "Rows",
        liters: "Litres",
        unitPrice: "Unit price",
        exclKdv: "Excl. KDV",
        inclKdv: "Incl. KDV",
        empty: "No detail lines.",
        notCounted: "Shown for information, not included in the expected total.",
        priceCut: "price cut on"
      },
      comparison: {
        title: "Expected and uploaded, line by line",
        line: "Line",
        expected: "Expected excl. KDV",
        uploaded: "Uploaded excl. KDV",
        difference: "Difference",
        expectedLiters: "Expected litres",
        uploadedLiters: "Uploaded litres",
        result: "Result",
        matches: "Matches",
        differs: "Differs",
        groups: {
          FUELS: "Fuels (AKARYAKIT)",
          LPG: "Autogas (OTOGAZ)",
          GIFT: "Points redeemed (YAKIT HEDIYE)"
        }
      },
      notes: {
        ESTIMATE_REVENUE_SHARE:
          "Formula-based estimate from the reference and pump prices: until the formula is confirmed it can be about ten percent off, and it counts as matched within five percent.",
        ESTIMATE_PRICE_DIFFERENCE:
          "Computed from the delivery invoices around the price cut; the exact set of deliveries the distributor compensates is confirmed on one month only.",
        NO_REFERENCE_PRICE:
          "No reference price covers this period, so the share could not be estimated. Enter one in the costing setup.",
        LEDGER_INCOMPLETE:
          "Not every gasoline and diesel sale of this period is costed yet (a rebuild still running, or a grade without an opening balance), so no expected figure is compared.",
        NO_SALES: "No sales of this kind among the period's imported sales.",
        NO_DATA: "No sales were imported for this period yet, so nothing can be expected from your data.",
        NO_PRICE_CUT: "The distributor did not lower its delivery price in this month, so no price difference is expected.",
        NO_OLD_PRICE_DELIVERY:
          "The distributor lowered its delivery price this month, but no delivery was invoiced at the old price after the cut, so no price difference is expected.",
        NO_DELIVERY_INVOICES:
          "No distributor delivery invoice of this month is uploaded, so the price difference cannot be computed yet. Upload the incoming e-Fatura.",
        DATA_INCOMPLETE:
          "The imported sales do not cover this whole period (a shift is missing, the data starts inside it, or its last shift is not imported yet), so the figure is shown but not compared.",
        BEFORE_OPENING_BALANCE:
          "This period starts before the costing's opening balance: its gasoline or diesel sales before that shift are never costed, so no expected figure is compared. Move the opening balance to the shift of the period's first imported sale or earlier so every imported sale of the period is costed."
      },
      partialNoFigure:
        "The imported sales do not cover this whole period either: until they do, any figure for it is shown but not compared with the document."
    }
  },
  modal: {
    totalCash: "Total cash:",
    retry: {
      title: "Failed",
      question: "Operation failed, would you like to try again?",
      button: "Retry"
    }
  },
  availableForCheckoutShift: {
    shiftId: "Shift ID",
    shiftDate: "Date",
    shiftNo: "Shift No",
    employeeName: "Employee",
    cash: "Cash",
    note: "Note",
    totalCash: "Total Cash",
    show: "Show",
    hide: "Hide",
    save: "Lock",
    loading: "Loading...",
    modalCheckButton: "Lock Shift",
    modalCheckQuestion: "Do you want to lock the shift?",
    modalPostFailedButton: "Retry",
    modalPostFailedQuestion:
      "The server could not be reached and therefore the shift was not locked. Would you like to try again?",
  },
  shiftReview: {
    title: "Shift Review",
    analyzeSales: "Analyze sales",
    reviewSales: "Review sales",
    subtitle: "Review cash, bank-confirmed card totals, employee sales and current deficit before locking the shift.",
    loading: "Loading...",
    noShiftAvailable: "No shift review found.",
    saveFailed: "Shift could not be locked. Please review the latest values and try again.",
    fingerprintNote: "Locking uses a backend review fingerprint to prevent stale shift locking.",
    employeeDeficitPreview: "Employee deficit preview",
    employeeDeficitDetected: "Employee deficit detected",
    table: {
      employeeName: "Employee Name",
      totalSale: "Total Sale",
      deficit: "Deficit",
      cashAmount: "Cash Amount",
      creditCardAmount: "Credit Card Amount",
      shiftId: "Shift ID",
      totalEmployeeSale: "Total Employee Sale",
      currentDeficit: "Current Deficit",
      totalCash: "Total Cash",
      totalCreditCard: "Bank Confirmed Card",
      bankConfirmedCard: "Bank Confirmed Card"
    },
    buttons: {
      saveShift: "Lock Shift",
      enterCash: "Enter Cash",
      enterCreditCard: "Enter Credit Card",
      enterEmployeeCreditCard: "Enter Employee Credit Card",
      openReconciliation: "Reconciliation",
      openPaymentCorrection: "Payment Correction",
      saving: "Saving...",
      previousShift: "Previous Shift",
      nextShift: "Next Shift",
      openExactShiftReview: "Open Exact Shift Review"
    },
    navigation: {
      shiftLabel: "Shift",
      recordLabel: "Record",
      noPreviousShift: "This is the oldest shift still open for review.",
      noNextShift: "This is the newest shift still open for review."
    },
    status: {
      valid: "Valid",
      notValid: "Not valid",
      employeeDeficitDetected: "Deficit detected",
      noEmployeeDeficit: "No employee deficit",
      fingerprintReady: "Fingerprint ready",
      fingerprintMissing: "Fingerprint missing"
    },
    alerts: {
      lockSuccess: "Shift locked successfully.",
      lockFailed: "Failed to lock shift.",
      staleReview: "This shift review changed after it was loaded. Please review the updated values before locking again."
    },
    errors: {
      loadFailed: "Failed to load shift review.",
      serverUnavailable: "Server is unreachable. Please try again later."
    }
  },
  shiftCreditCard: {
    availableShiftsH1: "Shifts Available For Credit Card Entry",
    noShiftAvailable: "No shifts available.",
    loadShifts: "Load Shifts",
    loading: "Loading...",
    shiftId: "Shift ID",
    date: "Date",
    shiftNo: "Shift No",
    bankName: "Bank Name",
    batchNo: "Batch No",
    amount: "Amount",
    show: "Show",
    hide: "Hide",
    save: "Save",
    saving: "Saving...",
    addNewBank: "Add New Bank",
    buttons: {
      saveModal: {
        title: "Save Credit Card Details",
        question: "Would you like to save the credit card details?",
        save: "Save"
      },
      retryModal: {
        title: "Save Failed",
        question: "Save failed, would you like to try again?",
        retry: "Retry"
      },
      addBankModal: {
        title: "Add New Bank",
        question: "Choose the bank you want to add.",
        add: "Add"
      }
    },
    modal: {
      bank: {
        placeholder: "Select Bank",
        error: "Choose a valid bank."
      }
    }
  },
  general: {
    locale: 'en',
    pagination: {
      next: "Next",
      prev: "Prev"
    },
    modal: {
      retry: {
        title: "Retry",
        question: "Operation failed, would you like to try again?",
        button: "Retry"
      },
      cancel: "Cancel",
      totalCash: "Total Cash:"
    }
  },
  employeeCreditCard: {
    addRow: "Add Row",
    totalTransaction: "Total Transaction",
    alerts: {
      exceedAmount: "You cannot exceed the total credit card amount"
    },
    table: {
      shiftId: "Shift ID",
      shiftDate: "Shift Date",
      shiftNo: "Shift No",
      totalCreditCardAmount: "Total Credit Card Amount",
      totalEmployeeTransactions: "Total Employee Transactions",
      totalDifference: "Total Difference",
      bankName: "Bank Name",
      batchNo: "Batch No",
      amount: "Amount",
      employeeTransactions: "Employee Transactions",
      difference: "Difference"
    },
    buttons: {
      goToReview: "Go To Review",
      saveAll: "Save All",
      fetchAgain: "Fetch Again"
    },
    currentDeficit: "Current Deficit",
    warning: {
      title: "Warning!",
      message: "Transactions not saved successfully, if you want to try again please click \"Save All\" button."
    },
    fetchFailed: "Fetch failed!",
    loading: "Loading..."
  },
  companyUser: {
    title: "Company User Management",
    addNewUser: "Add New User",
    email: "Email",
    password: "Password",
    roles: "Roles",
    usersList: "User List",
    status: {
      title: "Status",
      active: "Active",
      inactive: "Inactive"
    },
    actions: "Actions",
    buttons: {
      save: "Save",
      edit: "Edit",
      delete: "Delete"
    },
    firstName: "First Name",
    lastName: "Last Name",
    mobilePhone: "Mobile Phone",
    editForm: {
      title: "Edit User",
      language: {
        title: "Preferred Language",
        en: "English",
        tr: "Turkish"
      },
      userStatus: "User Enabled",
      passwordPlaceholder: "Leave empty to keep current password"
    },
    alerts: {
      createSuccess: "User created successfully",
      updateSuccess: "User updated successfully"
    },
  },
  validation: {
    required: 'This field is required',
    invalidEmail: 'Please enter a valid email address',
    invalidPhone: 'Please enter a valid phone number (05XX XXX XX XX)',
    roleRequired: 'At least one role must be selected'
  },
  login: {
    title: "Welcome Back",
    subtitle: "Please sign in to continue",
    email: "Email",
    invalidEmail: "Please enter a valid email address",
    password: "Password",
    signIn: "Sign In",
    failed: "Login failed",
    success: "Login successful!",
    forgotPasswordLink: "Forgot your password?"
  },
  subscriptionExpired: {
    title: "Your subscription has expired",
    subtitle: "Renew your subscription to keep using Shift Tracker.",
    expiredOn: "Your access ended on",
    choosePlan: "Choose a plan to renew:",
    noPlans: "No renewal plans are available right now. Please contact support.",
    stillExpired: "We couldn't confirm an active subscription yet. If you just paid, please try again in a moment.",
    recheck: "I've renewed, re-check",
    checking: "Checking…",
    logout: "Log out"
  },
  subscription: {
    planPicker: {
      // Prices come from the backend (GET /subscription/plans) so they always match what İyzico charges.
      // Only labels live here; {pct}/{amount} are filled from the fetched pricing.
      monthly: { name: "Monthly", period: "/ month" },
      annual: { name: "Annual", period: "/ year" },
      discountBadge: "{pct}% OFF",
      save: "You save {amount}",
      taxNote: "VAT included",
      subscribe: "Subscribe",
      updateCard: "Use this plan",
      starting: "Redirecting…",
      error: "We couldn't start the payment. Please try again.",
      secureNote: "You'll be taken to İyzico's secure page to enter your card. We never see or store your card details."
    },
    manage: {
      title: "My Subscription",
      subtitle: "Manage your Shift Tracker plan and payment method.",
      loading: "Loading…",
      loadError: "We couldn't load your subscription. Please try again.",
      retry: "Try again",
      notSubscribed: "You don't have an active recurring subscription yet.",
      choosePlan: "Choose a plan to get started:",
      back: "Back to app",
      planLabel: "Plan",
      priceLabel: "Price",
      startedLabel: "Member since",
      dueDateLabel: "Access until",
      nextChargeLabel: "Next charge",
      cardLabel: "Payment method",
      statusActive: "Active",
      statusPastDue: "Payment failed",
      statusCanceled: "Canceled",
      planMonthly: "Monthly",
      planAnnual: "Annual",
      updateCard: "Update payment method",
      addCard: "Add payment method",
      noCardNote: "Automatic renewal isn't set up yet. Add a payment method to renew automatically before {date}.",
      updateCardHint: "Pick a plan to enter a new card. Your current plan and access are unchanged.",
      extendHeading: "Extend your subscription",
      extendOption: "+{n} {unit}",
      months: "month(s)",
      years: "year(s)",
      extendNote: "Pay now to add time to your subscription (12 months maximum). We never store your card.",
      extendMaxed: "You're at the 12-month maximum. You'll be able to extend again as your paid time is used up.",
      cancel: "Cancel subscription",
      canceling: "Canceling…",
      cancelConfirm: "Stop future automatic charges? You'll keep access until your current period ends.",
      canceledNote: "Auto-renewal is off. Your access continues until {date}.",
      pastDueNote: "Your last payment didn't go through. Update your payment method to keep your subscription active.",
      cardOnFile: "{brand} ending in {last4}",
      noCard: "No card on file",
      reassurance: "We never store your card number. İyzico securely vaults your card and gives us only a token used to charge your plan."
    },
    success: {
      finalizing: "Confirming your payment…",
      successTitle: "You're all set!",
      successBody: "Your subscription is active. Thanks for choosing Shift Tracker.",
      failTitle: "We couldn't confirm your payment",
      failBody: "If you were charged, please contact support; otherwise you can try again.",
      goToApp: "Go to dashboard",
      manage: "View my subscription",
      retry: "Try again"
    }
  },
  companyDeactivated: {
    title: "Your company has been deactivated",
    subtitle: "This account is no longer active, so sign-in is disabled.",
    supportPrompt: "To reactivate your company, please contact support at",
    backToLogin: "Back to sign in"
  },
  paymentBadges: {
    ariaLabel: "Accepted payment methods",
    securedBy: "Secure payment",
    iyzicoAlt: "Pay with iyzico"
  },
  footer: {
    tagline: "Bank-verified shift reconciliation for fuel stations.",
    legalHeading: "Legal",
    companyHeading: "Company",
    about: "About",
    contact: "Contact",
    pricing: "Pricing",
    kvkk: "KVKK Notice",
    privacy: "Privacy Policy",
    distanceSales: "Distance Sales Agreement",
    deliveryReturn: "Delivery & Return",
    rights: "All rights reserved."
  },
  forgotPassword: {
    title: "Reset your password",
    subtitle: "Enter your account e-mail and we'll send you a reset link.",
    emailLabel: "E-mail",
    submit: "Send reset link",
    sending: "Sending…",
    sent: "If an account exists for that e-mail, a password reset link has been sent. Please check your inbox; the link expires in 5 minutes.",
    failed: "Could not send the reset link. Please try again.",
    backToLogin: "Back to sign in"
  },
  resetPassword: {
    title: "Set a new password",
    invalidLink: "This reset link is invalid or has expired. Please request a new one.",
    requestNewLink: "Request a new link",
    newPasswordLabel: "New password",
    confirmPasswordLabel: "Confirm new password",
    submit: "Reset password",
    submitting: "Resetting…",
    success: "Your password has been reset. Redirecting to sign in…",
    passwordMismatch: "The passwords do not match.",
    passwordTooShort: "Your password must be at least 6 characters.",
    failed: "Could not reset your password. The link may have expired or already been used.",
    backToLogin: "Back to sign in"
  },
  desktopAuthorize: {
    title: "Connect a device",
    loading: "Loading authorization request…",
    loginPrompt: "Sign in to authorize this device",
    consentHeading: "Authorize this device?",
    consentLead: "The desktop app below is requesting access to your Shift Tracker account.",
    appLabel: "Application",
    scopeLabel: "Requested access",
    hostLabel: "Device address",
    hostHint: "This is a local address on your own computer.",
    expiresLabel: "Request expires",
    approve: "Connect",
    deny: "Cancel",
    approving: "Connecting…",
    denying: "Cancelling…",
    redirecting: "Returning to the app…",
    missingRequest: "This authorization link is missing or invalid. Open the desktop app and try \"Sign in with browser\" again.",
    loadError: "We couldn't load this authorization request. It may have expired; please start again from the desktop app.",
    decisionError: "Something went wrong. Please try again from the desktop app.",
    defaultAppName: "Desktop app"
  },
  home: {
    hero: {
      eyebrow: "Close a shift in under a minute",
      badges: [
        "Automatic Reconciliation",
        "Deficit Detection",
        "TURPAK & Asis Integration"
      ],
      title: "Your shifts, closed automatically. Your station, under your control.",
      subtitle:
        "Bring modern management to your station today. By the time you open a shift the reconciliation is ready; you just review the figures and lock it.",
      primaryCta: "Talk to us",
      secondaryCta: "See the solutions",
      howItWorks: "See how it works, step by step",
      trust: [
        {
          value: "Under 1 min",
          label: "to review and lock a shift, versus hours of manual reconciliation before"
        },
        {
          value: "Card + cash",
          label: "both sides matched against your bank activity, automatically"
        },
        {
          value: "Bank-confirmed",
          label: "each reconciled amount tied back to a real transaction on your statement"
        }
      ],
      visual: {
        windowTitle: "Live operations preview",
        leftTitle: "ERP sales",
        rightTitle: "Bank payments",
        correctionTitle: "Payment correction",
        correctionText:
          "Convert wrongly entered cash sales into card sales so they become visible in reconciliation.",
        auditTitle: "Audit-ready decisions",
        auditText:
          "Keep original payment type, effective payment type, reason, reviewer, and timestamp."
      }
    },
    shortcuts: {
      title: "Jump straight into the new tools",
      subtitle: "Open the workflows your team uses most.",
      reconciliation: {
        title: "Reconciliation Workspace V2",
        description:
          "Review ERP card sales and bank payments side by side.",
        button: "Open workspace"
      },
      correction: {
        title: "Payment Type Correction",
        description:
          "Fix cash sales that should be treated as card before reconciliation.",
        button: "Open correction"
      },
      report: {
        title: "Shift Report",
        description:
          "Check shift totals, employee activity, and supporting details.",
        button: "Open report"
      }
    },
    features: {
      title: "Built around the problems you actually face on shift",
      subtitle:
        "While you focus on perfecting your station's operations and overall running, Shift Tracker controls all cash flow automatically in the background and helps you prevent possible losses and leaks.",
      items: [
        {
          title: "Bank-verified cash deposits",
          description:
            "Every cash deposit is matched against your real bank statement and confirmed automatically the same day; short, duplicate or missing deposits are flagged. Every cash payment is confirmed against the amount that actually reached the bank, so every gap in the system is closed."
        },
        {
          title: "Side-by-side reconciliation",
          description:
            "Compare ERP card sales and bank payments in chronological order without losing context. Every payment is checked against the bank, and anything that does not match is surfaced instead of quietly passing, so a missing or unrecorded POS receipt cannot slip through."
        },
        {
          title: "Payment type correction",
          description:
            "Convert wrongly entered cash sales into credit card sales so they enter the right workflow."
        },
        {
          title: "Allocation-aware review",
          description:
            "Track bank-confirmed portions, descriptive cash portions, and unresolved amounts separately."
        },
        {
          title: "Cross-shift visibility",
          description:
            "See payments that belong to nearby shifts, clearly marked and safely separated."
        },
        {
          title: "Audit trail by design",
          description:
            "Store reason, reviewer, and correction timestamps so every operational change stays traceable."
        },
        {
          title: "Operational clarity",
          description:
            "Make shift review, deficit analysis, and card confirmation easier to understand for teams."
        },
        {
          title: "Live sales dashboard",
          description:
            "Track the open shift's sales as they happen: live KPIs, an hourly trend and fuel/payment breakdowns, with a shareable snapshot for your team."
        },
        {
          title: "Fuel tank monitoring",
          description:
            "See each tank's current volume as a live estimate, the last recorded level minus the sales dispensed since, with a fill percentage per fuel, so you always know what is left in the ground."
        },
        {
          title: "Fuel order suggestions",
          description:
            "Get a per-tank recommended order that covers demand until your next delivery, forecast from your own sales history, with a run-dry warning so you reorder at the right time."
        }
      ]
    },
    workflow: {
      title: "How a shift closes",
      subtitle:
        "Every amount at the station is tracked end to end and processed automatically. All that is left for you is to review the results and lock the shift.",
      steps: [
        {
          title: "Open the shift",
          description:
            "Sales are pulled in and most are already matched to bank-confirmed records automatically."
        },
        {
          title: "Review what's auto-matched",
          description:
            "The reconciliation workspace lines up ERP sales and bank payments with the matches already made."
        },
        {
          title: "Review employee deficits",
          description:
            "Any difference is attributed to the shift and the employee, with the reason clear at a glance."
        },
        {
          title: "Review and lock",
          description:
            "You lock the shift; the full record is saved and audit-ready. Manual correction is only needed for the rare exception."
        }
      ]
    },
    examples: {
      title: "Examples your team will recognize",
      subtitle:
        "The rare cases that still need a closer look, and how Shift Tracker handles them.",
      items: [
        {
          title: "Cash sale corrected to card",
          description:
            "A sale entered as cash is corrected, becomes visible in reconciliation, and can then be linked to bank activity.",
          outcome: "Correction → Reconciliation"
        },
        {
          title: "Partial card, remainder in cash",
          description:
            "Bank-confirmed card amount is tracked separately while the cash portion stays descriptive and auditable.",
          outcome: "Allocation-aware"
        },
        {
          title: "Cross-shift payment overlap",
          description:
            "Payments from nearby shifts stay visible but clearly marked so reviewers avoid using the wrong bank row.",
          outcome: "Safer review"
        }
      ]
    },
    fraudCallout: {
      eyebrow: "Fraud prevention",
      title: "There may already be fraud hiding in your station's books.",
      text:
        "Most theft slips through small audit and approval gaps: a receipt counted twice, a card sale logged as cash, a prepaid balance quietly adjusted. See the exact gaps and how Shift Tracker closes each one.",
      stat: "6 common fraud gaps closed",
      button: "See how we close fraud gaps"
    },
    solutions: {
      title: "Solutions",
      subtitle: "Built for fuel and gas station operators."
    },
    faq: {
      title: "Frequently asked questions",
      subtitle:
        "What gas and fuel station teams ask before adopting Shift Tracker.",
      items: [
        {
          question: "What is Shift Tracker?",
          answer:
            "Shift Tracker is cash flow and reconciliation software for fuel and gas stations. It matches ERP card sales with bank-confirmed payments, corrects misclassified payment types, and produces audit-ready records for every shift."
        },
        {
          question: "How does it help control cash flow at a gas station?",
          answer:
            "It compares ERP sales against bank-proven records shift by shift, separates bank-confirmed amounts from descriptive cash amounts, and surfaces unresolved differences so managers catch leakage early."
        },
        {
          question: "Does it verify that cash deposits actually reached the bank?",
          answer:
            "Yes. When cash is marked deposited, the app issues a unique reference to write at the bank; Shift Tracker then matches it against your real bank statement and confirms the deposit automatically, the same day, and flags any deposit that is short, duplicated, or missing.",
          linkText: "See automatic deposit verification",
          linkTo: "/en/deposit-verification/"
        },
        {
          question: "Does it work with TURPAK, Asis or other pump automation?",
          answer:
            "Yes. Shift Tracker pulls sales data from pump automation systems such as TURPAK and Asis and reconciles it against bank-confirmed payments. The automation measures the sale at the pump; Shift Tracker proves it reached the bank and keeps the audit trail.",
          linkText: "Read: TURPAK automation vs. bank reconciliation",
          linkTo: "/en/blog/turpak-automation-vs-bank-reconciliation/"
        },
        {
          question: "How much time does it save per shift?",
          answer:
            "Most shifts are matched automatically and are ready the moment you open them: you just review the employee deficits and lock the shift. A shift that used to take 1.5 to 2 hours on paper and in Excel now closes in under a minute, and manual correction is only the rare exception."
        },
        {
          question: "How do I know if there is fraud in my current process?",
          answer:
            "Most station fraud hides in routine gaps: a payment receipt reused, a card sale recorded as cash, or a prepaid balance adjusted without a real bank settlement. If corrections happen without a recorded reason and reviewer, those gaps stay invisible. Shift Tracker reconciles every shift against bank-proven records and keeps a full audit trail, so the gaps become visible and closeable.",
          linkText: "See the fraud gaps we close",
          linkTo: "/en/fraud-prevention/"
        },
        {
          question: "How does it detect employee cash deficits or discrepancies?",
          answer:
            "Each shift is reconciled against bank-confirmed payments and ERP totals. Differences are attributed to the shift and the employee with a full audit trail of reason, reviewer, and timestamp."
        },
        {
          question: "Does it integrate with TURPAK?",
          answer:
            "Yes. Shift Tracker syncs with TURPAK automation systems so pump and ERP sales data flow in for reconciliation and reporting."
        },
        {
          question: "What is payment type correction?",
          answer:
            "When a card sale is mistakenly entered as cash, you can correct the effective payment type so it enters the reconciliation workflow, while the original entry is preserved for auditing."
        },
        {
          question: "What is allocation-based reconciliation?",
          answer:
            "Card amounts confirmed by the bank are allocated and tracked separately from descriptive cash portions, so every amount is traceable to a bank-proven record or an explained cash entry."
        },
        {
          question: "Is it suitable for multiple stations?",
          answer:
            "Yes. It supports multi-station operations with role-based access for owners, managers, and shift staff. Because the system runs entirely in the cloud, you can reach all of your station's data from any device, anytime and anywhere, through a single panel, so your station is always under your control."
        },
        {
          question: "How much does Shift Tracker cost?",
          answer:
            "See our pricing page for current monthly and annual plans, or contact us to get started.",
          linkText: "See pricing plans",
          linkTo: "/en/pricing/"
        },
        {
          question: "How do we get started?",
          answer:
            "Contact us for a demo and we will walk you through reconciliation, payment correction, and reporting for your stations."
        }
      ]
    },
    cta: {
      title: "Ready to close shifts the effortless way?",
      subtitle:
        "See Shift Tracker run against your own station's numbers. We will show you a full shift reconciling itself: card sales, cash deposits, and deficits all settled against the bank, then hand you a clean set of figures to review and lock.",
      primary: "Contact us",
      secondary: "Read the guides"
    }
  },
  contact: {
    title: "Contact Us",
    subtitle: "Fill out the form and we'll show you how Shift Tracker can help",
    companyName: "Company Name",
    fullName: "Full Name",
    email: "Email",
    phone: "Phone",
    message: "Message (optional)",
    submit: "Submit",
    submitting: "Submitting...",
    successMessage: "Your message has been sent. We'll get back to you shortly.",
    errorMessage: "An error occurred. Please try again later.",
    responseNote: "We reply within one business day, usually much sooner.",
    kvkkNotice: "Your details are used only to respond to your request and are processed in line with our",
    kvkkLinkText: "privacy notice (KVKK)"
  },
  newsletter: {
    heading: "Stay ahead of shift fraud & reconciliation",
    subtitle: "Practical tips on fuel-station cash flow, TURPAK reconciliation, and preventing shift losses, straight to your inbox. No spam.",
    emailPlaceholder: "Your email address",
    submit: "Subscribe",
    submitting: "Subscribing...",
    successMessage: "Almost there! Check your inbox and click the confirmation link to complete your subscription.",
    errorMessage: "Subscription failed. Please try again later.",
    consent: "By subscribing you agree to receive occasional emails. You can unsubscribe at any time.",
    confirmed: {
      title: "Subscription confirmed 🎉",
      message: "Thanks for confirming, you're on the list. We'll only email you when we have something worth reading.",
      cta: "Back to the blog"
    },
    unsubscribed: {
      title: "You've been unsubscribed",
      message: "You won't receive any more newsletter emails. Changed your mind? You can subscribe again anytime from our blog.",
      cta: "Back to the blog"
    }
  },
  pricing: {
    hero: {
      badge: "Limited-time discount: save up to 38%",
      title: "Simple, transparent pricing",
      subtitle: "One plan, everything included: bank-verified shifts, TURPAK reconciliation and live station tracking, so your station's cash flow stays secured at all times. Lock in the discounted price, no surprises."
    },
    plans: {
      monthly: {
        name: "Monthly",
        listPrice: "₺20,000",
        price: "₺15,000",
        period: "/ month",
        discount: "25% OFF",
        save: "You save ₺5,000 / month",
        note: "A no-lock-in way to see the value on your own shifts."
      },
      annual: {
        name: "Annual",
        listPrice: "₺240,000",
        price: "₺150,000",
        period: "/ year",
        discount: "38% OFF",
        save: "You save ₺90,000 / year",
        note: "One payment, 12 months, the best value."
      }
    },
    listLabel: "List price",
    cta: "Request a free demo",
    featuresTitle: "Everything is included in every plan",
    features: [
      "TURPAK integration: sales flow in automatically",
      "Card sales matched against real bank payments",
      "Cash deposits verified against your bank statement",
      "Live sales dashboard for the open shift",
      "Fuel tank stock monitoring",
      "Smart fuel order suggestions",
      "Employee deficit tracking",
      "Audit-ready shift records",
      "Direct WhatsApp and phone support"
    ],
    notes: [
      "VAT included in all prices.",
      "Discounted pricing for a limited time."
    ],
    bottom: {
      title: "See it on your own station's numbers",
      subtitle: "In a 15-minute demo we walk through your shift flow and show how reconciliation works with your bank and TURPAK data.",
      button: "Request a demo"
    }
  },
  kvkk: {
    title: "Privacy Notice (KVKK)",
    updated: "Last updated: 2 July 2026",
    intro: "This notice explains, under Turkey's Personal Data Protection Law No. 6698 (KVKK), which personal data shifttracker.net collects, why, and your rights. It was prepared in good faith and may be updated; the current version is always on this page.",
    sections: [
      {
        heading: "Data controller",
        text: "The data controller is the operator of Shift Tracker (shifttracker.net). You can reach us through the contact form on this site, by phone or WhatsApp at +90 532 552 09 03."
      },
      {
        heading: "What we collect and why",
        text: "Contact/demo form: company name, full name, email, phone, your message, and the page/campaign your visit started from, used solely to respond to your request and prepare a relevant demo. Newsletter: your email address, stored only after you confirm via the double opt-in email, used solely to send the newsletter you requested. Live chat (Crisp) and WhatsApp: the messages and contact details you choose to share, used to answer you."
      },
      {
        heading: "Cookies and analytics",
        text: "We use Google Analytics 4 to understand which pages are visited and which actions (e.g. demo requests) occur, and Crisp for live chat. These set cookies and process data on their providers' infrastructure. We do not sell personal data or use it for third-party advertising."
      },
      {
        heading: "Retention and sharing",
        text: "We keep personal data only as long as needed for the purposes above or as required by law, and share it only with the service providers named here (hosting, analytics, chat, email delivery) as necessary to operate the site."
      },
      {
        heading: "Your rights (KVKK Article 11)",
        text: "You may ask whether your data is processed, request correction or deletion, object to processing, and request that we inform third parties of corrections/deletions. Unsubscribe links are included in every newsletter email. To exercise any right, contact us through the channels above; we respond within the statutory period."
      }
    ],
    backHome: "Back to home"
  },
  registration: {
    success: {
      message: "Registration successful! Redirecting to the login page...",
      countdown: "Redirecting in {seconds} seconds...",
      invalidLink: "Invalid registration link",
      loadError: "Failed to load registration details",
      failed: "Registration failed. Please try again."
    }
  },
  about: {
    hero: {
      title: "Built by fuel-station operators, for fuel-station operators",
      subtitle: "Shift Tracker turns the hours of manual shift reconciliation into a one-minute, bank-verified close. We built it for our own station, and we run it there every day."
    },
    story: {
      title: "Our story",
      paragraphs: [
        "Shift Tracker did not start in an office. It started at a Shell station, where the end of every shift meant adding up sales by hand, matching card payments one by one, chasing whether the cash actually reached the bank, and hoping nothing slipped through.",
        "We could not find software that treated a fuel station's cash flow with the rigour it needs, so we built our own. Today Shift Tracker runs that same station every single day, alongside the other stations that now rely on it."
      ]
    },
    principle: {
      title: "What we believe: control, not trust",
      text: "A station should not run on the hope that the numbers add up. Every amount should be provable against the bank, every correction should leave a record, and every shift should close with proof. That principle shapes every part of Shift Tracker."
    },
    offer: {
      title: "What Shift Tracker does",
      items: [
        { icon: "🔄", title: "Automatic reconciliation", text: "Card sales from your pump automation are matched to bank-confirmed payments on schedule, so a shift is already reconciled by the time you open it." },
        { icon: "🏦", title: "Cash deposit verification", text: "Every cash deposit is checked against your real bank statement and confirmed, or flagged when it is short, duplicated, or missing." },
        { icon: "🧾", title: "Employee deficit detection", text: "Differences are attributed to the shift and the employee with a clear reason, so shortfalls surface instead of disappearing." },
        { icon: "🛡️", title: "Fraud prevention by design", text: "The routine gaps that hide theft, a receipt reused or a card sale logged as cash, become visible and closeable." },
        { icon: "📊", title: "Operational insight", text: "Live sales, tank levels, and order suggestions give you a real-time view of the station beyond the shift." }
      ]
    },
    why: {
      title: "Why stations choose Shift Tracker",
      items: [
        { title: "Built by operators", text: "Every feature comes from a real problem we lived at our own station, not from a checklist." },
        { title: "Bank-verified and audit-ready", text: "Every amount traces back to a real bank transaction, with a full record of who changed what and why." },
        { title: "Works with your automation", text: "TURPAK, Asis and other pump automation feed straight in. Nothing changes at the pump." },
        { title: "One minute, not two hours", text: "The reconciliation that used to take an evening is done for you; you review the figures and lock the shift." }
      ]
    },
    cta: {
      title: "See it on your own station's numbers",
      subtitle: "Talk to us for a walkthrough, or read the guides to see exactly how a shift closes.",
      button: "Talk to us",
      secondary: "Read the guides"
    }
  },
  fraud: {
    hero: {
      title: "Fraud Detection & Prevention for Fuel Stations",
      subtitle:
        "Most theft happens where audit and approval are missing. Every payment is compared against the bank and confirmed, so no POS receipt can slip through or go missing, and Shift Tracker closes the gaps fraudsters rely on: duplicate receipts, payment-type tricks, and prepaid card manipulation."
    },
    intro: {
      title: "Where fraud actually happens",
      text:
        "At a busy fuel station, money goes missing not through dramatic break-ins but through small, repeatable gaps in the daily process: a receipt counted twice, a card sale logged as cash, a prepaid balance quietly adjusted. Without a tight audit and approval trail, these gaps stay invisible. Shift Tracker is designed to close them."
    },
    gaps: {
      title: "Common fraud gaps, and how Shift Tracker closes them",
      subtitle:
        "Each gap below maps to a control that makes the manipulation detectable or impossible.",
      items: [
        {
          icon: "🧾",
          title: "Duplicate payment receipts",
          problem:
            "The same bank receipt or POS receipt is used more than once to cover different shortfalls, so cash can be removed while the books still look balanced.",
          solution:
            "Every payment is compared against the bank and can be allocated only once. Reusing a POS receipt is flagged immediately, so no slip can go missing and a single proof can never justify two amounts."
        },
        {
          icon: "🔁",
          title: "Card sales disguised as cash, or cash as card",
          problem:
            "A card sale is recorded as cash (or the reverse) so the bank-confirmed total no longer matches what was reported, opening room to pocket the difference.",
          solution:
            "ERP/automation sales are matched against bank-proven records, so any mismatch between the reported payment type and what actually reached the bank is exposed. Payment type correction preserves the original entry, the corrected type, the reason, and the reviewer."
        },
        {
          icon: "💳",
          title: "Prepaid and fuel card manipulation",
          problem:
            "Prepaid balances and fuel-card transactions are adjusted or claimed as paid when no real settlement ever reached the bank.",
          solution:
            "Prepaid and card activity is reconciled against bank-confirmed settlement, so a balance that was never truly funded cannot pass as a completed payment."
        },
        {
          icon: "🛡️",
          title: "No audit or approval trail",
          problem:
            "When corrections can be made without a recorded reason, reviewer, and timestamp, there is nothing to trace and no one is accountable.",
          solution:
            "Every change is captured with its reason, the reviewer, and a timestamp. Nothing can be edited without leaving an auditable record."
        },
        {
          icon: "🔀",
          title: "Shifting payments between shifts",
          problem:
            "A payment is moved to a neighboring shift to hide a deficit in the shift where the money actually went missing.",
          solution:
            "Payments that belong to nearby shifts stay visible but are clearly marked, so a deficit cannot be quietly absorbed by the wrong shift."
        },
        {
          icon: "🔍",
          title: "Unresolved differences left in the dark",
          problem:
            "Small, unexplained gaps are ignored until they add up to real losses.",
          solution:
            "Unresolved amounts are surfaced and attributed to the responsible shift and employee, so differences are addressed while they are still small."
        }
      ]
    },
    benefits: {
      title: "What this gives you",
      items: [
        {
          title: "Provable, not guessed",
          description:
            "Every cash payment is confirmed against the amount that reached the bank, so every difference in the system is closed and each figure traces back to a bank-confirmed record."
        },
        {
          title: "Accountability by design",
          description:
            "Reason, reviewer, and timestamp on every correction."
        },
        {
          title: "Early detection",
          description:
            "Differences surface at shift close, not months later in an audit."
        }
      ]
    },
    cta: {
      title: "Close the gaps fraud relies on",
      subtitle:
        "See how Shift Tracker turns your daily reconciliation into a fraud-prevention control.",
      button: "Request a demo"
    }
  },
  admin: {
    shift: {
      title: "Shifts",
      filters: {
        completed: "Completed",
        locked: "Locked",
        depositVerified: "Deposit Verified",
        creditCardVerified: "Credit Card Verified",
        deficitDeducted: "Deficit Deducted",
        deposited: "Deposited",
        filterActive: "Filter Active",
        listAmount: "List Amount",
        search: "Search",
        exportExcel: "Export to Excel",
        exportError: "Could not export the shift list."
      },
      table: {
        shiftId: "Shift ID",
        completed: "Completed",
        depositVerified: "Deposit",
        deficitDeducted: "Deficit",
        deficit: "Deficit Amount",
        employeeSale: "Employee Sale",
        cash: "Cash",
        creditCard: "Credit Card",
        partnerCard: "Partner Card",
        giftCard: "Gift Card",
        mobile: "Mobile",
        distributorSales: "Distributor Sales",
        companySales: "Company Sales",
        test: "Test",
        totalSale: "Total Sale",
        bankConfirmedCard: "Bank Confirmed Card",
        locked: "Shift Locked",
        deposited: "Cash Deposited",
        creditCardVerified: "Credit Card Verified",
        delete: "Delete",
        reconciliation: "Reconciliation",
        paymentCorrection: "Payment Correction",
        open: "Open",
        shiftReview: "Shift Review"
      }
    },
    deposit: {
      title: "Deposits",
      ui: {
        pageSubtitle: "Review deposited cash, bank verification results and the shifts included in each deposit.",
        filtersTitle: "Search and filters",
        resultsTitle: "Deposit operations",
        resultsHint: "Open a deposit to review its shifts and employee cash details.",
        visibleDeposits: "Deposits in view",
        unverifiedDeposits: "Unverified in view",
        totalInView: "Total cash in view",
        showShifts: "Show included shifts",
        hideShifts: "Hide included shifts",
        showCashes: "Show employee cash",
        hideCashes: "Hide employee cash",
        shiftCount: "Included shifts",
        noShifts: "No shifts are included in this deposit.",
        noCashes: "No employee cash entries are recorded for this shift.",
        saving: "Saving…",
        saved: "Saved",
        unsaved: "Unsaved changes",
        saveFailed: "Could not save. Please try again.",
        emptyResults: "No deposits match these filters.",
        fetchFailed: "Deposits could not be loaded. Please try again.",
        manualVerification: "Manual verification",
        deleteDeposit: "Delete deposit",
        deleteQuestion: "Delete deposit",
      },
      verification: {
        title: "Deposit verification",
        overallStatus: "Current status",
        verified: "Verified",
        notVerified: "Not verified",
        automaticResult: "Last automatic result",
        noResult: "No automatic result recorded",
        reason: "Saved reason",
        noReason: "No reason recorded",
        reference: "Bank reference",
        expectedAmount: "Expected amount at deposit",
        lastChecked: "Result updated",
        matchedAt: "Matched at",
        warnedAt: "Warning recorded at",
        unknownDate: "Date unavailable",
        notAvailable: "Not available",
        reviewRequired: "Review the bank statement and resolve this deposit manually if needed.",
        processingFailed: "Automatic verification could not complete. Review the saved reason and resolve the processing problem before trying again.",
        historyNote: "The saved automatic result may precede a manual status change. The current verification status is shown above.",
        statuses: {
          PENDING: "Pending automatic verification",
          MATCHED: "Matched",
          MISMATCH: "Amount mismatch",
          AMBIGUOUS: "Multiple matches",
          NOT_FOUND: "Matching transaction not found",
          FAILED: "Processing failed",
          UNKNOWN: "Unknown automatic result",
        },
        reasons: {
          missingDetails: "The deposit has no bank reference or expected amount.",
          uniqueMatch: "A single incoming bank transaction matched both the reference and amount.",
          multipleMatches: "More than one incoming bank transaction matched the reference and amount.",
          amountMismatch: "An incoming bank transaction contained the reference, but its amount differed from the expected amount.",
          notFoundByDeadline: "No matching incoming bank transaction containing the reference was found in the checked date range. Review the bank statement to confirm the deposit.",
          notFoundInRange: "No matching incoming bank transaction containing the reference was found in the checked date range. Review the bank statement to confirm the deposit.",
          bankClosed: "No matching incoming bank transaction has been found yet after bank closing time.",
          noTransactionYet: "The automatic check has not found an incoming bank transaction containing the reference yet.",
        },
      },
      filters: {
        dateFilter: "Date Filter",
        amountFilter: "Amount Filter",
        shiftFilter: "Shift Filter",
        startDate: "Start Date",
        endDate: "End Date",
        depositVerified: "Deposit Verified",
        creditCardVerified: "Credit Card Verified",
        filterActive: "Filter Active",
        shiftLocked: "Shift Locked",
        shiftCompleted: "Shift Completed",
        deposited: "Deposited",
        minAmount: "Min Amount",
        maxAmount: "Max Amount",
        firstShift: "First Shift",
        lastShift: "Last Shift",
        search: "Search",
        amountEqual: "Amount Equal to",
        active: "Active",
        amount: "Amount",
        amountGreaterThanOrEqual: "Amount Greater Than or Equal to",
        amountGreaterThan: "Amount Greater Than",
        amountLessThan: "Amount Less Than",
        amountLessThanOrEqual: "Amount Less Than or Equal to",
        startDateFilter: "Start Date Filter",
        searchByIdFilter: "Search By ID",
        enterShiftId: "Enter Shift ID",
        deleteMode: "Delete Mode",
        sortBy: "Normal Sort",
        sortByDesc: "Reverse Sort",
        listAmount: "List Amount",
      },
      table: {
        depositId: "Deposit ID",
        date: "Date",
        amount: "Amount",
        deposited: "Deposited",
        verified: "Verified",
        deleteShift: "Delete Shift",
        showShift: "Show Shift",
        depositVerified: "Deposit Verified",
        totalAmount: "Total Amount",
        eligibleForVerify: "Eligible for Verify",
        delete: "Delete",
        showCash: "Show Cash",
        shiftId: "Shift ID",
        locked: "Locked",
        completed: "Completed",
        yes: "Yes",
        no: "No",
        employeeName: "Employee Name",
        note: "Note",
        update: "Update"
      }
    },
    creditCard: {
      title: "Credit Card Transactions",
      noResults: "No credit card transactions found.",
      filters: {
        filterActive: "Filter Active",
        general: "General Filters",
        verified: "Verified",
        locked: "Locked",
        completed: "Completed",
        bankFilter: "Bank Filter",
        bankFilterActive: "Bank Filter Active",
        shiftFilter: "Shift Filter",
        firstShift: "First Shift",
        lastShift: "Last Shift",
        search: "Search",
        sortBy: "Normal Sort",
        sortByDesc: "Reverse Sort",
        listAmount: "List Amount",
        amountFilter: "Amount Filter",
        minAmount: "Min Amount",
        maxAmount: "Max Amount",
        batchIdFilter: "Batch ID Filter",
        batchId: "Batch ID",
        searchByIdFilter: "Search By ID",
        selectBank: "Select Bank"
      },
      table: {
        creditCardId: "Credit Card ID",
        shiftId: "Shift ID",
        bankName: "Bank",
        amount: "Amount",
        batchId: "Batch No",
        locked: "Locked",
        completed: "Completed",
        verified: "Verified",
        yes: "Yes",
        no: "No"
      }
    },
    shiftReport: {
      title: "Daily Shift Report",
      selectDate: "Select Date",
      loading: "Loading...",
      noReports: "No shift reports found for the selected date.",
      error: "An error occurred while loading reports",
      shift: "Shift",
      shiftId: "Shift ID",
      enterShiftId: "Enter Shift ID",
      enterShiftIds: "e.g. 2025031101, 2025031102",
      multipleShiftIds: "Enter multiple IDs separated by comma",
      search: "Search",
      totalSale: "Total Sale",
      noEmployeeData: "No employee data available",
      noBatchData: "No credit card batch data available",
      descriptions: "Notes",
      infoText: "Info",
      exportExcel: "Export to Excel",
      exportPDF: "Export to PDF",
      shareLink: "Share Link",
      linkCopied: "Link copied to clipboard!",
      clearDateFilter: "Clear date filter",
      grandTotal: "Grand Total",
      employees: {
        title: "Employees",
        name: "Personnel",
        totalSale: "Total Sale",
        cashAmount: "Cash Amount",
        creditCardAmount: "Credit Card Amount",
        difference: "Difference",
        note: "Note",
        totals: "Totals"
      },
      creditCardBatches: {
        title: "Credit Card Batches",
        bank: "Bank",
        batchNo: "Batch No",
        amount: "Amount",
        total: "Total"
      }
    },
    employeeDeficit: {
      title: "Employee Deficits",
      filter: {
        title: "Filter",
        startShift: "Start Shift",
        endShift: "End Shift",
        deductionStatus: "Deduction Status",
        allDeficits: "All Deficits",
        deducted: "Deducted",
        notDeducted: "Not Deducted",
        employeeName: "Employee Name",
        employeeNamePlaceholder: "Search by name",
        amount: "Amount",
        amountOperator: "Operator",
        operators: {
          gte: "At least",
          lte: "At most",
          gt: "More than",
          lt: "Less than"
        },
        amountPlaceholder: "Amount",
        onlyShortfalls: "Only shortfalls",
        onlySurpluses: "Only surpluses",
        export: "Export to Excel",
        applyFilter: "Filter",
        resetFilter: "Reset"
      },
      table: {
        id: "ID",
        shiftId: "Shift ID",
        rootShiftId: "Root Shift ID",
        date: "Date",
        shiftNo: "Shift No",
        employee: "Employee",
        amount: "Amount",
        status: "Status",
        note: "Note",
        actions: "Actions"
      },
      status: {
        deducted: "Deducted",
        notDeducted: "Not Deducted",
        shortfall: "Owes",
        surplus: "Over",
        balanced: "Balanced"
      },
      buttons: {
        goToShift: "Go To Shift",
        markAsDeducted: "Mark as Deducted",
        markAsNotDeducted: "Mark as Not Deducted",
        recalculate: "Recalculate shift"
      },
      confirmation: {
        title: "Confirm",
        markAsDeducted: "Are you sure you want to mark this deficit as deducted?",
        markAsNotDeducted: "Are you sure you want to mark this deficit as not deducted?",
        yes: "Yes",
        no: "No"
      },
      messages: {
        recalcSuccess: "Shift deficits recalculated.",
        deductSuccess: "Deduction status updated.",
        exportError: "Could not export the deficit list."
      },
      noDeficits: "No deficits match these filters.",
      loading: "Loading..."
    }
  },
  reconciliation: {
    queue: {
      breadcrumb: "Reconciliation / Admin Review",
      title: "Ambiguity Queue",
      status: "AMBIGUOUS",
      subtitle: "Review unresolved ERP card transactions and manually confirm the correct bank record.",
      summary: {
        currentPage: "Current Page",
        totalRecords: "Total Records",
        bankCode: "Bank Code",
        shiftFilter: "Shift Filter"
      },
      filters: {
        title: "Filters",
        hint: "Filter queue by bank and business shift number",
        businessShiftNo: "Business Shift No",
        search: "Search",
        clear: "Clear",
        perPage: "/ page"
      },
      table: {
        title: "Queue",
        hint: "Quickly scan unresolved transactions and open one for manual review",
        matchId: "Match ID",
        shift: "Shift",
        employee: "Employee",
        amount: "Amount",
        erpTime: "ERP Time",
        receipt: "Receipt",
        plate: "Plate",
        reason: "Reason",
        candidates: "Candidates",
        tx: "Tx",
        entity: "Entity",
        review: "Review"
      },
      loading: "Loading ambiguity queue...",
      empty: "No ambiguous rows found for the selected filters.",
      pagination: {
        page: "Page",
        of: "of",
        go: "Go",
        invalidPage: "Please enter a valid page number.",
        pageRange: "Page must be between 1 and {totalPages}."
      }
    },
    detail: {
      breadcrumb: "Reconciliation / Ambiguity Review",
      subtitle: "Review ERP transaction and confirm the correct bank candidate.",
      backToQueue: "Back to queue",
      recordNotFound: "Record not found",
      recordNotFoundDesc: "This ambiguity may already be resolved or no longer available.",
      loading: "Loading ambiguity detail...",
      sections: {
        erpTransaction: "ERP Transaction",
        erpHint: "Source transaction details",
        candidateBankTransactions: "Candidate Bank Transactions",
        candidateHint: "Select exactly one candidate to confirm",
        adminAction: "Admin Action",
        adminActionHint: "Confirm, reject, or move back to pending"
      },
      summary: {
        amount: "Amount",
        employee: "Employee",
        businessShiftNo: "Business Shift No",
        erpTime: "ERP Time"
      },
      fields: {
        reason: "Reason",
        shiftEntityId: "Shift Entity ID",
        shiftTransactionId: "Shift Transaction ID",
        receipt: "Receipt",
        plate: "Plate",
        paymentType: "Payment Type",
        bank: "Bank",
        terminal: "Terminal",
        authorization: "Authorization",
        merchant: "Merchant",
        importedFileId: "Imported File ID",
        transactionId: "Transaction ID"
      },
      note: {
        label: "Note",
        placeholder: "Optional admin note"
      },
      selection: {
        selectedCandidate: "Selected candidate ID",
        noCandidate: "No candidate selected"
      },
      actions: {
        confirm: "Confirm Selected Candidate",
        reject: "Reject ERP Transaction",
        keepPending: "Keep Pending",
        processing: "Processing...",
        continue: "Continue",
        cancel: "Cancel"
      },
      modal: {
        title: "Confirm action",
        confirm: "Confirm the selected bank candidate?",
        reject: "Reject this ERP card transaction?",
        pending: "Move this record to pending?"
      },
      emptyCandidates: "No bank candidates found for this record.",
      alerts: {
        loadFailed: "Failed to load ambiguity detail.",
        selectCandidate: "Please select one bank candidate.",
        confirmSuccess: "Candidate confirmed successfully.",
        confirmFailed: "Confirm action failed.",
        rejectSuccess: "ERP transaction rejected successfully.",
        rejectFailed: "Reject action failed.",
        pendingSuccess: "Item moved to pending.",
        pendingFailed: "Keep pending action failed."
      }
    }
  },
  matchingStatus: {
    readyTitle: "Bank matching is up to date",
    readyBody:
      "All bank files for this day are loaded, so nothing is blocking automatic matching.",
    waitingTitle: "Waiting for bank files",
    waitingBody:
      "Automatic matching starts only after every bank has sent its daily file, so a card sale is never matched to the wrong bank record. Card sales stay in pending until then; nothing is lost and there is nothing for you to do. Still waiting for:",
    delayedTitle: "Bank files are late",
    delayedBody:
      "This file normally arrives earlier than this. Matching will start on its own as soon as it lands, and nothing is lost. Still waiting for:",
    attentionTitle: "Bank file still missing, please follow up",
    attentionBody:
      "The daily file has not reached us, and matching cannot start safely without it. Please contact your bank or your Shift Tracker representative about:",
    noBanksTitle: "No bank is linked yet",
    noBanksBody:
      "Automatic matching needs at least one active bank. Please contact your Shift Tracker representative.",
    bankSynced: "loaded",
    bankLoading: "loading",
    bankNotImported: "not arrived",
    bankNotSupported: "not set up",
    expectedBy: "All files are normally in by"
  },
  reconciliationV2: {
    common: {
      show: "Show",
      hide: "Hide",
      backToQueue: "Back to queue",
      breadcrumb: "Reconciliation / Workspace V2",
      title: "Reconciliation Workspace V2",
      subtitle:
        "Review ERP card sales and bank payment rows side by side and perform manual allocation actions.",
      loading: "Loading workspace...",
      refresh: "Refresh",
      clear: "Clear",
      search: "Search",
      cancel: "Cancel",
      continue: "Continue",
      processing: "Processing...",
      note: "Note",
      optionalNote: "Optional admin note",
      notFound: "No data found",
      noSelection: "Nothing selected"
    },
    filters: {
      title: "Workspace Controls",
      shiftId: "Shift ID",
      shiftIdPlaceholder: "e.g. 2026041401",
      lookbackHours: "Lookback Hours",
      lookaheadHours: "Lookahead Hours",
      bankCode: "Bank Code",
      showOnlyUnmatchedErp: "Show only unmatched ERP rows",
      showOnlyFreeBankRows: "Show only free bank rows",
      terminal: "Terminal",
      amount: "Amount"
    },
    workspace: {
      shiftInfo: {
        title: "Workspace Summary",
        shiftId: "Shift ID",
        shiftEntityId: "Shift Entity ID",
        shiftStart: "Shift Start",
        shiftEnd: "Shift End",
        lookbackHours: "Lookback",
        lookaheadHours: "Lookahead"
      },
      erpPanel: {
        title: "ERP Credit Card Sales",
        hint: "ERP card sales for the selected shift",
        empty: "No ERP rows found for this workspace."
      },
      bankPanel: {
        title: "Bank Payments",
        hint: "Bank transactions in the expanded review window",
        empty: "No bank rows found for this workspace."
      }
    },
    erpTable: {
      shiftTransactionId: "Shift Transaction ID",
      matchId: "Match ID",
      shiftId: "Shift ID",
      employeeName: "Employee Name",
      pumpNo: "Pump No",
      plate: "Plate",
      receiptNo: "Receipt No",
      amount: "Amount",
      transactionTime: "ERP Transaction Time",
      matchStatus: "Match Status",
      matchedBankCode: "Matched Bank Code",
      matchedTerminalNo: "Matched Terminal No",
      matchedBankTime: "Matched Bank Time",
      matchType: "Type",
      allocatedBankTotal: "Allocated Bank",
      allocatedCashTotal: "Allocated Cash",
      cashPortion: "Cash Portion",
      remainingAmount: "Remaining"
    },
    bankTable: {
      bankTransactionId: "Bank Transaction ID",
      bankCode: "Bank Code",
      terminalNo: "Terminal No",
      merchantNo: "Merchant No",
      merchantName: "Merchant Name",
      authorizationCode: "Authorization Code",
      amount: "Amount",
      transactionTime: "Bank Transaction Time",
      state: "State",
      matchedInfo: "Matched Info",
      matchedShiftId: "Matched Shift"
    },
    suggestions: {
      title: "Suggested Candidates",
      none: "No suggestions for this ERP row.",
      diffMinutes: "Time diff (min)",
      exactAmount: "Exact amount",
      allowedTerminal: "Allowed terminal",
      alreadyMatched: "Already matched elsewhere"
    },
    actions: {
      title: "Actions",
      addBankAllocation: "Add Bank Allocation",
      addCashAllocation: "Add Cash Allocation",
      deleteAllocation: "Delete Allocation",
      clearSelectedBankRow: "Clear Selected Bank Row",
      allocationAmount: "Allocation Amount",
      allocationAmountPlaceholder: "Enter amount"
    },
    badges: {
      auto: "AUTO",
      manual: "MANUAL",
      matched: "MATCHED",
      pending: "PENDING",
      ambiguous: "AMBIGUOUS",
      rejected: "REJECTED",
      locked: "LOCKED",
      selectable: "SELECTABLE",
      used: "USED",
      partiallyAllocated: "PARTIALLY ALLOCATED",
      matchedCurrentShift: "CURRENT SHIFT",
      matchedOtherShift: "OTHER SHIFT",
      fraudRisk: "FRAUD RISK",
      suggested: "SUGGESTED",
      linked: "LINKED"
    },
    details: {
      allocations: "Allocations",
      noAllocations: "No allocations",
      allocationType: "Type",
      allocationTypeBank: "Bank",
      allocationTypeCash: "Cash",
      allocationAmount: "Amount",
      allocationBank: "Bank",
      allocationTerminal: "Terminal",
      allocationBankTime: "Bank Time",
      allocationAuthorization: "Authorization",
      allocationNote: "Note",
      cashAllocationHint:
        "Cash allocation is descriptive only. It does not affect matched bank totals or shift cash totals."
    },
    indicators: {
      alreadyMatchedElsewhere: "Already matched elsewhere",
      selectable: "Selectable",
      locked: "Locked"
    },
    confirmations: {
      title: "Confirm action",
      addBankAllocation: "Do you want to create this bank allocation?",
      addCashAllocation: "Do you want to create this cash allocation?"
    },
    alerts: {
      workspaceLoadFailed: "Failed to load reconciliation workspace.",
      selectErpRow: "Please select an ERP row.",
      selectBankRow: "Please select a bank row.",
      bankRowLocked: "This bank row is not selectable because it is already used by another match.",
      invalidAllocationAmount: "Please enter a valid allocation amount.",
      bankAllocationSuccess: "Bank allocation created successfully.",
      bankAllocationFailed: "Bank allocation failed.",
      cashAllocationSuccess: "Cash allocation created successfully.",
      cashAllocationFailed: "Cash allocation failed.",
      allocationDeletedSuccess: "Allocation deleted successfully.",
      allocationDeletedFailed: "Allocation delete failed."
    }
  },
  paymentTypeCorrection: {
    breadcrumb: "Payment Type Correction",
    title: "Payment Type Correction",
    subtitle:
      "Use this page when a sale was entered as cash in ERP/Turpak but was actually paid by credit card. After correction, the sale will become available in the reconciliation workspace.",
    description:
      "This page is used to correct sales that were entered as cash in ERP/Turpak but were actually paid by credit card. It does not create bank matching and does not adjust shift cash or deposit records.",
    loading: "Loading sales...",
    yes: "Yes",
    no: "No",
    filters: {
      shiftIdPlaceholder: "Enter shift ID, e.g. 2026041401",
      search: "Search"
    },
    sections: {
      cashSales: "Cash Sales",
      correctedSales: "Corrected Sales"
    },
    table: {
      shiftTransactionId: "Shift Transaction ID",
      receiptNo: "Receipt No",
      dateTime: "Date / Time",
      plate: "Plate",
      pumpNo: "Pump No",
      total: "Total",
      originalPaymentType: "Original Payment Type",
      effectivePaymentType: "Effective Payment Type",
      corrected: "Corrected?",
      action: "Action",
      reason: "Correction Reason",
      correctedBy: "Corrected By",
      correctedAt: "Corrected At"
    },
    paymentTypes: {
      cash: "Cash",
      card: "Credit Card"
    },
    actions: {
      convertToCard: "Convert to Credit Card",
      openReconciliation: "Open Reconciliation",
      cancel: "Cancel",
      confirm: "Confirm",
      processing: "Processing..."
    },
    modal: {
      title: "Convert to Credit Card",
      reason: "Reason",
      reasonPlaceholder: "Enter correction reason",
      warning:
        "This action changes the effective payment type of the sale from cash to credit card. It does not automatically create bank matching and does not adjust shift cash deposit records."
    },
    empty: {
      cashSales: "No cash sales found for this shift.",
      correctedSales: "No corrected sales found for this shift."
    },
    alerts: {
      shiftIdRequired: "Please enter a shift id.",
      loadFailed: "Failed to load sales.",
      reasonRequired: "Please enter a correction reason.",
      convertSuccess: "Sale converted to credit card successfully.",
      convertFailed: "Failed to convert sale to credit card."
    }
  }
}

export type LanguageData = typeof eng;

export const tr: LanguageData = {
  shiftCashPost: {
    shiftsAvailableForCheckoutH1: "Nakitleri Alınabilecek Vardiyalar",
    shiftsAvailableForDepositH1: "Bankaya Yatırılabilecek Vardiyalar",
    totalCashNotice: "Bankaya yatırılacak toplam nakit tutar: ",
    noShiftAvailable: "Vardiya bulunamadı.",
    paginationNext: "İleri",
    paginationPrev: "Geri",
    depositToBankButton: "Nakitleri Bankaya Götür",
    loadShifts: "Vardiyaları Yükle",
    printDepositButton: "Nakit Raporu Yazdır",
    loading: "Yükleniyor...",

    ui: {
      pageSubtitle:
        "Tahsilat sorumlusu personel bazlı nakitleri girer, vardiyayı kilitler ve hazırlanan nakit grubunu bankaya yatırır.",
      checkoutShifts: "Nakit alınacak vardiyalar",
      checkoutDraftTotal: "Girilen taslak toplam",
      readyForDeposit: "Bankaya hazır",
      employees: "Personeller",
      firstShift: "İlk Vardiya",
      lastShift: "Son Vardiya",
      page: "Sayfa",
      checkoutHint: "Her personel için nakit tutarı ve not bilgisini girin.",
      depositHint: "Bankaya yatırmadan önce kaydedilmiş nakit girişlerini kontrol edin.",
      entered: "Girildi",
      empty: "Boş",
      emptyOrZero: "Boş / Sıfır",
      status: "Durum",
      employeeCashEntry: "Personel nakit girişi",
      optionalNote: "İsteğe bağlı not",
      depositFailedTitle: "Yatırma Başarısız"
    },

    alerts: {
      invalidNumber: "Lütfen geçerli bir sayı girin.",
      operationFailed: "İşlem başarısız oldu.",
      noDepositShifts: "Bankaya yatırılacak vardiya bulunmuyor."
    },

    checkModal: {
      title: "Nakit Yatırmayı Onayla",
      buttonText: "Bankaya Yatır",
      questionText:
        "Toplam nakdi bankaya yatırmak istediğinizden emin misiniz?",
    },

    failedModal: {
      title: "Bağlantı Hatası",
      buttonText: "Tekrar Dene",
      questionText:
        "Sunucuya erişilemediğinden vardiyalar alınamadı. Tekrar denemek ister misiniz?",
    },

    depositPostFailedModal: {
      title: "Yatırma Başarısız",
      buttonText: "Tekrar Dene",
      questionText:
        "Sunucuya erişilemediğinden bankaya yatırılacak nakit kaydedilemedi. Tekrar kaydetmeyi denemek ister misiniz?",
    },
  },
  navigation: {
    home: "Ana Menü",
    login: "Giriş Yap",
    logout: "Çıkış Yap",
    cash: "Nakit",
    creditCard: "Kredi Kartı",
    shiftReview: "Vardiyalar",
    companyUsers: "Şirket Kullanıcıları",
    contact: "İletişim",
    about: "Hakkımızda",
    solutions: "Çözümler",
    pricing: "Fiyatlandırma",
    blog: "Blog",
    fraud: "Dolandırıcılık Önleme",
    deposit: "Nakit Yatırma Doğrulama",
    cardVerify: "Kredi Kartı Doğrulama",
    shiftReport: "Vardiya Raporu",
    salesAnalytics: "Satış Analizi",
    liveSales: "Canlı Satış",
    tanks: "Tank Stoğu",
    mySubscription: "Aboneliğim",
    admin: {
      title: "Yönetici",
      shifts: "Vardiyalar",
      deposits: "Kasa İşlemleri",
      creditCards: "Kredi Kartı İşlemleri",
      employeeDeficit: "Personel Açıkları",
      companyUsers: "Şirket Kullanıcıları",
      reconciliationV2: "Mutabakat",
      paymentTypeCorrection: "Ödeme Tipi Düzeltme",
      fuelGrossProfit: "Akaryakıt Brüt Kar",
      saleEarnings: "Satış Kazançları",
      settlementCheck: "Mutabakat Kontrolü"
    }
  },
  salesAnalytics: {
    title: "Satış Analizi",
    subtitle:
      "İstasyonunuzun akaryakıt satışlarını analiz edin: özet göstergeler, trendler, kırılımlar ve filtrelenebilir satış tablosu.",
    filters: {
      title: "Filtreler",
      quickRange: "Hızlı aralık",
      presets: {
        THIS_MONTH: "Bu ay",
        LAST_MONTH: "Geçen ay",
        THIS_QUARTER: "Bu çeyrek",
        LAST_QUARTER: "Geçen çeyrek",
        THIS_YEAR: "Bu yıl",
        LAST_YEAR: "Geçen yıl"
      },
      saleType: "Satış tipi",
      paymentMethod: "Ödeme",
      employee: "Personel",
      allEmployees: "Tüm personel",
      apply: "Uygula",
      reset: "Sıfırla",
      advanced: "Daha fazla filtre",
      optional: "Tümü",
      invalidWindow: "Bitiş tarihi başlangıç tarihinden önce olamaz.",
      dateMode: { all: "Tüm tarihler", period: "Dönem", window: "Tarih aralığı" },
      period: "Dönem",
      periodValues: { DAY: "Gün", WEEK: "Hafta", MONTH: "Ay", YEAR: "Yıl" },
      referenceDate: "Referans tarihi",
      from: "Başlangıç",
      to: "Bitiş",
      shiftId: "Vardiya No",
      fuelType: "Yakıt tipi",
      paymentType: "Ödeme tipi",
      pumpNr: "Pompa no.",
      nozzleNr: "Tabanca no.",
      loyaltyCardType: "Sadakat kart tipi",
      plate: "Plaka",
      ecrPlate: "ECR plaka",
      fleetCode: "Filo kodu",
      minTotal: "Min. ciro",
      maxTotal: "Maks. ciro",
      minAmount: "Min. litre",
      maxAmount: "Maks. litre"
    },
    kpis: {
      transactions: "İşlem",
      revenue: "Ciro",
      volume: "Hacim",
      averageTicket: "Ortalama fiş",
      averageUnitPrice: "Ort. birim fiyat"
    },
    trend: {
      title: "Satış trendi",
      metric: "Metrik",
      revenue: "Ciro",
      volume: "Hacim",
      transactions: "İşlem",
      granularity: "Çözünürlük",
      granularityValues: {
        HOUR: "Saatlik",
        DAY: "Günlük",
        WEEK: "Haftalık",
        MONTH: "Aylık",
        YEAR: "Yıllık"
      },
      chartType: { line: "Çizgi", bar: "Çubuk" },
      empty: "Bu aralıkta satış yok."
    },
    breakdown: {
      title: "Kırılım",
      dimension: "Grupla",
      dimensionValues: {
        FUEL_TYPE: "Yakıt tipi",
        PAYMENT_TYPE: "Ödeme tipi",
        PUMP: "Pompa",
        NOZZLE: "Tabanca",
        LOYALTY_CARD_TYPE: "Sadakat kartı",
        FLEET: "Filo",
        EMPLOYEE: "Personel"
      },
      employeeNote: "Yalnızca perakende pompacı satışları (Vardiya İncelemesi ile uyumlu).",
      chartType: { pie: "Pasta", bar: "Çubuk" },
      empty: "Kırılacak satış yok.",
      unknown: "Belirtilmemiş",
      cols: {
        name: "Tür",
        transactions: "Satış",
        volume: "Hacim",
        revenue: "Ciro",
        share: "Pay"
      }
    },
    fuelTypes: {
      "5": "AdBlue",
      "6": "VP95/Kurşunsuz",
      "7": "VP Diesel",
      "8": "LPG"
    },
    table: {
      title: "İşlemler",
      rowsPerPage: "Satır",
      page: "Sayfa",
      of: "/",
      prev: "Önceki",
      next: "Sonraki",
      empty: "Filtreye uyan işlem yok.",
      totalRows: "işlem",
      corrected: "düzeltildi",
      columns: {
        dateTime: "Tarih / saat",
        shift: "Vardiya",
        fuelType: "Yakıt",
        plate: "Plaka",
        ecrPlate: "ECR plaka",
        pump: "Pompa",
        nozzle: "Tabanca",
        amount: "Litre",
        unitPrice: "Birim fiyat",
        total: "Ciro",
        paymentType: "Ödeme",
        receipt: "Fiş"
      },
      detail: {
        fullUnitPrice: "Liste birim fiyatı",
        rawPaymentType: "Ham ödeme tipi",
        fleetCode: "Filo kodu",
        fleetName: "Filo adı",
        loyaltyCardType: "Sadakat kart tipi",
        loyaltyCardNo: "Sadakat kart no.",
        redemption: "Sadakat indirimi",
        discountAmount: "İndirim",
        earnedPoints: "Kazanılan puan",
        earnedMoney: "Kazanılan tutar"
      }
    },
    common: {
      loading: "Yükleniyor...",
      error: "Satış verileri yüklenemedi.",
      retry: "Tekrar dene"
    },
    review: {
      title: "Satış İnceleme",
      subtitle:
        "Filtreye uyan her satışı inceleyin; tüm ayrıntılar için satırı genişletin.",
      reviewSales: "Satışları incele",
      backToDashboard: "← Panoya dön"
    },
    insights: {
      title: "Ne zaman satıyoruz?",
      profile: "Grupla",
      profileValues: {
        HOUR_OF_DAY: "Günün saati",
        DAY_OF_WEEK: "Haftanın günü",
        DAY_OF_MONTH: "Ayın günü",
        MONTH_OF_YEAR: "Yılın ayı"
      },
      metric: "Metrik",
      revenue: "Ciro",
      volume: "Hacim",
      transactions: "İşlem",
      peak: "Zirve",
      empty: "Bu aralıkta satış yok."
    },
    segments: {
      title: "Segmente göre satışlar",
      revenue: "Ciro",
      volume: "Hacim",
      transactions: "İşlem",
      empty: "Bu aralıkta satış yok.",
      note: "Segmentler çakışabilir (ör. bir sadakat satışı perakende olarak da sayılır), bu nedenle genel toplamı vermez. Bir çubuğa tıklayarak o segmente göre filtreleyin."
    },
    categories: {
      all: "Tümü",
      cash: "Nakit",
      credit: "Veresiye (şirket/dağıtıcı)",
      creditCard: "Kredi Kartı"
    },
    saleTypes: {
      all: "Tümü",
      EMPLOYEE: "Perakende",
      DISTRIBUTOR: "Bayi",
      COMPANY: "Firma",
      PARTNER_CARD: "Partner kart",
      GIFT_CARD: "Hediye kart",
      MOBILE: "Mobil",
      TEST: "Test"
    },
    live: {
      title: "Canlı Satış",
      subtitle:
        "Açık vardiyanın canlı görünümü: geçmiş satışları görmek için tarih veya vardiyaya göre filtreleyin.",
      provisional:
        "Açık vardiyanın geçici canlı önizlemesi, nihai ve mutabakatı yapılmış vardiya rakamları değildir.",
      todayCombinedNote:
        "Bugün şu ana kadar = bugünün içe aktarılmış (kapanmış) vardiyaları + canlı açık vardiya. Canlı kısım geçicidir.",
      openAnalytics: "Analizi aç",
      liveTag: "canlı",
      importedTag: "içe aktarılmış",
      imported: "İÇE AKTARILMIŞ",
      viewingImported:
        "Seçili kapsam için kesinleşmiş (içe aktarılmış) satışlar gösteriliyor.",
      live: "CANLI",
      paused: "DURAKLATILDI",
      pause: "Duraklat",
      resume: "Devam et",
      refresh: "Yenile",
      refreshing: "Yenileniyor…",
      refreshEvery: "Yenileme aralığı",
      shiftStatus: "Vardiya",
      count: "Satış",
      lastReceipt: "Son fiş",
      lastSale: "Son satış",
      updated: "Güncellendi",
      statusValues: { OPEN: "Açık", CLOSED: "Kapalı", UNKNOWN: "Bilinmiyor" },
      share: {
        button: "Görseli paylaş",
        title: "Canlı Vardiya Satışları",
        asOf: "şu ana kadar",
        generated: "Oluşturuldu",
        brand: "Shift Tracker",
        filename: "canli-satis",
        shareText: "Canlı vardiya satış özeti"
      },
      window: {
        label: "Zaman aralığı",
        values: {
          CURRENT_SHIFT: "Mevcut vardiya",
          TODAY: "Bugün",
          H1: "Son 1 saat",
          M30: "Son 30 dk",
          M15: "Son 15 dk",
          M5: "Son 5 dk"
        },
        truncated:
          "En son 200 satış gösteriliyor; seçili aralıkta daha fazlası olabilir."
      }
    }
  },
  tanks: {
    title: "Tank Stoğu",
    subtitle:
      "Canlı yakıt tankı seviyeleri ve vardiya bazlı geçmiş, görselleştirilir ve otomatik yenilenir.",
    live: "CANLI",
    paused: "DURAKLATILDI",
    refresh: "Yenile",
    refreshing: "Yenileniyor…",
    pause: "Duraklat",
    resume: "Devam et",
    refreshEvery: "Yenileme aralığı",
    asOf: "Hesaplanma",
    baselineShift: "Temel vardiya",
    indicativeLabel: "Değerler",
    indicative: "Canlı / tahmini",
    loading: "Yükleniyor…",
    error: "Tank verileri yüklenemedi.",
    noSnapshot: "Henüz tank anlık görüntüsü yok; değerler ilk vardiya içe aktarıldığında görünür.",
    dispensed: "Satılan",
    dispensedShift: "Bu vardiyada satılan",
    deliveredShift: "Bu vardiyada gelen",
    capacityUnknown: "Kapasite bilinmiyor",
    freeSpace: "Boş kapasite",
    unloadWarning: "Güvenli boşaltma payının altında",
    unloadDanger: "Tanker bölmesi boşaltmak güvenli değil",
    legend: {
      title: "Boşaltmak güvenli mi?",
      intro: "Bir yakıt teslimatı için mevcut boş kapasite:",
      ok: "Güvenli, pay ile",
      warning: "Sınırlı pay",
      danger: "Boşaltmayın",
    },
    compact: "Kompakt",
    detailed: "Detaylı",
    share: {
      button: "Paylaş",
      failed: "Görsel oluşturulamadı. Lütfen tekrar deneyin.",
      filename: "tank-stok",
      shareText: "Tank stoğu",
      title: "Tank Stoğu",
      asOf: "Hesaplanma",
      generated: "Oluşturuldu",
      brand: "Shift Tracker",
      available: "Mevcut",
      current: "Mevcut",
      free: "Boş kapasite",
      capacity: "Kapasite",
      fill: "Doluluk",
      more: "+{n} tank daha",
      note: "Canlı / tahmini: fiziksel ölçüm değil, tahmini defter değeri."
    },
    tank: "Tank",
    allTanks: "Tüm tanklar",
    trendTitle: "Tank trendi (vardiya bazlı)",
    metricValues: {
      consumption: "Tüketim",
      delivery: "Teslimat",
      stock: "Stok"
    },
    historyTitle: "Vardiya bazlı okumalar",
    historyEmpty: "Bu seçim için okuma yok.",
    historyCols: {
      shift: "Vardiya",
      recordedAt: "Kayıt",
      tank: "Tank",
      previous: "Başlangıç",
      dispensed: "Satılan",
      delivery: "Gelen",
      current: "Kapanış stoğu"
    },
    totalRows: "okuma",
    prev: "Önceki",
    next: "Sonraki",
    page: "Sayfa",
    of: "/",
    orders: {
      title: "Sipariş önerileri",
      advisory: "Tahmini / öneri",
      basis: "Son {weeks} haftaya göre",
      strategy: "Strateji",
      strategyValues: {
        MINIMIZE_INVENTORY: "Stoğu en aza indir",
        NEUTRAL: "Dengeli",
        MAXIMIZE_CAPACITY: "Kapasiteyi doldur"
      },
      strategyHelp: {
        MINIMIZE_INVENTORY: "en küçük güvenli sipariş: düşük stok (fiyat düşüşü beklentisi)",
        NEUTRAL: "sonraki teslimata kadar talebi karşılar, üstüne tampon ekler",
        MAXIMIZE_CAPACITY: "kapasitenin ~%{pct} oranına kadar doldurur (fiyat artışı beklentisi)"
      },
      strategyTooltip: {
        MINIMIZE_INVENTORY: "Fiyat düşüşü beklediğinizde kullanın",
        NEUTRAL: "Fiyatların sabit kalmasını beklediğinizde kullanın",
        MAXIMIZE_CAPACITY: "Fiyat artışı beklediğinizde kullanın"
      },
      strategyHint: "Hangisini ne zaman kullanmalı? ▸ Kapasiteyi doldur: fiyat artışı beklentisi · Dengeli: fiyat sabit · Stoğu en aza indir: fiyat düşüşü beklentisi",
      arrives: "Tanker varışı",
      nextDelivery: "Sonraki teslimat",
      target: "Hedef",
      clear: "Temizle",
      intraday: "Önümüzdeki ~{h} sa",
      coverTo: "Önümüzdeki ~{h} saati kapsar",
      order: "Sipariş",
      noOrder: "Sipariş gerekmiyor",
      capacityUnknownCta: "Tahmin için tank kapasitesini girin",
      urgent: "Acil",
      willRunDry: "bitebilir",
      now: "Şimdi",
      atArrival: "Varışta",
      intradayBaseline: "önümüzdeki ~{h} sa",
      empty: "Henüz sipariş önerisi yok.",
      loading: "Yükleniyor…"
    }
  },
  fuelCost: {
    title: "Akaryakıt Brüt Kar",
    subtitle:
      "Alım faturalarından hesaplanan satılan malın maliyeti ile Turpak satışları: vardiya, gün ve ay bazında brüt kar ve dağıtıcı mahsup faturaları.",
    loading: "Yükleniyor…",
    error: "Brüt kar raporu yüklenemedi.",
    actions: {
      exportExcel: "Excel'e aktar",
      exporting: "Aktarılıyor…",
      exportError: "Excel aktarımı başarısız oldu.",
      recompute: "Defteri yeniden hesapla",
      recomputing: "Hesaplanıyor…"
    },
    status: {
      upToDate: "Defter güncel",
      dirty: "Defter hesaplanıyor",
      lastRun: "Son hesaplama",
      lastCosted: "Son maliyetlenen vardiya",
      waiting: "Bekleyen alımlar",
      noOpening: "Açılış stoğu yok",
      notSold: "Satılmıyor",
      noOpeningNotice: "Açılış stoğu girilmeden maliyet hesaplanmaz:",
      error: "Hata"
    },
    filters: {
      from: "Başlangıç",
      to: "Bitiş",
      granularity: "Görünüm",
      day: "Gün",
      month: "Ay",
      shift: "Vardiya",
      fuel: "Yakıt",
      allFuels: "Tüm yakıtlar",
      apply: "Uygula",
      quickRange: "Hızlı aralık",
      invalidRange: "Geçerli bir tarih aralığı girin (başlangıç bitişten sonra olamaz).",
      presets: {
        thisMonth: "Bu ay",
        lastMonth: "Geçen ay",
        last3Months: "Son 3 ay",
        thisYear: "Bu yıl"
      }
    },
    kpis: {
      soldLiters: "Satılan litre",
      sales: "satış",
      netRevenue: "Net ciro (KDV hariç)",
      outputKdv: "Hesaplanan KDV",
      cogs: "Satılan malın maliyeti",
      stockVariance: "Dahil stok farkı",
      salesMinusCogs: "Satış eksi maliyet",
      perLiter: "litre başına",
      settlement: "Mahsup faturaları",
      revenueShare: "Gelir paylaşımı",
      loyaltyReimbursement: "Sadakat indirimi iadesi",
      priceDifference: "Fiyat farkı",
      grossProfit: "Brüt kar",
      provisional: "Geçici litre"
    },
    table: {
      title: "Dağılım",
      period: "Dönem",
      fuel: "Yakıt",
      soldLiters: "Litre",
      netRevenue: "Net ciro",
      cogs: "Maliyet",
      salesMinusCogs: "Satış eksi maliyet",
      marginPerLiter: "Marj / L",
      marginPercent: "Marj %",
      receipts: "Alınan L",
      variance: "Fark L",
      closing: "Kapanış L",
      avgCost: "Ort. maliyet",
      settlementRow: "Mahsup",
      grossProfit: "Brüt kar",
      flags: "İşaretler",
      total: "Toplam",
      empty: "Bu aralıkta maliyetlenmiş vardiya yok. Başlamak için açılış stoklarını girin ve alım faturalarını yükleyin."
    },
    flags: {
      PROVISIONAL: "Geçici maliyet",
      NEGATIVE_STOCK: "Negatif stok",
      NO_TANK_READING: "Tank verisi gelmedi",
      VARIANCE_OVER_TOLERANCE: "Fark tolerans üstünde",
      NO_SALES: "Satış yok",
      NO_COST_BASIS: "Maliyet dayanağı yok",
      KDV_RATE_MISSING: "KDV oranı eksik",
      PROVISIONAL_UNPRICED: "Fiyatlanmamış dolum",
      TANK_NOT_GAUGED: "Göstergesiz tank",
      REVENUE_SHARE_UNPRICED: "Pay tahmin edilemedi"
    },
    setup: {
      title: "Maliyet ayarları",
      missing: "eksik",
      show: "Göster",
      hide: "Gizle",
      openingHelp:
        "Her yakıt için bir açılış stoğu: ilk maliyetlenen vardiyanın başındaki stok ve KDV hariç alış maliyeti. Açılış stoğu değiştirilince defter o vardiyadan itibaren yeniden hesaplanır; daha sonraki bir vardiyaya taşınan açılış stoğu, kapanmış aylar dahil önceki bütün vardiyaların maliyetini kaldırır; daha önceki bir vardiyaya yeniden açılış stoğu girilene kadar geri gelmez.",
      fuel: "Yakıt",
      effectiveShift: "İlk maliyetlenen vardiya",
      liters: "Litre",
      unitCost: "Birim maliyet (KDV hariç)",
      save: "Kaydet",
      replace: "Değiştir",
      saving: "Kaydediliyor…",
      current: "Mevcut",
      failed: "Kaydedilemedi.",
      settings: "Ayarlar",
      settingsHelp:
        "Kapanış tarihi dışındaki bir ayardaki değişiklik kaydedilince defter yeniden hesaplanır. Alım miktarı esası veya LPG yoğunluğu değişirse daha önce yüklenmiş her faturanın litresi de yeniden hesaplanır. Yeni LPG yoğunluğu açılış bakiyelerini girildiği gibi bırakır: kilogramdan hesaplanan LPG açılışı yeniden girilmelidir (litre: kilogram ÷ yeni yoğunluk; birim maliyet: kilogram fiyatı × yeni yoğunluk).",
      receiptBasis: "Alım miktarı esası",
      basisAmbient: "Ortam litresi (irsaliye)",
      basisL15: "Faturadaki 15 °C litresi",
      lpgDensity: "LPG yoğunluğu (kg/L)",
      loyaltyReimbursed: "Sadakat indirimleri dağıtıcı tarafından iade edilir",
      tolerance: "Fire toleransı",
      gasoline: "benzin",
      diesel: "motorin",
      lpg: "LPG",
      closedThrough: "Kapanış tarihi",
      settlementParams: {
        title: "Mahsup parametreleri",
        help:
          "Dağıtıcının her satışta mahsup ettiği kalemler: satış kazançları ve beklenen mahsup tutarları bu değerlerle hesaplanır. Paylar ve oranlar yüzde olarak girilir.",
        revenueShareRetail: "Gelir paylaşımı, perakende (%)",
        revenueShareCompany: "Gelir paylaşımı, cari hesap (%)",
        revenueShareTts: "Gelir paylaşımı, TTS (%)",
        sharesHelp:
          "Gelir paylaşımı tahmini, satılan her litre benzin ve motorinde referans (rafineri) fiyatı ile KDV hariç pompa fiyatı arasındaki marjdan size düşen paydır; dağıtıcı bunu aylık prim faturasıyla öder.",
        ttsFleetDiscount: "TTS filo indirimi (%)",
        fleetDiscountHelp:
          "Dağıtıcının filo müşterilerine pompa fiyatı üzerinden tanıdığı indirim; TTS satışının marjı paylaşılmadan önce düşülür.",
        cardCommissionRate: "Kart komisyonu (%)",
        commissionHelp:
          "Dağıtıcının partner (3), mobil (6, 7) ve hediye (9) kartı satışlarında KDV dahil tutar üzerinden kestiği komisyon.",
        referenceGap: "Referans farkı (TL/L, KDV hariç)",
        referenceGapGasoline: "Benzin",
        referenceGapDiesel: "Motorin",
        gapHelp:
          "Bir tarih için referans fiyat girilmemişse referans, alış fiyatından bu farkın düşülmesiyle bulunur; bir yakıt boş bırakılırsa o satışlar tahmin dışı kalır.",
        invalidPercent: "0 ile 100 arasında bir yüzde girin.",
        invalidNumber: "Bir sayı girin veya alanı boş bırakın."
      },
      referencePrices: {
        title: "Referans fiyatlar",
        help:
          "Dağıtıcının duyurduğu, yakıt başına KDV hariç referans (rafineri) fiyatı ve geçerlilik başlangıcı. Aynı yakıt ve tarih için kaydedilen fiyat öncekinin yerine geçer.",
        fuel: "Yakıt",
        effectiveFrom: "Geçerlilik başlangıcı",
        price: "Fiyat, KDV hariç (TL/L)",
        source: "Kaynak",
        note: "Not",
        add: "Fiyatı kaydet",
        saving: "Kaydediliyor…",
        delete: "Sil",
        deleteConfirm:
          "Bu referans fiyat silinsin mi? Geçerlilik tarihinden itibaren yapılan satışlar bir önceki fiyata veya referans farkına döner.",
        empty: "Henüz referans fiyat girilmedi.",
        failed: "Referans fiyat kaydedilemedi.",
        deleteFailed: "Referans fiyat silinemedi.",
        sources: {
          MANUAL: "Elle",
          EMAIL: "E-posta"
        }
      }
    },
    upload: {
      title: "e-Fatura yükle",
      help:
        "e-Fatura XML dosyalarını veya bunların ZIP arşivini bırakın: dağıtıcının dolum ve hizmet faturaları ile sizin dağıtıcıya kestiğiniz faturalar. Yinelenenler atlanır, yakıt satırları alıma dönüşür ve defter yeniden hesaplanır.",
      dropHere: "XML veya ZIP dosyalarını buraya bırakın",
      choose: "Dosya seç",
      upload: "Yükle",
      uploading: "Yükleniyor…",
      unsupported: "Yalnızca .xml ve .zip dosyaları yüklenebilir.",
      failed: "Yükleme başarısız oldu.",
      result: "Sonuç",
      created: "kaydedildi",
      duplicates: "yinelenen",
      rejected: "reddedildi",
      receipts: "alım oluşturuldu",
      skipped: "kayıt atlandı",
      file: "Dosya",
      outcome: "Sonuç",
      invoice: "Fatura",
      reason: "Neden",
      outcomes: {
        CREATED: "Kaydedildi",
        DUPLICATE: "Yinelenen",
        REJECTED: "Reddedildi"
      }
    },
    invoices: {
      title: "Faturalar",
      direction: "Yön",
      all: "Tümü",
      INCOMING: "Gelen",
      OUTGOING: "Giden",
      date: "Tarih",
      number: "Numara",
      party: "Karşı taraf",
      netAmount: "Net tutar",
      payable: "Ödenecek",
      lines: "Satır",
      status: "Durum",
      xml: "XML",
      void: "İptal et",
      voidConfirm: "Bu fatura iptal edilsin mi? Alımları iptal edilir ve defter yeniden hesaplanır.",
      empty: "Henüz fatura yüklenmedi.",
      statuses: {
        PARSED: "Okundu",
        NEEDS_REVIEW: "İnceleme gerekli",
        BOOKED: "Kaydedildi",
        VOIDED: "İptal"
      }
    },
    receipts: {
      title: "Yakıt alımları",
      help:
        "Stoğa giren litreler ve maliyetleri: faturalardan, elle girilen kayıtlardan veya faturası henüz gelmemiş tank ölçümlü dolumlardan (geçici).",
      date: "Tarih",
      fuel: "Yakıt",
      liters: "Litre",
      unitCost: "Birim maliyet",
      cost: "Maliyet (KDV hariç)",
      source: "Kaynak",
      status: "Durum",
      shift: "Maliyet vardiyası",
      note: "Not",
      unplaced: "teslimat bekleniyor",
      inOpeningStock: "açılış stoğunda",
      empty: "Bu aralıkta alım yok.",
      manual: "Elle alım ekle",
      add: "Ekle",
      saving: "Kaydediliyor…",
      failed: "Alım eklenemedi.",
      void: "İptal et",
      voidConfirm: "Bu alım iptal edilsin mi? Defter teslim gününden bir gün öncesinden itibaren yeniden hesaplanır.",
      sources: {
        INVOICE: "Fatura",
        MANUAL: "Elle",
        PROVISIONAL_TANK: "Tank (geçici)"
      },
      statuses: {
        BOOKED: "Kaydedildi",
        PROVISIONAL: "Geçici",
        VOIDED: "İptal"
      }
    },
    earnings: {
      title: "Satış Kazançları",
      subtitle:
        "Satılan malın maliyeti ve dağıtıcı mahsubu düşüldükten sonra her bir akaryakıt satışının kazancı: en çok ve en az kazandıran kanalları, personeli, müşterileri ve ödeme tiplerini, zarar eden satışları görün.",
      formula:
        "Brüt kar = KDV hariç net ciro - satılan malın maliyeti + sadakat iadesi + gelir paylaşımı - kart komisyonu",
      formulaNote:
        "Bir satışın maliyeti, litrelerinin ortalama maliyetidir. Tank ölçümlerine göre stok farkı ve defter eksiye düşmüşken satılan litrelerin yeniden değerlemesi tek bir satışa değil vardiyaya aittir: brüt kar raporu bunları sayar, bu yüzden aynı tarihler ve ürün için, başka filtre olmadan, oradaki satılan malın maliyeti bu sayfanın toplamından tam olarak bu ikisi kadar farklıdır: stok kaybı ya da daha yüksek alış fiyatıyla yeniden değerleme artırır, ölçülen fazla ya da daha düşük alış fiyatıyla yeniden değerleme azaltır.",
      loading: "Yükleniyor…",
      error: "Satış kazançları yüklenemedi.",
      filters: {
        from: "Başlangıç",
        to: "Bitiş",
        fuel: "Yakıt",
        allFuels: "Tüm yakıtlar",
        channel: "Kanal",
        allChannels: "Tüm kanallar",
        paymentType: "Ödeme tipi",
        allPaymentTypes: "Tüm ödeme tipleri",
        cardType: "Kart tipi",
        allCardTypes: "Tüm kart tipleri",
        negativeOnly: "Sadece zarar eden satışlar",
        search: "Ara",
        searchPlaceholder: "Personel, plaka, filo, fiş no",
        shift: "Vardiya",
        apply: "Uygula",
        clear: "Filtreleri temizle",
        invalidRange: "Geçerli bir tarih aralığı girin (başlangıç bitişten sonra olamaz)."
      },
      channels: {
        RETAIL: "Perakende",
        TTS: "TTS (dağıtıcı filosu)",
        COMPANY: "Cari hesap"
      },
      cardTypes: {
        "0": "Kart yok",
        "3": "Partner kart",
        "9": "Hediye kartı",
        "6": "Mobil (6)",
        "7": "Mobil (7)"
      },
      kpis: {
        sales: "Satış",
        liters: "Litre",
        netRevenue: "Net ciro (KDV hariç)",
        grossRevenue: "KDV dahil",
        cogs: "Satılan malın maliyeti",
        salesMinusCogs: "Satış eksi maliyet",
        loyaltyReimbursement: "Sadakat iadesi",
        revenueShare: "Gelir paylaşımı",
        cardCommission: "Kart komisyonu",
        grossProfit: "Brüt kar",
        perLiter: "litre başına",
        margin: "marj",
        negativeRows: "Zarar eden satışlar",
        negativeSum: "toplam zarar"
      },
      breakdown: {
        title: "Dağılım",
        dimension: "Gruplama",
        hint: "Satışları o gruba göre filtrelemek için satıra tıklayın.",
        empty: "Filtrelere uyan satış yok.",
        emptyGroup: "(kayıt yok)",
        total: "Toplam",
        dimensions: {
          CHANNEL: "Kanal",
          FUEL: "Yakıt",
          ATTENDANT: "Personel",
          CUSTOMER: "Müşteri",
          PAYMENT_TYPE: "Ödeme tipi",
          CARD_TYPE: "Kart tipi",
          PUMP: "Pompa",
          DAY: "Gün",
          MONTH: "Ay",
          HOUR: "Günün saati",
          SHIFT: "Vardiya"
        },
        columns: {
          label: "Grup",
          sales: "Satış",
          negative: "Zarar eden",
          liters: "Litre",
          netRevenue: "Net ciro",
          cogs: "Maliyet",
          loyaltyReimbursement: "Sadakat iadesi",
          revenueShare: "Gelir payı",
          cardCommission: "Komisyon",
          grossProfit: "Brüt kar",
          perLiter: "Litre başına",
          marginPercent: "Marj %",
          shareOfTotal: "Toplam içinde %"
        }
      },
      table: {
        title: "Satışlar",
        empty: "Filtrelere uyan satış yok.",
        provisional: "Geçici",
        provisionalHint: "Faturası henüz gelmemiş geçici bir dolumun maliyetiyle hesaplandı.",
        unpriced: "Referanssız",
        unpricedHint: "Bu tarih için referans fiyat yok: gelir paylaşımı tahmin edilmedi.",
        columns: {
          saleAt: "Zaman",
          shift: "Vardiya",
          fuel: "Yakıt",
          channel: "Kanal",
          attendant: "Personel",
          plate: "Plaka",
          fleet: "Filo",
          pumpNozzle: "Pompa / tabanca",
          receipt: "Fiş no",
          paymentType: "Ödeme",
          cardType: "Kart",
          liters: "Litre",
          grossRevenue: "Ödenen, KDV dahil",
          loyaltyDiscount: "Sadakat indirimi",
          netRevenue: "Net ciro",
          costRate: "Maliyet / L",
          cogs: "Maliyet",
          loyaltyReimbursement: "Sadakat iadesi",
          revenueShare: "Gelir payı",
          cardCommission: "Komisyon",
          grossProfit: "Brüt kar",
          perLiter: "Litre başına",
          marginPercent: "Marj %",
          flags: "İşaretler"
        }
      },
      actions: {
        exportExcel: "Excel'e aktar",
        exporting: "Aktarılıyor…",
        exportError: "Excel aktarımı başarısız oldu."
      }
    },
    settlement: {
      title: "Mutabakat Kontrolü",
      subtitle:
        "Dağıtıcının mahsup belgelerini kendi verinizle doğrulayın: her 10 günlük, haftalık (AdBlue) ve aylık dönem için satışlarınızdan hesaplanan beklenen tutar, yüklenen e-Fatura ile yan yana.",
      loading: "Yükleniyor…",
      error: "Mutabakat kontrolü yüklenemedi.",
      empty: "Bu aralığa denk gelen mahsup dönemi yok.",
      emptyType: "Aralıkta bu türden dönem yok.",
      filters: {
        from: "Başlangıç",
        to: "Bitiş",
        apply: "Uygula",
        invalidRange: "Geçerli bir tarih aralığı girin (başlangıç bitişten sonra olamaz)."
      },
      summary: {
        title: "Duruma göre dönemler",
        generatedAt: "Hesaplama"
      },
      statuses: {
        MATCHED: "Uyumlu",
        DIFFERS: "Farklı",
        MISSING_ACTUAL: "Fatura eksik",
        NOT_DUE: "Vadesi gelmedi",
        UNESTIMATED: "Tahmin yok",
        NOT_COMPARED: "Karşılaştırılmadı",
        EXPECTED_CREDIT_UNBILLED: "Alacak bildirilmedi"
      },
      types: {
        TTS_SALE: {
          title: "TTS satış faturası",
          description: "Her 10 günde bir, pompa fiyatıyla satılan filo (TTS) litrelerini dağıtıcıya faturalarsınız."
        },
        PARTNER_SALE: {
          title: "Partner kart satış faturası",
          description: "Her 10 günde bir, partner kartla ödenen litreleri pompa fiyatıyla dağıtıcıya faturalarsınız."
        },
        ADBLUE_SALE: {
          title: "AdBlue satış faturası",
          description: "Haftalık pencereler (1-7, 8-14, 15-21, 22-28 ve 29-ay sonu günleri): her pencerede filoya satılan AdBlue'yu dağıtıcıya faturalarsınız."
        },
        LOYALTY_REIMBURSEMENT: {
          title: "Sadakat iadesi",
          description: "Aylık: pompada tanıdığınız sadakat indirimlerinin dağıtıcı tarafından KDV hariç geri ödenmesi."
        },
        REVENUE_SHARE: {
          title: "Gelir paylaşımı (prim)",
          description:
            "Aylık: referans fiyat ile pompa fiyatı arasındaki marjdan size düşen pay; fatura gelene kadar tahmindir."
        },
        PRICE_DIFFERENCE: {
          title: "Depo fiyat farkı",
          description:
            "Dağıtıcı teslimat fiyatını düşürdüğünde: indirim gününde ve sonrasında eski fiyattan faturalanan litreler çarpı indirim, size alacak olarak; zamlar hiç yansıtılmaz."
        }
      },
      directions: {
        OUTGOING: "Siz dağıtıcıya fatura kesersiniz",
        INCOMING: "Dağıtıcı size fatura keser"
      },
      columns: {
        period: "Dönem",
        dueDate: "Vade",
        expected: "Beklenen",
        actual: "Gerçekleşen",
        difference: "Fark",
        status: "Durum",
        liters: "litre",
        exclKdv: "KDV hariç",
        kdv: "KDV",
        inclKdv: "KDV dahil",
        invoice: "Fatura",
        issueDate: "düzenleme",
        noExpected: "Tahmin yok",
        partialData: "Kısmi: aktarılan satışlar dönemin tamamını kapsamıyor",
        noActual: "Fatura yok",
        details: "Ayrıntı",
        hideDetails: "Gizle"
      },
      lines: {
        title: "Beklenen tutarın ayrıntısı",
        label: "Kalem",
        rows: "Satır",
        liters: "Litre",
        unitPrice: "Birim fiyat",
        exclKdv: "KDV hariç",
        inclKdv: "KDV dahil",
        empty: "Ayrıntı satırı yok.",
        notCounted: "Bilgi için gösterilir, beklenen toplama dahil değildir.",
        priceCut: "fiyat indirimi"
      },
      comparison: {
        title: "Satır satır beklenen ve yüklenen",
        line: "Satır",
        expected: "Beklenen (KDV hariç)",
        uploaded: "Yüklenen (KDV hariç)",
        difference: "Fark",
        expectedLiters: "Beklenen litre",
        uploadedLiters: "Yüklenen litre",
        result: "Sonuç",
        matches: "Eşleşiyor",
        differs: "Farklı",
        groups: {
          FUELS: "Akaryakıt (AKARYAKIT)",
          LPG: "Otogaz (OTOGAZ)",
          GIFT: "Kullanılan puan (YAKIT HEDİYE)"
        }
      },
      notes: {
        ESTIMATE_REVENUE_SHARE:
          "Referans ve pompa fiyatlarından formülle hesaplanan tahmin: formül doğrulanana kadar yüzde on kadar sapabilir, yüzde beş içinde eşleşmiş sayılır.",
        ESTIMATE_PRICE_DIFFERENCE:
          "Fiyat indirimi çevresindeki teslimat faturalarından hesaplanır; dağıtıcının hangi teslimatları telafi ettiği yalnızca bir ay üzerinde doğrulandı.",
        NO_REFERENCE_PRICE:
          "Bu dönemi kapsayan referans fiyat yok, pay tahmin edilemedi. Maliyet ayarlarından bir referans fiyat girin.",
        LEDGER_INCOMPLETE:
          "Bu dönemin benzin ve motorin satışlarının hepsi henüz maliyetlenmedi (süren bir yeniden hesaplama ya da açılış bakiyesi girilmemiş bir ürün), bu yüzden beklenen tutar karşılaştırılmıyor.",
        NO_SALES: "Dönemin aktarılan satışları arasında bu türden satış yok.",
        NO_DATA: "Bu dönem için henüz satış aktarılmadı, verinizden beklenen tutar hesaplanamıyor.",
        NO_PRICE_CUT: "Dağıtıcı bu ay teslimat fiyatını düşürmedi, fiyat farkı beklenmiyor.",
        NO_OLD_PRICE_DELIVERY:
          "Dağıtıcı bu ay teslimat fiyatını düşürdü, ancak indirimden sonra eski fiyattan faturalanan teslimat olmadığı için fiyat farkı beklenmiyor.",
        NO_DELIVERY_INVOICES:
          "Bu ayın dağıtıcı teslimat faturaları yüklenmedi, fiyat farkı henüz hesaplanamıyor. Gelen e-Faturaları yükleyin.",
        DATA_INCOMPLETE:
          "Aktarılan satışlar bu dönemin tamamını kapsamıyor (bir vardiya eksik, veri dönemin içinde başlıyor ya da son vardiya henüz aktarılmadı), bu yüzden tutar gösterilir ama karşılaştırılmaz.",
        BEFORE_OPENING_BALANCE:
          "Bu dönem maliyetlendirmenin açılış bakiyesinden önce başlıyor: o vardiyadan önceki benzin veya motorin satışları hiç maliyetlenmez, bu yüzden beklenen tutar karşılaştırılmıyor. Dönemde aktarılan bütün satışların maliyetlenmesi için açılış bakiyesini dönemin ilk aktarılan satışının vardiyasına ya da daha öncesine taşıyın."
      },
      partialNoFigure:
        "Aktarılan satışlar da bu dönemin tamamını kapsamıyor: kapsayana kadar dönem için hesaplanan tutar gösterilir ama belgeyle karşılaştırılmaz."
    }
  },
  modal: {
    totalCash: "Toplam Nakit:",
    retry: {
      title: "Hata",
      question: "İşlem başarısız oldu, tekrar denemek ister misiniz?",
      button: "Tekrar Dene"
    }
  },
  availableForCheckoutShift: {
    shiftId: "Vardiya Kimlik No",
    shiftDate: "Tarih",
    shiftNo: "Vardiya No",
    employeeName: "Personel",
    cash: "Nakit",
    note: "Not",
    totalCash: "Toplam Nakit",
    show: "Göster",
    hide: "Gizle",
    save: "Kilitle",
    loading: "Yükleniyor...",
    modalCheckButton: "Vardiyayı Kilitle",
    modalCheckQuestion: "Vardiyayı kilitlemek istediğinizden emin misiniz?",
    modalPostFailedButton: "Tekrar Dene",
    modalPostFailedQuestion:
      "Sunucuya erişilemediğinden vardiya kilitlenemedi. Tekrar kilitlemeyi denemek ister misiniz?",
  },
  shiftReview: {
    title: "Vardiya İncelemesi",
    analyzeSales: "Satışları analiz et",
    reviewSales: "Satışları incele",
    subtitle: "Vardiyayı kilitlemeden önce nakit, banka onaylı kart toplamı, personel satışları ve mevcut açığı inceleyin.",
    loading: "Yükleniyor...",
    noShiftAvailable: "Vardiya incelemesi bulunamadı.",
    saveFailed: "Vardiya kilitlenemedi. Lütfen güncel değerleri kontrol edip tekrar deneyin.",
    fingerprintNote: "Kilit işlemi, eski verilerle vardiya kilitlemeyi önlemek için sunucu tarafındaki inceleme parmak izini kullanır.",
    employeeDeficitPreview: "Personel açık önizlemesi",
    employeeDeficitDetected: "Personel açığı tespit edildi",
    table: {
      employeeName: "Personel Adı",
      totalSale: "Toplam Satış",
      deficit: "Açık",
      cashAmount: "Nakit Tutarı",
      creditCardAmount: "Kredi Kartı Tutarı",
      shiftId: "Vardiya No",
      totalEmployeeSale: "Toplam Personel Satışı",
      currentDeficit: "Mevcut Açık",
      totalCash: "Toplam Nakit",
      totalCreditCard: "Banka Onaylı Kart",
      bankConfirmedCard: "Banka Onaylı Kart"
    },
    buttons: {
      saveShift: "Vardiyayı Kilitle",
      enterCash: "Nakit Gir",
      enterCreditCard: "Kredi Kartı Gir",
      enterEmployeeCreditCard: "Personel Kredi Kartı Gir",
      openReconciliation: "Mutabakatı Aç",
      openPaymentCorrection: "Ödeme Düzeltme",
      saving: "Kaydediliyor...",
      previousShift: "Önceki Vardiya",
      nextShift: "Sonraki Vardiya",
      openExactShiftReview: "Bu Vardiyayı Aç"
    },
    navigation: {
      shiftLabel: "Vardiya",
      recordLabel: "Kayıt",
      noPreviousShift: "İncelemeye açık en eski vardiya bu.",
      noNextShift: "İncelemeye açık en yeni vardiya bu."
    },
    status: {
      valid: "Geçerli",
      notValid: "Geçerli değil",
      employeeDeficitDetected: "Açık tespit edildi",
      noEmployeeDeficit: "Personel açığı yok",
      fingerprintReady: "Parmak izi hazır",
      fingerprintMissing: "Parmak izi eksik"
    },
    alerts: {
      lockSuccess: "Vardiya başarıyla kilitlendi.",
      lockFailed: "Vardiya kilitleme işlemi başarısız oldu.",
      staleReview: "Bu vardiya incelemesi yüklendikten sonra değişti. Lütfen güncel değerleri kontrol edip tekrar kilitleyin."
    },
    errors: {
      loadFailed: "Vardiya incelemesi yüklenemedi.",
      serverUnavailable: "Sunucuya ulaşılamıyor. Lütfen daha sonra tekrar deneyin."
    }
  },
  shiftCreditCard: {
    availableShiftsH1: "Kredi Kartı Girişi Yapılabilecek Vardiyalar",
    noShiftAvailable: "Vardiya bulunamadı.",
    loadShifts: "Vardiyaları Yükle",
    loading: "Yükleniyor...",
    shiftId: "Vardiya No",
    date: "Tarih",
    shiftNo: "Vardiya No",
    bankName: "Banka Adı",
    batchNo: "Batch No",
    amount: "Tutar",
    show: "Göster",
    hide: "Gizle",
    save: "Kaydet",
    saving: "Kaydediliyor...",
    addNewBank: "Yeni Banka Ekle",
    buttons: {
      saveModal: {
        title: "Kredi Kartı Detaylarını Kaydet",
        question: "Kredi kartı detaylarını kaydetmek istediğinizden emin misiniz?",
        save: "Kaydet"
      },
      retryModal: {
        title: "Kayıt Başarısız",
        question: "Kayıt başarısız oldu, tekrar denemek ister misiniz?",
        retry: "Tekrar Dene"
      },
      addBankModal: {
        title: "Yeni Banka Ekle",
        question: "Eklemek istediğiniz bankayı seçin.",
        add: "Ekle"
      }
    },
    modal: {
      bank: {
        placeholder: "Banka Seçiniz",
        error: "Geçerli bir banka seçiniz."
      }
    }
  },
  general: {
    locale: 'tr',
    pagination: {
      next: "İleri",
      prev: "Geri"
    },
    modal: {
      retry: {
        title: "Tekrar Dene",
        question: "İşlem başarısız oldu, tekrar denemek ister misiniz?",
        button: "Tekrar Dene"
      },
      cancel: "İptal",
      totalCash: "Toplam Nakit:"
    }
  },
  employeeCreditCard: {
    addRow: "Satır Ekle",
    totalTransaction: "Toplam İşlem",
    alerts: {
      exceedAmount: "Toplam kredi kartı tutarını aşamazsınız"
    },
    table: {
      shiftId: "Vardiya No",
      shiftDate: "Vardiya Tarihi",
      shiftNo: "Vardiya No",
      totalCreditCardAmount: "Toplam Kredi Kartı Tutarı",
      totalEmployeeTransactions: "Toplam Personel İşlemleri",
      totalDifference: "Toplam Fark",
      bankName: "Banka Adı",
      batchNo: "Batch No",
      amount: "Tutar",
      employeeTransactions: "Personel İşlemleri",
      difference: "Fark"
    },
    buttons: {
      goToReview: "İncelemeye Git",
      saveAll: "Hepsini Kaydet",
      fetchAgain: "Tekrar Getir"
    },
    currentDeficit: "Mevcut Açık",
    warning: {
      title: "Uyarı!",
      message: "İşlemler başarıyla kaydedilemedi, tekrar denemek için lütfen \"Hepsini Kaydet\" butonuna tıklayın."
    },
    fetchFailed: "Getirme başarısız!",
    loading: "Yükleniyor..."
  },
  companyUser: {
    title: "Şirket Kullanıcı Yönetimi",
    addNewUser: "Yeni Kullanıcı Ekle",
    email: "E-posta",
    password: "Şifre",
    roles: "Roller",
    usersList: "Kullanıcı Listesi",
    status: {
      title: "Durum",
      active: "Aktif",
      inactive: "Pasif"
    },
    actions: "İşlemler",
    buttons: {
      save: "Kaydet",
      edit: "Düzenle",
      delete: "Sil"
    },
    firstName: "Ad",
    lastName: "Soyad",
    mobilePhone: "Telefon",
    editForm: {
      title: "Kullanıcı Düzenle",
      language: {
        title: "Tercih Edilen Dil",
        en: "İngilizce",
        tr: "Türkçe"
      },
      userStatus: "Kullanıcı Aktif",
      passwordPlaceholder: "Mevcut şifreyi korumak için boş bırakın"
    },
    alerts: {
      createSuccess: "Kullanıcı başarıyla oluşturuldu",
      updateSuccess: "Kullanıcı başarıyla güncellendi"
    },
  },
  validation: {
    required: 'Bu alan zorunludur',
    invalidEmail: 'Geçerli bir e-posta adresi giriniz',
    invalidPhone: 'Geçerli bir telefon numarası giriniz (05XX XXX XX XX)',
    roleRequired: 'En az bir rol seçilmelidir'
  },
  login: {
    title: "Hoş Geldiniz",
    subtitle: "Devam etmek için giriş yapın",
    email: "E-posta",
    invalidEmail: "Geçerli bir e-posta adresi giriniz",
    password: "Şifre",
    signIn: "Giriş Yap",
    failed: "Giriş başarısız",
    success: "Giriş başarılı!",
    forgotPasswordLink: "Şifrenizi mi unuttunuz?"
  },
  subscriptionExpired: {
    title: "Aboneliğinizin süresi doldu",
    subtitle: "Shift Tracker'ı kullanmaya devam etmek için aboneliğinizi yenileyin.",
    expiredOn: "Erişiminiz şu tarihte sona erdi:",
    choosePlan: "Yenilemek için bir plan seçin:",
    noPlans: "Şu anda uygun bir yenileme planı yok. Lütfen destek ile iletişime geçin.",
    stillExpired: "Aktif bir abonelik henüz doğrulanamadı. Az önce ödeme yaptıysanız lütfen birazdan tekrar deneyin.",
    recheck: "Yeniledim, tekrar kontrol et",
    checking: "Kontrol ediliyor…",
    logout: "Çıkış yap"
  },
  subscription: {
    planPicker: {
      // Fiyatlar arka uçtan gelir (GET /subscription/plans), böylece her zaman İyzico'nun tahsil ettiği
      // tutarla eşleşir. Burada yalnızca etiketler vardır; {pct}/{amount} çekilen fiyattan doldurulur.
      monthly: { name: "Aylık", period: "/ ay" },
      annual: { name: "Yıllık", period: "/ yıl" },
      discountBadge: "%{pct} İNDİRİM",
      save: "{amount} tasarruf",
      taxNote: "KDV dahildir",
      subscribe: "Abone ol",
      updateCard: "Bu planı kullan",
      starting: "Yönlendiriliyor…",
      error: "Ödeme başlatılamadı. Lütfen tekrar deneyin.",
      secureNote: "Kart bilgilerinizi girmek için İyzico'nun güvenli sayfasına yönlendirileceksiniz. Kart bilgilerinizi asla görmez veya saklamayız."
    },
    manage: {
      title: "Aboneliğim",
      subtitle: "Shift Tracker planınızı ve ödeme yönteminizi yönetin.",
      loading: "Yükleniyor…",
      loadError: "Aboneliğiniz yüklenemedi. Lütfen tekrar deneyin.",
      retry: "Tekrar dene",
      notSubscribed: "Henüz aktif bir yinelenen aboneliğiniz yok.",
      choosePlan: "Başlamak için bir plan seçin:",
      back: "Uygulamaya dön",
      planLabel: "Plan",
      priceLabel: "Ücret",
      startedLabel: "Üyelik başlangıcı",
      dueDateLabel: "Erişim bitişi",
      nextChargeLabel: "Sonraki tahsilat",
      cardLabel: "Ödeme yöntemi",
      statusActive: "Aktif",
      statusPastDue: "Ödeme başarısız",
      statusCanceled: "İptal edildi",
      planMonthly: "Aylık",
      planAnnual: "Yıllık",
      updateCard: "Ödeme yöntemini güncelle",
      addCard: "Ödeme yöntemi ekle",
      noCardNote: "Otomatik yenileme henüz ayarlanmadı. {date} tarihinden önce otomatik yenilemek için bir ödeme yöntemi ekleyin.",
      updateCardHint: "Yeni bir kart girmek için bir plan seçin. Mevcut planınız ve erişiminiz değişmez.",
      extendHeading: "Aboneliğinizi uzatın",
      extendOption: "+{n} {unit}",
      months: "ay",
      years: "yıl",
      extendNote: "Aboneliğinize süre eklemek için şimdi ödeyin (en fazla 12 ay). Kart bilgilerinizi asla saklamayız.",
      extendMaxed: "12 aylık üst sınırdasınız. Ödediğiniz süre azaldıkça tekrar uzatabilirsiniz.",
      cancel: "Aboneliği iptal et",
      canceling: "İptal ediliyor…",
      cancelConfirm: "Gelecekteki otomatik tahsilatlar durdurulsun mu? Mevcut döneminiz bitene kadar erişiminiz sürer.",
      canceledNote: "Otomatik yenileme kapalı. Erişiminiz {date} tarihine kadar devam eder.",
      pastDueNote: "Son ödemeniz gerçekleştirilemedi. Aboneliğinizi aktif tutmak için ödeme yönteminizi güncelleyin.",
      cardOnFile: "{brand} •••• {last4}",
      noCard: "Kayıtlı kart yok",
      reassurance: "Kart numaranızı asla saklamayız. İyzico kartınızı güvenle saklar ve bize yalnızca planınızı tahsil etmek için kullanılan bir jeton verir."
    },
    success: {
      finalizing: "Ödemeniz onaylanıyor…",
      successTitle: "Her şey hazır!",
      successBody: "Aboneliğiniz aktif. Shift Tracker'ı tercih ettiğiniz için teşekkürler.",
      failTitle: "Ödemeniz onaylanamadı",
      failBody: "Ücret tahsil edildiyse lütfen destek ile iletişime geçin; aksi halde tekrar deneyebilirsiniz.",
      goToApp: "Panoya git",
      manage: "Aboneliğimi görüntüle",
      retry: "Tekrar dene"
    }
  },
  companyDeactivated: {
    title: "Şirketiniz devre dışı bırakıldı",
    subtitle: "Bu hesap artık etkin değil, bu nedenle giriş devre dışı bırakıldı.",
    supportPrompt: "Şirketinizi yeniden etkinleştirmek için lütfen şu adresten destek ile iletişime geçin:",
    backToLogin: "Girişe dön"
  },
  paymentBadges: {
    ariaLabel: "Kabul edilen ödeme yöntemleri",
    securedBy: "Güvenli ödeme",
    iyzicoAlt: "iyzico ile öde"
  },
  footer: {
    tagline: "Akaryakıt istasyonları için banka onaylı vardiya mutabakatı.",
    legalHeading: "Yasal",
    companyHeading: "Kurumsal",
    about: "Hakkımızda",
    contact: "İletişim",
    pricing: "Fiyatlandırma",
    kvkk: "KVKK Aydınlatma Metni",
    privacy: "Gizlilik Sözleşmesi",
    distanceSales: "Mesafeli Satış Sözleşmesi",
    deliveryReturn: "Teslimat ve İade",
    rights: "Tüm hakları saklıdır."
  },
  forgotPassword: {
    title: "Şifrenizi sıfırlayın",
    subtitle: "Hesabınızın e-posta adresini girin, size bir sıfırlama bağlantısı gönderelim.",
    emailLabel: "E-posta",
    submit: "Sıfırlama bağlantısı gönder",
    sending: "Gönderiliyor…",
    sent: "Bu e-postaya ait bir hesap varsa, şifre sıfırlama bağlantısı gönderildi. Lütfen gelen kutunuzu kontrol edin; bağlantı 5 dakika içinde geçerliliğini yitirir.",
    failed: "Sıfırlama bağlantısı gönderilemedi. Lütfen tekrar deneyin.",
    backToLogin: "Girişe dön"
  },
  resetPassword: {
    title: "Yeni şifre belirleyin",
    invalidLink: "Bu sıfırlama bağlantısı geçersiz veya süresi dolmuş. Lütfen yeni bir tane isteyin.",
    requestNewLink: "Yeni bağlantı iste",
    newPasswordLabel: "Yeni şifre",
    confirmPasswordLabel: "Yeni şifreyi onaylayın",
    submit: "Şifreyi sıfırla",
    submitting: "Sıfırlanıyor…",
    success: "Şifreniz sıfırlandı. Giriş sayfasına yönlendiriliyorsunuz…",
    passwordMismatch: "Şifreler eşleşmiyor.",
    passwordTooShort: "Şifreniz en az 6 karakter olmalıdır.",
    failed: "Şifreniz sıfırlanamadı. Bağlantının süresi dolmuş veya zaten kullanılmış olabilir.",
    backToLogin: "Girişe dön"
  },
  desktopAuthorize: {
    title: "Cihaz bağla",
    loading: "Yetkilendirme isteği yükleniyor…",
    loginPrompt: "Bu cihazı yetkilendirmek için giriş yapın",
    consentHeading: "Bu cihaz yetkilendirilsin mi?",
    consentLead: "Aşağıdaki masaüstü uygulaması Shift Tracker hesabınıza erişim istiyor.",
    appLabel: "Uygulama",
    scopeLabel: "İstenen erişim",
    hostLabel: "Cihaz adresi",
    hostHint: "Bu, kendi bilgisayarınızdaki yerel bir adrestir.",
    expiresLabel: "İstek geçerlilik süresi",
    approve: "Bağlan",
    deny: "Vazgeç",
    approving: "Bağlanıyor…",
    denying: "İptal ediliyor…",
    redirecting: "Uygulamaya dönülüyor…",
    missingRequest: "Bu yetkilendirme bağlantısı eksik veya geçersiz. Masaüstü uygulamasını açıp \"Tarayıcı ile giriş yap\" seçeneğini yeniden deneyin.",
    loadError: "Bu yetkilendirme isteği yüklenemedi. Süresi dolmuş olabilir; lütfen masaüstü uygulamasından yeniden başlayın.",
    decisionError: "Bir şeyler ters gitti. Lütfen masaüstü uygulamasından tekrar deneyin.",
    defaultAppName: "Masaüstü uygulaması"
  },
  home: {
    hero: {
      eyebrow: "Vardiya kapanışı bir dakikanın altında",
      badges: [
        "Otomatik Mutabakat",
        "Personel Açığı Tespiti",
        "TURPAK & Asis Entegrasyonu"
      ],
      title: "Vardiyalar otomatik alınır, kontrol sizde kalır.",
      subtitle:
        "İstasyonunuzu hemen modern bir yönetime kavuşturun. Vardiyayı açtığınızda mutabakat hazırdır; size yalnızca rakamları gözden geçirip vardiyayı kilitlemek kalır.",
      primaryCta: "Bizimle iletişime geçin",
      secondaryCta: "Çözümleri görün",
      howItWorks: "Adım adım nasıl çalıştığını görün",
      trust: [
        {
          value: "< 1 dk",
          label: "eskiden saatler süren işlem yerine, vardiyayı gözden geçirip kilitlemeniz yeterli"
        },
        {
          value: "Kart + nakit",
          label: "her iki taraf da banka hareketlerinizle otomatik eşleştirilir"
        },
        {
          value: "Banka onaylı",
          label: "mutabık kılınan her tutar, ekstrenizdeki gerçek bir işleme bağlıdır"
        }
      ],
      visual: {
        windowTitle: "Canlı operasyon önizlemesi",
        leftTitle: "Otomasyon satışları",
        rightTitle: "Banka ödemeleri",
        correctionTitle: "Ödeme düzeltme",
        correctionText:
          "Yanlışlıkla nakit girilmiş satışları kart satışına çevirin ve mutabakatta görünür hale getirin.",
        auditTitle: "Denetime hazır kararlar",
        auditText:
          "Orijinal ödeme tipi, efektif ödeme tipi, neden, kullanıcı ve zaman bilgilerini saklayın."
      }
    },
    shortcuts: {
      title: "Yeni araçlara doğrudan geçin",
      subtitle: "Ekibinizin en sık kullandığı akışları açın.",
      reconciliation: {
        title: "Mutabakat Çalışma Alanı",
        description:
          "Otomasyon kart satışlarını ve banka ödemelerini yan yana inceleyin.",
        button: "Çalışma alanını aç"
      },
      correction: {
        title: "Ödeme Tipi Düzeltme",
        description:
          "Mutabakata geçmeden önce kart olması gereken nakit satışları düzeltin.",
        button: "Düzeltme sayfasını aç"
      },
      report: {
        title: "Vardiya Raporu",
        description:
          "Vardiya toplamlarını, personel hareketlerini ve destekleyici detayları görüntüleyin.",
        button: "Raporu aç"
      }
    },
    features: {
      title: "Vardiyada gerçekten yaşadığınız sorunlar için tasarlandı",
      subtitle:
        "Siz istasyonunuzun operasyonlarını ve genel işleyişini mükemmelleştirmeye odaklanırken, Shift Tracker arka planda tüm nakit akışını otomatik olarak kontrol eder ve olası kayıp ve kaçakları önlemenize yardımcı olur.",
      items: [
        {
          title: "Banka onaylı nakit yatırmalar",
          description:
            "Her nakit yatırma, gerçek banka ekstrenizle eşleştirilip aynı gün otomatik doğrulanır; eksik, mükerrer veya kayıp yatırmalar işaretlenir. Bütün nakit ödemeler bankaya yatan tutar üzerinden teyit edilir ve sistemdeki bütün açıklar kapanmış olur."
        },
        {
          title: "Yan yana mutabakat",
          description:
            "Otomasyon kart satışlarını ve banka ödemelerini kronolojik sırayla, bağlamı kaybetmeden yan yana karşılaştırın. Bütün ödemeler banka ile karşılaştırılır ve eşleşmeyen her tutar öne çıkarılır; bu sayede POS slibi kaçması veya kaybolması derdi kalmaz."
        },
        {
          title: "Ödeme tipi düzeltme",
          description:
            "Yanlışlıkla nakit girilmiş satışları kredi kartı satışına çevirin ve doğru akışa alın."
        },
        {
          title: "Tahsis odaklı inceleme",
          description:
            "Banka onaylı kısım, açıklayıcı nakit kısmı ve çözümlenmemiş tutarı ayrı ayrı izleyin."
        },
        {
          title: "Vardiyalar arası görünürlük",
          description:
            "Yakın vardiyalara ait ödemeleri görün, açıkça işaretlenmiş ve güvenli şekilde ayrılmış olarak inceleyin."
        },
        {
          title: "Doğası gereği denetlenebilir",
          description:
            "Her operasyonel değişikliği neden, kullanıcı ve zaman bilgisiyle kayıt altında tutun."
        },
        {
          title: "Operasyonel netlik",
          description:
            "Vardiya incelemesini, açık analizini ve kart doğrulamasını ekipler için daha anlaşılır hale getirin."
        },
        {
          title: "Canlı Satış Takibi",
          description:
            "Açık vardiyanın satışlarını anlık izleyin: canlı KPI'lar, saatlik trend ve yakıt/ödeme kırılımları; ekibinizle paylaşılabilir görsel özet."
        },
        {
          title: "Tank stok takibi",
          description:
            "Her tankın güncel hacmini canlı bir tahmin olarak görün: son ölçülen seviyeden o andan itibaren satılan miktar düşülür, yakıt bazında doluluk yüzdesiyle birlikte; böylece depoda ne kaldığını her an bilirsiniz."
        },
        {
          title: "Akaryakıt sipariş önerisi",
          description:
            "Bir sonraki teslimata kadar olan talebi kendi satış geçmişinizden tahmin ederek her tank için önerilen sipariş miktarını, stok tükenme uyarısıyla birlikte alın; böylece doğru zamanda sipariş verirsiniz."
        }
      ]
    },
    workflow: {
      title: "Bir vardiya nasıl kapanır",
      subtitle:
        "İstasyondaki her tutar uçtan uca takip edilir ve otomatik olarak işlenir. Size sadece sonuçları inceleyip vardiyayı kilitlemek kalır.",
      steps: [
        {
          title: "Vardiyayı açın",
          description:
            "Satışlar otomatik yüklenir ve çoğu, banka onaylı kayıtlarla zaten eşleştirilmiş gelir."
        },
        {
          title: "Otomatik eşleşeni gözden geçirin",
          description:
            "Mutabakat çalışma alanı, otomasyon satışlarını ve banka ödemelerini eşleşmeleri yapılmış halde yan yana gösterir."
        },
        {
          title: "Personel açıklarını inceleyin",
          description:
            "Her fark, gerekçesi bir bakışta görünecek şekilde ilgili vardiyaya ve personele atanır."
        },
        {
          title: "Gözden geçirip kilitleyin",
          description:
            "Vardiyayı kilitlersiniz; tam kayıt saklanır ve denetime hazırdır. Manuel düzeltme yalnızca nadir istisna için gerekir."
        }
      ]
    },
    examples: {
      title: "Ekibinizin tanıyacağı örnekler",
      subtitle:
        "Yine de yakından bakılması gereken nadir durumlar ve Shift Tracker'ın bunları nasıl ele aldığı.",
      items: [
        {
          title: "Nakitten karta düzeltilen satış",
          description:
            "Nakit girilmiş bir satış düzeltilir, mutabakatta görünür hale gelir ve ardından banka hareketine bağlanabilir.",
          outcome: "Düzeltme → Mutabakat"
        },
        {
          title: "Kısmi kart, kalan nakit",
          description:
            "Banka onaylı kart kısmı ayrı izlenirken nakit kısmı açıklayıcı ve denetlenebilir olarak kalır.",
          outcome: "Tahsis odaklı"
        },
        {
          title: "Vardiyalar arası ödeme çakışması",
          description:
            "Yakın vardiyalara ait ödemeler görünür kalır ancak yanlış banka kaydının kullanılmaması için açıkça işaretlenir.",
          outcome: "Daha güvenli inceleme"
        }
      ]
    },
    fraudCallout: {
      eyebrow: "Dolandırıcılık önleme",
      title: "İstasyonunuzun kayıtlarında halihazırda gizli bir suistimal olabilir.",
      text:
        "Hırsızlığın çoğu küçük denetim ve onay açıklarından sızar: iki kez sayılan bir makbuz, nakit olarak kaydedilen bir kart satışı, sessizce değiştirilen bir ön ödemeli bakiye. Açıkları ve Shift Tracker'ın her birini nasıl kapattığını görün.",
      stat: "6 yaygın açık kapatılır",
      button: "Açıkları nasıl kapattığımızı görün"
    },
    solutions: {
      title: "Çözümler",
      subtitle: "Akaryakıt ve benzin istasyonu işletmecileri için."
    },
    faq: {
      title: "Sıkça sorulan sorular",
      subtitle:
        "Akaryakıt ve benzin istasyonu ekiplerinin Shift Tracker'a geçmeden önce sorduğu sorular.",
      items: [
        {
          question: "Shift Tracker nedir?",
          answer:
            "Shift Tracker, akaryakıt ve benzin istasyonları için nakit akışı ve mutabakat yazılımıdır. ERP kart satışlarını banka onaylı ödemelerle eşleştirir, yanlış girilen ödeme tiplerini düzeltir ve her vardiya için denetlenebilir kayıtlar oluşturur."
        },
        {
          question: "İstasyonda nakit akışını kontrol etmeye nasıl yardımcı olur?",
          answer:
            "Otomasyon satışlarını vardiya bazında banka onaylı kayıtlarla karşılaştırır, banka onaylı tutarları açıklayıcı nakit tutarlardan ayırır ve çözülmemiş farkları öne çıkararak kaçakların erken fark edilmesini sağlar."
        },
        {
          question: "Nakit yatırmaların gerçekten bankaya ulaştığını doğrular mı?",
          answer:
            "Evet. Nakit yatırıldı olarak işaretlendiğinde uygulama, bankada yazılacak benzersiz bir referans üretir; Shift Tracker bunu gerçek banka ekstrenizle eşleştirir ve yatırmayı aynı gün otomatik doğrular; eksik, mükerrer veya kayıp yatırmaları işaretler.",
          linkText: "Otomatik nakit yatırma doğrulamayı görün",
          linkTo: "/nakit-yatirma-dogrulama/"
        },
        {
          question: "TURPAK, Asis veya diğer pompa otomasyonlarıyla çalışır mı?",
          answer:
            "Evet. Shift Tracker, TURPAK ve Asis gibi pompa otomasyon sistemlerinden satış verisini alır ve banka onaylı ödemelerle mutabık kılar. Otomasyon satışı pompada ölçer; Shift Tracker o satışın bankaya geçtiğini kanıtlar ve denetim izini tutar.",
          linkText: "Okuyun: TURPAK otomasyonu ve banka mutabakatı",
          linkTo: "/blog/turpak-otomasyonu-banka-mutabakati/"
        },
        {
          question: "Vardiya başına ne kadar zaman kazandırır?",
          answer:
            "Çoğu vardiya otomatik eşleştirilir ve açar açmaz hazırdır; siz yalnızca personel açıklarını gözden geçirip vardiyayı kilitlersiniz. Daha önce kâğıt ve Excel ile 1,5-2 saat süren bir vardiya artık bir dakikanın altında kapanır; manuel düzeltme yalnızca nadir bir istisnadır."
        },
        {
          question: "Mevcut sürecimde suistimal olup olmadığını nasıl anlarım?",
          answer:
            "İstasyon suistimalinin çoğu rutin açıklarda gizlenir: yeniden kullanılan bir ödeme makbuzu, nakit olarak kaydedilen bir kart satışı veya gerçek bir banka tahsilatı olmadan değiştirilen bir ön ödemeli bakiye. Düzeltmeler; kayıtlı bir gerekçe ve inceleyen olmadan yapılıyorsa bu açıklar görünmez kalır. Shift Tracker her vardiyayı banka onaylı kayıtlarla mutabık kılar ve tam bir denetim izi tutar; böylece açıklar görünür ve kapatılabilir hale gelir.",
          linkText: "Kapattığımız suistimal açıklarını görün",
          linkTo: "/fraud-prevention/"
        },
        {
          question: "Personel açıklarını veya uyuşmazlıkları nasıl tespit eder?",
          answer:
            "Her vardiya banka onaylı ödemeler ve ERP toplamlarıyla mutabık kılınır. Farklar; gerekçe, inceleyen ve zaman damgasıyla birlikte vardiyaya ve personele atanır."
        },
        {
          question: "TURPAK ile entegre mi?",
          answer:
            "Evet. Shift Tracker, TURPAK otomasyon sistemleriyle senkronize olarak pompa ve ERP satış verilerini mutabakat ve raporlama için alır."
        },
        {
          question: "Ödeme tipi düzeltmesi nedir?",
          answer:
            "Kartla yapılan bir satış yanlışlıkla nakit olarak girildiğinde, etkin ödeme tipini düzelterek mutabakat akışına dahil edebilirsiniz; orijinal kayıt denetim için korunur."
        },
        {
          question: "Tahsis (allocation) bazlı mutabakat nedir?",
          answer:
            "Banka tarafından onaylanan kart tutarları, açıklayıcı nakit tutarlardan ayrı olarak tahsis edilir ve izlenir; böylece her tutar ya banka onaylı bir kayda ya da açıklamalı bir nakit girişine bağlanır."
        },
        {
          question: "Birden fazla istasyon için uygun mu?",
          answer:
            "Evet. Sahip, yönetici ve vardiya personeli için rol bazlı erişimle çoklu istasyon operasyonlarını destekler. Tamamen internet üzerinden çalışan sistem sayesinde istasyonunuza ait tüm verilere, dilediğiniz cihazdan, istediğiniz an ve her yerden tek bir panel üzerinden erişebilirsiniz; istasyonunuz her zaman kontrolünüz altında."
        },
        {
          question: "Shift Tracker'ın ücreti nedir?",
          answer:
            "Güncel aylık ve yıllık planlar için fiyatlandırma sayfamıza bakın veya başlamak için bizimle iletişime geçin.",
          linkText: "Fiyatlandırma planlarını görün",
          linkTo: "/fiyatlandirma/"
        },
        {
          question: "Nasıl başlarız?",
          answer:
            "Demo için bizimle iletişime geçin; istasyonlarınız için mutabakat, ödeme düzeltme ve raporlamayı birlikte inceleyelim."
        }
      ]
    },
    cta: {
      title: "Vardiyalarınızı zahmetsiz kapatmaya hazır mısınız?",
      subtitle:
        "Shift Tracker'ı kendi istasyonunuzun rakamlarıyla görün. Bütün bir vardiyanın nasıl kendiliğinden mutabık kılındığını gösterelim; kart satışları, nakit yatırmalar ve personel açıkları banka mutabakatıyla birlikte çözülsün, ardından yalnızca gözden geçirip kilitleyeceğiniz temiz bir tablo elinizde kalsın.",
      primary: "İletişime geçin",
      secondary: "Rehberleri okuyun"
    }
  },
  contact: {
    title: "İletişime Geçin",
    subtitle: "Formu doldurun, Shift Tracker'ın size nasıl yardımcı olabileceğini gösterelim",
    companyName: "Şirket Adı",
    fullName: "Ad Soyad",
    email: "E-posta",
    phone: "Telefon",
    message: "Mesajınız (isteğe bağlı)",
    submit: "Gönder",
    submitting: "Gönderiliyor...",
    successMessage: "Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.",
    errorMessage: "Bir hata oluştu. Lütfen daha sonra tekrar deneyin.",
    responseNote: "1 iş günü içinde yanıtlıyoruz, genellikle çok daha kısa sürede.",
    kvkkNotice: "Bilgileriniz yalnızca talebinize yanıt vermek için kullanılır ve şu metne uygun işlenir:",
    kvkkLinkText: "aydınlatma metni (KVKK)"
  },
  newsletter: {
    heading: "Vardiya usulsüzlüklerinde ve mutabakatta bir adım önde olun",
    subtitle: "Akaryakıt istasyonu nakit akışı, TURPAK mutabakatı ve vardiya kayıplarını önleme üzerine pratik ipuçları, doğrudan e-postanıza. Spam yok.",
    emailPlaceholder: "E-posta adresiniz",
    submit: "Abone Ol",
    submitting: "Kaydediliyor...",
    successMessage: "Neredeyse tamam! E-posta kutunuzu kontrol edip onay bağlantısına tıklayarak aboneliğinizi tamamlayın.",
    errorMessage: "Abonelik başarısız oldu. Lütfen daha sonra tekrar deneyin.",
    consent: "Abone olarak zaman zaman e-posta almayı kabul edersiniz. İstediğiniz zaman abonelikten çıkabilirsiniz.",
    confirmed: {
      title: "Aboneliğiniz onaylandı 🎉",
      message: "Onayladığınız için teşekkürler, artık listemizdesiniz. Size yalnızca okumaya değer bir şey olduğunda e-posta göndereceğiz.",
      cta: "Bloga dön"
    },
    unsubscribed: {
      title: "Abonelikten çıkarıldınız",
      message: "Artık bülten e-postası almayacaksınız. Fikrinizi mi değiştirdiniz? Blogumuzdan istediğiniz zaman yeniden abone olabilirsiniz.",
      cta: "Bloga dön"
    }
  },
  pricing: {
    hero: {
      badge: "Sınırlı süreli indirim: %38'e varan tasarruf",
      title: "Basit ve şeffaf fiyatlandırma",
      subtitle: "Tek plan, her şey dahil: banka onaylı vardiyalar, TURPAK mutabakatı ve canlı istasyon takibi; istasyonunuzun nakit akışı her an güvence altında. İndirimli fiyatı sabitleyin, sürpriz yok."
    },
    plans: {
      monthly: {
        name: "Aylık",
        listPrice: "20.000 ₺",
        price: "15.000 ₺",
        period: "/ ay",
        discount: "%25 İNDİRİM",
        save: "Ayda 5.000 ₺ tasarruf",
        note: "Taahhütsüz olarak değeri kendi vardiyalarınızda görün."
      },
      annual: {
        name: "Yıllık",
        listPrice: "240.000 ₺",
        price: "150.000 ₺",
        period: "/ yıl",
        discount: "%38 İNDİRİM",
        save: "Yılda 90.000 ₺ tasarruf",
        note: "Tek ödeme, 12 ay, en avantajlı seçenek."
      }
    },
    listLabel: "Liste fiyatı",
    cta: "Ücretsiz demo talep edin",
    featuresTitle: "Her plana her şey dahil",
    features: [
      "TURPAK entegrasyonu: satışlar otomatik aktarılır",
      "Kart satışlarının gerçek banka ödemeleriyle eşleştirilmesi",
      "Nakit yatırmaların banka ekstresiyle doğrulanması",
      "Açık vardiya için canlı satış ekranı",
      "Tank stok takibi",
      "Akıllı akaryakıt sipariş önerileri",
      "Personel açık takibi",
      "Denetime hazır vardiya kayıtları",
      "Doğrudan WhatsApp ve telefon desteği"
    ],
    notes: [
      "Tüm fiyatlara KDV dahildir.",
      "İndirimli fiyat sınırlı bir süre için geçerlidir."
    ],
    bottom: {
      title: "Kendi istasyonunuzun rakamlarıyla görün",
      subtitle: "15 dakikalık bir demoda vardiya akışınızı birlikte inceliyor, mutabakatın kendi banka ve TURPAK verilerinizle nasıl çalıştığını gösteriyoruz.",
      button: "Demo talep edin"
    }
  },
  kvkk: {
    title: "Aydınlatma Metni (KVKK)",
    updated: "Son güncelleme: 2 Temmuz 2026",
    intro: "Bu metin, 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında shifttracker.net'in hangi kişisel verileri neden topladığını ve haklarınızı açıklar. İyi niyetle hazırlanmıştır ve güncellenebilir; güncel sürüm her zaman bu sayfadadır.",
    sections: [
      {
        heading: "Veri sorumlusu",
        text: "Veri sorumlusu, Shift Tracker'ın (shifttracker.net) işletmecisidir. Bize bu sitedeki iletişim formundan, telefon veya WhatsApp ile +90 532 552 09 03 numarasından ulaşabilirsiniz."
      },
      {
        heading: "Hangi verileri neden topluyoruz",
        text: "İletişim/demo formu: şirket adı, ad soyad, e-posta, telefon, mesajınız ve ziyaretinizin başladığı sayfa/kampanya bilgisi, yalnızca talebinize yanıt vermek ve size uygun bir demo hazırlamak için kullanılır. Bülten: e-posta adresiniz, yalnızca çift onay (double opt-in) e-postasını onaylamanızdan sonra saklanır ve sadece talep ettiğiniz bülteni göndermek için kullanılır. Canlı sohbet (Crisp) ve WhatsApp: paylaşmayı seçtiğiniz mesajlar ve iletişim bilgileri, size yanıt vermek için kullanılır."
      },
      {
        heading: "Çerezler ve analitik",
        text: "Hangi sayfaların ziyaret edildiğini ve hangi işlemlerin (ör. demo talebi) gerçekleştiğini anlamak için Google Analytics 4, canlı sohbet için Crisp kullanıyoruz. Bu hizmetler çerez kullanır ve verileri sağlayıcılarının altyapısında işler. Kişisel verileri satmıyor ve üçüncü taraf reklamcılığı için kullanmıyoruz."
      },
      {
        heading: "Saklama ve paylaşım",
        text: "Kişisel verileri yalnızca yukarıdaki amaçlar için gerekli olduğu sürece veya yasal zorunluluk kapsamında saklıyor; sadece burada adı geçen hizmet sağlayıcılarla (barındırma, analitik, sohbet, e-posta gönderimi) sitenin çalışması için gerektiği ölçüde paylaşıyoruz."
      },
      {
        heading: "Haklarınız (KVKK Madde 11)",
        text: "Verilerinizin işlenip işlenmediğini sorma, düzeltilmesini veya silinmesini isteme, işlemeye itiraz etme ve düzeltme/silme işlemlerinin aktarıldığı üçüncü kişilere bildirilmesini talep etme hakkına sahipsiniz. Her bülten e-postasında abonelikten çıkma bağlantısı bulunur. Haklarınızı kullanmak için yukarıdaki kanallardan bize ulaşın; yasal süre içinde yanıtlıyoruz."
      }
    ],
    backHome: "Ana sayfaya dön"
  },
  registration: {
    success: {
      message: "Kayıt başarılı! Giriş sayfasına yönlendiriliyorsunuz...",
      countdown: "{seconds} saniye içinde yönlendiriliyorsunuz...",
      invalidLink: "Geçersiz kayıt linki",
      loadError: "Kayıt detayları yüklenemedi",
      failed: "Kayıt başarısız. Lütfen tekrar deneyin."
    }
  },
  about: {
    hero: {
      title: "İstasyoncular tarafından, istasyoncular için",
      subtitle: "Shift Tracker, saatler süren manuel vardiya mutabakatını bir dakikalık, banka onaylı bir kapanışa dönüştürür. Kendi istasyonumuz için geliştirdik ve her gün orada kullanıyoruz."
    },
    story: {
      title: "Hikâyemiz",
      paragraphs: [
        "Shift Tracker bir ofiste doğmadı. Bir Shell istasyonunda doğdu; her vardiyanın sonunda satışları elle toplamak, kart ödemelerini tek tek eşleştirmek, nakdin gerçekten bankaya ulaşıp ulaşmadığının peşine düşmek ve hiçbir şeyin gözden kaçmadığını ummak demekti.",
        "Bir akaryakıt istasyonunun nakit akışını gereken titizlikle ele alan bir yazılım bulamadık, biz de kendimizinkini geliştirdik. Bugün Shift Tracker, artık ona güvenen diğer istasyonların yanı sıra o aynı istasyonu her gün çalıştırıyor."
      ]
    },
    principle: {
      title: "İlkemiz: güvene değil, kontrole dayalı",
      text: "Bir istasyon, rakamların tutacağı umuduyla yönetilmemeli. Her tutar bankaya karşı ispatlanabilmeli, her düzeltme bir kayıt bırakmalı ve her vardiya kanıtla kapanmalı. Bu ilke Shift Tracker'ın her parçasını şekillendirir."
    },
    offer: {
      title: "Shift Tracker ne yapar",
      items: [
        { icon: "🔄", title: "Otomatik mutabakat", text: "Pompa otomasyonunuzdan gelen kart satışları, düzenli olarak banka onaylı ödemelerle eşleştirilir; böylece vardiyayı açtığınızda mutabakat çoktan hazırdır." },
        { icon: "🏦", title: "Nakit yatırma doğrulama", text: "Her nakit yatırma gerçek banka ekstrenizle karşılaştırılıp teyit edilir; eksik, mükerrer ya da hiç yatırılmamışsa işaretlenir." },
        { icon: "🧾", title: "Personel açığı tespiti", text: "Farklar, açık bir gerekçeyle vardiyaya ve personele atfedilir; böylece açıklar kaybolmak yerine ortaya çıkar." },
        { icon: "🛡️", title: "Tasarımdan gelen suistimal önleme", text: "Hırsızlığı gizleyen rutin açıklar, yeniden kullanılan bir makbuz veya nakit gösterilen bir kart satışı gibi, görünür ve kapatılabilir hale gelir." },
        { icon: "📊", title: "Operasyonel görünürlük", text: "Canlı satışlar, tank seviyeleri ve sipariş önerileri, vardiyanın ötesinde istasyonun gerçek zamanlı bir görünümünü verir." }
      ]
    },
    why: {
      title: "İstasyonlar neden Shift Tracker'ı seçiyor",
      items: [
        { title: "İstasyoncular tarafından geliştirildi", text: "Her özellik, bir kontrol listesinden değil, kendi istasyonumuzda birebir yaşadığımız gerçek bir problemden doğdu." },
        { title: "Banka onaylı ve denetime hazır", text: "Her tutar gerçek bir banka işlemine dayanır; kimin neyi neden değiştirdiğinin tam kaydıyla birlikte." },
        { title: "Otomasyonunuzla çalışır", text: "TURPAK, Asis ve diğer pompa otomasyonları doğrudan beslenir. Pompada hiçbir şey değişmez." },
        { title: "İki saat değil, bir dakika", text: "Eskiden bir akşamınızı alan mutabakat sizin için yapılır; siz rakamları gözden geçirip vardiyayı kilitlersiniz." }
      ]
    },
    cta: {
      title: "Kendi istasyonunuzun rakamlarıyla görün",
      subtitle: "Bir tanıtım için bizimle iletişime geçin ya da bir vardiyanın tam olarak nasıl kapandığını görmek için rehberleri okuyun.",
      button: "Bizimle iletişime geçin",
      secondary: "Rehberleri okuyun"
    }
  },
  fraud: {
    hero: {
      title: "Akaryakıt İstasyonları için Dolandırıcılık Tespiti ve Önleme",
      subtitle:
        "Hırsızlığın çoğu, denetim ve onay sürecinin eksik olduğu yerlerde olur. Bütün ödemeler banka ile karşılaştırılır ve teyit edilir, böylece POS slibi kaçması veya kaybolması derdi kalmaz; Shift Tracker, dolandırıcıların dayandığı açıkları kapatır: mükerrer makbuzlar, ödeme tipi hileleri ve ön ödemeli kart manipülasyonu."
    },
    intro: {
      title: "Dolandırıcılık gerçekte nerede olur?",
      text:
        "Yoğun bir akaryakıt istasyonunda para, büyük soygunlarla değil; günlük süreçteki küçük ve tekrar eden açıklarla kaybolur, iki kez sayılan bir makbuz, nakit olarak kaydedilen bir kart satışı, sessizce değiştirilen bir ön ödemeli bakiye. Sıkı bir denetim ve onay izi olmadan bu açıklar görünmez kalır. Shift Tracker bunları kapatmak için tasarlandı."
    },
    gaps: {
      title: "Yaygın dolandırıcılık açıkları ve Shift Tracker bunları nasıl kapatır",
      subtitle:
        "Aşağıdaki her açık, manipülasyonu tespit edilebilir ya da imkansız kılan bir kontrole karşılık gelir.",
      items: [
        {
          icon: "🧾",
          title: "Mükerrer ödeme makbuzları",
          problem:
            "Aynı banka makbuzu veya POS slibi, farklı açıkları kapatmak için birden fazla kez kullanılır; böylece defterler dengeli görünürken nakit dışarı çıkarılabilir.",
          solution:
            "Bütün ödemeler banka ile karşılaştırılır ve her ödeme yalnızca bir kez tahsis edilebilir. Bir POS slibinin yeniden kullanılması anında işaretlenir; POS slibi kaçması olmaz ve tek bir kanıt asla iki tutarı haklı çıkaramaz."
        },
        {
          icon: "🔁",
          title: "Kart satışının nakit (veya nakdin kart) gibi gösterilmesi",
          problem:
            "Bir kart satışı nakit (veya tersi) olarak kaydedilir; böylece banka onaylı toplam, raporlanan tutarla örtüşmez ve aradaki fark cebe atılabilir.",
          solution:
            "ERP/otomasyon satışları banka onaylı kayıtlarla eşleştirilir; raporlanan ödeme tipi ile gerçekte bankaya geçen tutar arasındaki her uyumsuzluk ortaya çıkar. Ödeme tipi düzeltmesi; orijinal kaydı, düzeltilen tipi, gerekçeyi ve inceleyeni saklar."
        },
        {
          icon: "💳",
          title: "Ön ödemeli ve yakıt kartı manipülasyonu",
          problem:
            "Ön ödemeli bakiyeler ve yakıt kartı işlemleri değiştirilir veya bankaya gerçek bir tahsilat geçmediği halde ödenmiş gibi gösterilir.",
          solution:
            "Ön ödemeli ve kart hareketleri banka onaylı tahsilatla mutabık kılınır; gerçekte fonlanmamış bir bakiye, tamamlanmış bir ödeme gibi geçemez."
        },
        {
          icon: "🛡️",
          title: "Denetim ve onay izinin olmaması",
          problem:
            "Düzeltmeler; kayıtlı bir gerekçe, inceleyen ve zaman damgası olmadan yapılabildiğinde, izlenecek hiçbir şey ve sorumlu hiç kimse kalmaz.",
          solution:
            "Her değişiklik; gerekçesi, inceleyeni ve zaman damgasıyla kaydedilir. Hiçbir şey denetlenebilir bir iz bırakmadan değiştirilemez."
        },
        {
          icon: "🔀",
          title: "Vardiyalar arası ödeme kaydırma",
          problem:
            "Paranın gerçekte kaybolduğu vardiyadaki açığı gizlemek için bir ödeme komşu vardiyaya kaydırılır.",
          solution:
            "Yakın vardiyalara ait ödemeler görünür kalır ancak açıkça işaretlenir; böylece bir açık, yanlış vardiya tarafından sessizce yutulamaz."
        },
        {
          icon: "🔍",
          title: "Gizli kalan çözülmemiş farklar",
          problem:
            "Küçük ve açıklanamayan farklar, gerçek kayıplara dönüşene kadar göz ardı edilir.",
          solution:
            "Çözülmemiş tutarlar öne çıkarılır ve sorumlu vardiya ile personele atanır; böylece farklar hâlâ küçükken ele alınır."
        }
      ]
    },
    benefits: {
      title: "Bu size ne kazandırır?",
      items: [
        {
          title: "Tahmin değil, kanıt",
          description:
            "Bütün nakit ödemeler bankaya yatan tutar üzerinden teyit edilir; böylece sistemdeki bütün açıklar kapanır ve her rakam banka onaylı bir kayda kadar izlenebilir."
        },
        {
          title: "Tasarımdan gelen hesap verebilirlik",
          description:
            "Her düzeltmede gerekçe, inceleyen ve zaman damgası."
        },
        {
          title: "Erken tespit",
          description:
            "Farklar aylar sonra bir denetimde değil, vardiya kapanışında ortaya çıkar."
        }
      ]
    },
    cta: {
      title: "Dolandırıcılığın dayandığı açıkları kapatın",
      subtitle:
        "Shift Tracker'ın günlük mutabakatınızı nasıl bir dolandırıcılık önleme kontrolüne dönüştürdüğünü görün.",
      button: "Demo talep edin"
    }
  },
  admin: {
    shift: {
      title: "Vardiyalar",
      filters: {
        completed: "Tamamlandı",
        locked: "Kilitli",
        depositVerified: "Kasa Onaylandı",
        creditCardVerified: "Kredi Kartı Onaylandı",
        deficitDeducted: "Açık Düşüldü",
        deposited: "Kasaya Yatırıldı",
        filterActive: "Filtre Aktif",
        listAmount: "Liste Miktarı",
        search: "Ara",
        exportExcel: "Excel'e Aktar",
        exportError: "Vardiya listesi dışa aktarılamadı."
      },
      table: {
        shiftId: "Vardiya No",
        completed: "Tamamlandı",
        depositVerified: "Kasa",
        deficitDeducted: "Açık",
        deficit: "Açık Tutarı",
        employeeSale: "Personel Satışı",
        cash: "Nakit",
        creditCard: "Kredi Kartı",
        partnerCard: "Partner Kart",
        giftCard: "Hediye Kartı",
        mobile: "Mobil",
        distributorSales: "Dağıtıcı Satışları",
        companySales: "Şirket Satışları",
        test: "Test",
        totalSale: "Toplam Satış",
        bankConfirmedCard: "Banka Onaylı Kart",
        locked: "Vardiya Kilitli",
        deposited: "Nakit Yatırıldı",
        creditCardVerified: "Kredi Kartı Onaylandı",
        delete: "Sil",
        reconciliation: "Mutabakat",
        paymentCorrection: "Ödeme Düzeltme",
        open: "Aç",
        shiftReview: "Vardiya İncele"
      }
    },
    deposit: {
      title: "Kasa İşlemleri",
      ui: {
        pageSubtitle: "Yatırılan nakitleri, banka doğrulama sonuçlarını ve her yatırmaya dahil vardiyaları inceleyin.",
        filtersTitle: "Arama ve filtreler",
        resultsTitle: "Nakit yatırma işlemleri",
        resultsHint: "Vardiyaları ve personel nakitlerini incelemek için yatırmanın ayrıntılarını açın.",
        visibleDeposits: "Listelenen yatırma",
        unverifiedDeposits: "Listede onay bekleyen",
        totalInView: "Listedeki toplam nakit",
        showShifts: "Dahil vardiyaları göster",
        hideShifts: "Dahil vardiyaları gizle",
        showCashes: "Personel nakitlerini göster",
        hideCashes: "Personel nakitlerini gizle",
        shiftCount: "Dahil vardiyalar",
        noShifts: "Bu yatırmaya dahil vardiya bulunmuyor.",
        noCashes: "Bu vardiya için personel nakit kaydı bulunmuyor.",
        saving: "Kaydediliyor…",
        saved: "Kaydedildi",
        unsaved: "Kaydedilmemiş değişiklikler",
        saveFailed: "Kaydedilemedi. Lütfen tekrar deneyin.",
        emptyResults: "Bu filtrelerle eşleşen yatırma bulunamadı.",
        fetchFailed: "Yatırmalar yüklenemedi. Lütfen tekrar deneyin.",
        manualVerification: "Manuel onay",
        deleteDeposit: "Yatırmayı sil",
        deleteQuestion: "Yatırmayı sil",
      },
      verification: {
        title: "Yatırma doğrulaması",
        overallStatus: "Güncel durum",
        verified: "Onaylandı",
        notVerified: "Onaylanmadı",
        automaticResult: "Son otomatik kontrol sonucu",
        noResult: "Kayıtlı otomatik kontrol sonucu yok",
        reason: "Kayıtlı neden",
        noReason: "Kayıtlı neden yok",
        reference: "Banka referansı",
        expectedAmount: "Yatırma anındaki beklenen tutar",
        lastChecked: "Sonuç güncellenme zamanı",
        matchedAt: "Eşleşme zamanı",
        warnedAt: "Uyarı kayıt zamanı",
        unknownDate: "Tarih bilgisi yok",
        notAvailable: "Bilgi yok",
        reviewRequired: "Banka hesap hareketlerini inceleyin ve gerekirse yatırmayı manuel olarak onaylayın.",
        processingFailed: "Otomatik doğrulama tamamlanamadı. Kayıtlı nedeni inceleyin ve yeniden denemeden önce işlem sorununu giderin.",
        historyNote: "Kayıtlı otomatik sonuç, manuel durum değişikliğinden önceye ait olabilir. Güncel onay durumu yukarıda gösterilir.",
        statuses: {
          PENDING: "Otomatik doğrulama bekleniyor",
          MATCHED: "Eşleşti",
          MISMATCH: "Tutar uyuşmazlığı",
          AMBIGUOUS: "Birden fazla eşleşme",
          NOT_FOUND: "Eşleşen işlem bulunamadı",
          FAILED: "İşlem hatası",
          UNKNOWN: "Bilinmeyen otomatik kontrol sonucu",
        },
        reasons: {
          missingDetails: "Yatırmanın banka referansı veya beklenen tutarı yok.",
          uniqueMatch: "Referans ve tutarla eşleşen tek bir gelen banka işlemi bulundu.",
          multipleMatches: "Referans ve tutarla eşleşen birden fazla gelen banka işlemi bulundu.",
          amountMismatch: "Gelen bir banka işleminde referans bulundu, ancak tutar beklenen tutarla eşleşmedi.",
          notFoundByDeadline: "Kontrol edilen tarih aralığında referansı içeren eşleşen bir gelen banka işlemi bulunamadı. Yatırmayı teyit etmek için hesap hareketlerini inceleyin.",
          notFoundInRange: "Kontrol edilen tarih aralığında referansı içeren eşleşen bir gelen banka işlemi bulunamadı. Yatırmayı teyit etmek için hesap hareketlerini inceleyin.",
          bankClosed: "Banka kapanış saatinden sonra da henüz eşleşen bir gelen banka işlemi bulunamadı.",
          noTransactionYet: "Otomatik kontrolde henüz referansı içeren bir gelen banka işlemi bulunamadı.",
        },
      },
      filters: {
        creditCardVerified: "Kredi Kartı Onaylandı",
        filterActive: "Filtre Aktif",
        shiftLocked: "Vardiya Kilitli",
        shiftCompleted: "Vardiya Tamamlandı",
        deposited: "Bankaya Yatırıldı",
        depositVerified: "Yatırma Onaylandı",
        amount: "Tutar",
        active: "Aktif",
        dateFilter: "Tarih Filtresi",
        amountFilter: "Tutar Filtresi",
        shiftFilter: "Vardiya Filtresi",
        startDate: "Başlangıç Tarihi",
        startDateFilter: "Başlangıç Tarihi Filtresi",
        endDate: "Bitiş Tarihi",
        minAmount: "Min Tutar",
        searchByIdFilter: "Id'ye Göre Ara",
        firstShift: "İlk Vardiya",
        enterShiftId: "Vardiya No Giriniz",
        maxAmount: "Max Tutar",
        lastShift: "Son Vardiya",
        search: "Ara",
        sortBy: "Normal Sıralama",
        sortByDesc: "Ters Sıralama",
        listAmount: "Liste Miktarı",
        deleteMode: "Silme Modu",
        amountEqual: "Tutar Eşit",
        amountGreaterThanOrEqual: "Tutar Büyük Eşit",
        amountGreaterThan: "Tutar Büyük",
        amountLessThan: "Tutar Küçük",
        amountLessThanOrEqual: "Tutar Küçük Eşit"
      },
      table: {
        depositId: "Yatırma No",
        date: "Tarih",
        amount: "Tutar",
        deposited: "Yatırıldı",
        verified: "Onaylandı",
        deleteShift: "Vardiyayı Sil",
        showShift: "Vardiyayı Görüntüle",
        depositVerified: "Yatırma Onaylandı",
        totalAmount: "Toplam Tutar",
        eligibleForVerify: "Onaylanabilir",
        delete: "Sil",
        showCash: "Nakit Görüntüle",
        shiftId: "Vardiya No",
        locked: "Kilitli",
        completed: "Tamamlandı",
        yes: "Evet",
        no: "Hayır",
        employeeName: "Personel Adı",
        note: "Not",
        update: "Güncelle",
      }
    },
    creditCard: {
      title: "Kredi Kartı İşlemleri",
      noResults: "Kredi kartı işlemleri bulunamadı",
      filters: {
        filterActive: "Filtre Aktif",
        general: "Genel Filtreler",
        verified: "Onaylandı",
        locked: "Kilitli",
        completed: "Tamamlandı",
        bankFilter: "Banka Filtresi",
        bankFilterActive: "Banka Filtresi Aktif",
        shiftFilter: "Vardiya Filtresi",
        firstShift: "İlk Vardiya",
        lastShift: "Son Vardiya",
        search: "Ara",
        sortBy: "Normal Sıralama",
        sortByDesc: "Ters Sıralama",
        listAmount: "Liste Miktarı",
        amountFilter: "Tutar Filtresi",
        minAmount: "Minimum Tutar",
        maxAmount: "Maksimum Tutar",
        batchIdFilter: "Batch Id Filtresi",
        batchId: "Batch Id",
        searchByIdFilter: "Id'ye Göre Ara",
        selectBank: "Banka Seç"
      },
      table: {
        creditCardId: "Kredi Kartı No",
        shiftId: "Vardiya No",
        bankName: "Banka",
        amount: "Tutar",
        batchId: "Batch No",
        locked: "Kilitli",
        completed: "Tamamlandı",
        verified: "Onaylandı",
        yes: "Evet",
        no: "Hayır"
      }
    },
    shiftReport: {
      title: "Günlük Vardiya Raporu",
      selectDate: "Tarih Seçin",
      loading: "Yükleniyor...",
      noReports: "Seçilen tarih için vardiya raporu bulunamadı.",
      error: "Raporlar yüklenirken bir hata oluştu",
      shift: "Vardiya",
      shiftId: "Vardiya No",
      enterShiftId: "Vardiya No Giriniz",
      enterShiftIds: "Örn. 2025031101, 2025031102",
      multipleShiftIds: "Birden fazla vardiya no için virgülle ayırın",
      search: "Ara",
      totalSale: "Toplam Satış",
      noEmployeeData: "Personel verisi bulunamadı",
      noBatchData: "Kredi kartı batch verisi bulunamadı",
      descriptions: "Notlar",
      infoText: "Bilgi",
      exportExcel: "Excel'e Aktar",
      exportPDF: "PDF'e Aktar",
      shareLink: "Bağlantıyı Paylaş",
      linkCopied: "Bağlantı panoya kopyalandı!",
      clearDateFilter: "Tarih filtresini temizle",
      grandTotal: "Genel Toplam",
      employees: {
        title: "Personeller",
        name: "Personel",
        totalSale: "Toplam Satış",
        cashAmount: "Nakit Tutarı",
        creditCardAmount: "Kredi Kartı Tutarı",
        difference: "Fark",
        note: "Not",
        totals: "Toplamlar"
      },
      creditCardBatches: {
        title: "Kredi Kartı Batch",
        bank: "Banka",
        batchNo: "Batch No",
        amount: "Tutar",
        total: "Toplam"
      }
    },
    employeeDeficit: {
      title: "Personel Açıkları",
      filter: {
        title: "Filtrele",
        startShift: "Başlangıç Vardiyası",
        endShift: "Bitiş Vardiyası",
        deductionStatus: "Kesinti Durumu",
        allDeficits: "Tüm Açıklar",
        deducted: "Kesildi",
        notDeducted: "Kesilmedi",
        employeeName: "Personel Adı",
        employeeNamePlaceholder: "İsme göre ara",
        amount: "Tutar",
        amountOperator: "Operatör",
        operators: {
          gte: "En az",
          lte: "En çok",
          gt: "Daha fazla",
          lt: "Daha az"
        },
        amountPlaceholder: "Tutar",
        onlyShortfalls: "Yalnızca açıklar",
        onlySurpluses: "Yalnızca fazlalar",
        export: "Excel'e Aktar",
        applyFilter: "Filtrele",
        resetFilter: "Sıfırla"
      },
      table: {
        id: "ID",
        shiftId: "Vardiya No",
        rootShiftId: "Ana Vardiya No",
        date: "Tarih",
        shiftNo: "Vardiya No",
        employee: "Personel",
        amount: "Tutar",
        status: "Durum",
        note: "Not",
        actions: "İşlemler"
      },
      status: {
        deducted: "Kesildi",
        notDeducted: "Kesilmedi",
        shortfall: "Borçlu",
        surplus: "Fazla",
        balanced: "Dengede"
      },
      buttons: {
        goToShift: "Vardiyaya Git",
        markAsDeducted: "Kesildi Olarak İşaretle",
        markAsNotDeducted: "Kesilmedi Olarak İşaretle",
        recalculate: "Vardiyayı yeniden hesapla"
      },
      confirmation: {
        title: "Onay",
        markAsDeducted: "Bu açığı kesildi olarak işaretlemek istediğinizden emin misiniz?",
        markAsNotDeducted: "Bu açığı kesilmedi olarak işaretlemek istediğinizden emin misiniz?",
        yes: "Evet",
        no: "Hayır"
      },
      messages: {
        recalcSuccess: "Vardiya açıkları yeniden hesaplandı.",
        deductSuccess: "Kesinti durumu güncellendi.",
        exportError: "Açık listesi dışa aktarılamadı."
      },
      noDeficits: "Bu filtrelere uyan personel açığı yok.",
      loading: "Yükleniyor..."
    }
  },
  reconciliation: {
    queue: {
      breadcrumb: "Mutabakat / Yönetici İnceleme",
      title: "Belirsizlik Kuyruğu",
      status: "BELİRSİZ",
      subtitle: "Çözülemeyen ERP kart işlemlerini inceleyin ve doğru banka kaydını manuel olarak onaylayın.",
      summary: {
        currentPage: "Mevcut Sayfa",
        totalRecords: "Toplam Kayıt",
        bankCode: "Banka Kodu",
        shiftFilter: "Vardiya Filtresi"
      },
      filters: {
        title: "Filtreler",
        hint: "Kuyruğu banka ve iş vardiya numarasına göre filtreleyin",
        businessShiftNo: "İş Vardiya No",
        search: "Ara",
        clear: "Temizle",
        perPage: "/ sayfa"
      },
      table: {
        title: "Kuyruk",
        hint: "Çözülemeyen işlemleri hızlıca tarayın ve manuel inceleme için açın",
        matchId: "Eşleşme ID",
        shift: "Vardiya",
        employee: "Personel",
        amount: "Tutar",
        erpTime: "ERP Zamanı",
        receipt: "Fiş",
        plate: "Plaka",
        reason: "Neden",
        candidates: "Adaylar",
        tx: "İşlem",
        entity: "Entity",
        review: "İncele"
      },
      loading: "Belirsizlik kuyruğu yükleniyor...",
      empty: "Seçili filtreler için belirsiz kayıt bulunamadı.",
      pagination: {
        page: "Sayfa",
        of: "/",
        go: "Git",
        invalidPage: "Lütfen geçerli bir sayfa numarası girin.",
        pageRange: "Sayfa 1 ile {totalPages} arasında olmalıdır."
      }
    },
    detail: {
      breadcrumb: "Mutabakat / Belirsizlik İncelemesi",
      subtitle: "ERP işlemini inceleyin ve doğru banka adayını onaylayın.",
      backToQueue: "Kuyruğa dön",
      recordNotFound: "Kayıt bulunamadı",
      recordNotFoundDesc: "Bu belirsizlik çözülmüş olabilir veya artık mevcut olmayabilir.",
      loading: "Belirsizlik detayı yükleniyor...",
      sections: {
        erpTransaction: "ERP İşlemi",
        erpHint: "Kaynak işlem detayları",
        candidateBankTransactions: "Aday Banka İşlemleri",
        candidateHint: "Onaylamak için tam olarak bir aday seçin",
        adminAction: "Yönetici İşlemi",
        adminActionHint: "Onayla, reddet veya yeniden beklemeye al"
      },
      summary: {
        amount: "Tutar",
        employee: "Personel",
        businessShiftNo: "İş Vardiya No",
        erpTime: "ERP Zamanı"
      },
      fields: {
        reason: "Neden",
        shiftEntityId: "Vardiya Entity ID",
        shiftTransactionId: "Vardiya İşlem ID",
        receipt: "Fiş",
        plate: "Plaka",
        paymentType: "Ödeme Tipi",
        bank: "Banka",
        terminal: "Terminal",
        authorization: "Provizyon",
        merchant: "İşyeri",
        importedFileId: "Aktarılan Dosya ID",
        transactionId: "İşlem ID"
      },
      note: {
        label: "Not",
        placeholder: "İsteğe bağlı yönetici notu"
      },
      selection: {
        selectedCandidate: "Seçilen aday ID",
        noCandidate: "Aday seçilmedi"
      },
      actions: {
        confirm: "Seçili Adayı Onayla",
        reject: "ERP İşlemini Reddet",
        keepPending: "Beklemede Tut",
        processing: "İşleniyor...",
        continue: "Devam",
        cancel: "İptal"
      },
      modal: {
        title: "İşlemi onayla",
        confirm: "Seçilen banka adayını onaylamak istiyor musunuz?",
        reject: "Bu ERP kart işlemini reddetmek istiyor musunuz?",
        pending: "Bu kaydı beklemeye almak istiyor musunuz?"
      },
      emptyCandidates: "Bu kayıt için banka adayı bulunamadı.",
      alerts: {
        loadFailed: "Belirsizlik detayı yüklenemedi.",
        selectCandidate: "Lütfen bir banka adayı seçin.",
        confirmSuccess: "Aday başarıyla onaylandı.",
        confirmFailed: "Onaylama işlemi başarısız oldu.",
        rejectSuccess: "ERP işlemi başarıyla reddedildi.",
        rejectFailed: "Reddetme işlemi başarısız oldu.",
        pendingSuccess: "Kayıt beklemeye alındı.",
        pendingFailed: "Beklemeye alma işlemi başarısız oldu."
      }
    }
  },
  matchingStatus: {
    readyTitle: "Banka eşleştirmesi güncel",
    readyBody:
      "Bu güne ait tüm banka dosyaları yüklendi, otomatik eşleştirmeyi bekleten bir durum yok.",
    waitingTitle: "Banka dosyaları bekleniyor",
    waitingBody:
      "Bir kart satışının yanlış banka kaydıyla eşleşmemesi için otomatik eşleştirme, ancak tüm bankalar günlük dosyasını gönderdikten sonra başlar. O ana kadar kart satışları beklemede kalır; hiçbir kayıt kaybolmaz ve sizin bir işlem yapmanıza gerek yoktur. Halen beklenen:",
    delayedTitle: "Banka dosyaları gecikti",
    delayedBody:
      "Bu dosya normalde daha erken gelir. Dosya geldiği anda eşleştirme kendiliğinden başlayacak, hiçbir kayıt kaybolmaz. Halen beklenen:",
    attentionTitle: "Banka dosyası hâlâ gelmedi, takip edilmesi gerekiyor",
    attentionBody:
      "Günlük dosya bize ulaşmadı ve bu dosya olmadan eşleştirme güvenle başlayamaz. Lütfen bankanızla veya Shift Tracker yetkilinizle iletişime geçin:",
    noBanksTitle: "Henüz banka tanımlı değil",
    noBanksBody:
      "Otomatik eşleştirme için en az bir aktif banka gerekir. Lütfen Shift Tracker yetkilinizle iletişime geçin.",
    bankSynced: "yüklendi",
    bankLoading: "yükleniyor",
    bankNotImported: "gelmedi",
    bankNotSupported: "kurulu değil",
    expectedBy: "Tüm dosyalar normalde şu saate kadar gelir:"
  },
  reconciliationV2: {
    common: {
      show: "Göster",
      hide: "Gizle",
      backToQueue: "Kuyruğa dön",
      breadcrumb: "Mutabakat / Çalışma Alanı",
      title: "Mutabakat Çalışma Alanı",
      subtitle:
        "ERP kart satışları ile banka ödeme kayıtlarını yan yana inceleyin ve manuel tahsis işlemleri yapın.",
      loading: "Çalışma alanı yükleniyor...",
      refresh: "Yenile",
      clear: "Temizle",
      search: "Ara",
      cancel: "İptal",
      continue: "Devam Et",
      processing: "İşleniyor...",
      note: "Not",
      optionalNote: "İsteğe bağlı yönetici notu",
      notFound: "Kayıt bulunamadı",
      noSelection: "Seçim yapılmadı"
    },
    filters: {
      title: "Çalışma Alanı Kontrolleri",
      shiftId: "Vardiya No",
      shiftIdPlaceholder: "Örn. 2026041401",
      lookbackHours: "Geriye Dönük Saat",
      lookaheadHours: "İleriye Dönük Saat",
      bankCode: "Banka Kodu",
      showOnlyUnmatchedErp: "Yalnızca eşleşmemiş ERP kayıtları",
      showOnlyFreeBankRows: "Yalnızca boş banka kayıtları",
      terminal: "Terminal",
      amount: "Tutar"
    },
    workspace: {
      shiftInfo: {
        title: "Çalışma Alanı Özeti",
        shiftId: "Vardiya No",
        shiftEntityId: "Vardiya Varlık No",
        shiftStart: "Vardiya Başlangıcı",
        shiftEnd: "Vardiya Bitişi",
        lookbackHours: "Geriye Dönük",
        lookaheadHours: "İleriye Dönük"
      },
      erpPanel: {
        title: "ERP Kredi Kartı Satışları",
        hint: "Seçili vardiyaya ait ERP kart satışları",
        empty: "Bu çalışma alanı için ERP kaydı bulunamadı."
      },
      bankPanel: {
        title: "Banka Ödemeleri",
        hint: "Genişletilmiş inceleme penceresindeki banka işlemleri",
        empty: "Bu çalışma alanı için banka kaydı bulunamadı."
      }
    },
    erpTable: {
      shiftTransactionId: "Vardiya İşlem No",
      matchId: "Eşleşme No",
      shiftId: "Vardiya No",
      employeeName: "Personel Adı",
      pumpNo: "Pompa No",
      plate: "Plaka",
      receiptNo: "Fiş No",
      amount: "Tutar",
      transactionTime: "ERP İşlem Saati",
      matchStatus: "Eşleşme Durumu",
      matchedBankCode: "Eşleşen Banka",
      matchedTerminalNo: "Eşleşen Terminal",
      matchedBankTime: "Eşleşen Banka Saati",
      matchType: "Tür",
      allocatedBankTotal: "Banka Tahsisi",
      allocatedCashTotal: "Nakit Tahsisi",
      cashPortion: "Nakit Kısmı",
      remainingAmount: "Kalan"
    },
    bankTable: {
      bankTransactionId: "Banka İşlem No",
      bankCode: "Banka Kodu",
      terminalNo: "Terminal No",
      merchantNo: "Üye İşyeri No",
      merchantName: "Üye İşyeri",
      authorizationCode: "Provizyon Kodu",
      amount: "Tutar",
      transactionTime: "Banka İşlem Saati",
      state: "Durum",
      matchedInfo: "Eşleşme Bilgisi",
      matchedShiftId: "Bağlı Vardiya"
    },
    suggestions: {
      title: "Önerilen Adaylar",
      none: "Bu ERP kaydı için öneri bulunamadı.",
      diffMinutes: "Zaman farkı (dk)",
      exactAmount: "Tutar birebir eşleşiyor",
      allowedTerminal: "Uygun terminal",
      alreadyMatched: "Başka bir kayıtla zaten eşleşmiş"
    },
    actions: {
      title: "İşlemler",
      addBankAllocation: "Banka Tahsisi Ekle",
      addCashAllocation: "Nakit Tahsisi Ekle",
      deleteAllocation: "Tahsisi Sil",
      clearSelectedBankRow: "Seçili Banka Kaydını Temizle",
      allocationAmount: "Tahsis Tutarı",
      allocationAmountPlaceholder: "Tutar giriniz"
    },
    badges: {
      auto: "OTOMATİK",
      manual: "MANUEL",
      matched: "EŞLEŞTİ",
      pending: "BEKLEMEDE",
      ambiguous: "BELİRSİZ",
      rejected: "REDDEDİLDİ",
      locked: "KİLİTLİ",
      selectable: "SEÇİLEBİLİR",
      used: "KULLANILMIŞ",
      partiallyAllocated: "KISMİ TAHSİSLİ",
      matchedCurrentShift: "BU VARDİYA",
      matchedOtherShift: "DİĞER VARDİYA",
      fraudRisk: "ŞÜPHELİ",
      suggested: "ÖNERİ",
      linked: "BAĞLI"
    },
    details: {
      allocations: "Tahsisler",
      noAllocations: "Tahsis bulunamadı",
      allocationType: "Tür",
      allocationTypeBank: "Banka",
      allocationTypeCash: "Nakit",
      allocationAmount: "Tutar",
      allocationBank: "Banka",
      allocationTerminal: "Terminal",
      allocationBankTime: "Banka Saati",
      allocationAuthorization: "Provizyon",
      allocationNote: "Not",
      cashAllocationHint:
        "Nakit tahsisi sadece açıklama amaçlıdır. Eşleşen banka toplamlarını ve vardiya nakit toplamlarını etkilemez."
    },
    indicators: {
      alreadyMatchedElsewhere: "Başka bir kayıtla eşleşmiş",
      selectable: "Seçilebilir",
      locked: "Kilitli"
    },
    confirmations: {
      title: "İşlemi Onayla",
      addBankAllocation: "Bu banka tahsisini oluşturmak istiyor musunuz?",
      addCashAllocation: "Bu nakit tahsisini oluşturmak istiyor musunuz?"
    },
    alerts: {
      workspaceLoadFailed: "Mutabakat çalışma alanı yüklenemedi.",
      selectErpRow: "Lütfen bir ERP kaydı seçin.",
      selectBankRow: "Lütfen bir banka kaydı seçin.",
      bankRowLocked: "Bu banka kaydı başka bir eşleşmede kullanıldığı için seçilemez.",
      invalidAllocationAmount: "Lütfen geçerli bir tahsis tutarı girin.",
      bankAllocationSuccess: "Banka tahsisi başarıyla oluşturuldu.",
      bankAllocationFailed: "Banka tahsisi başarısız oldu.",
      cashAllocationSuccess: "Nakit tahsisi başarıyla oluşturuldu.",
      cashAllocationFailed: "Nakit tahsisi başarısız oldu.",
      allocationDeletedSuccess: "Tahsis başarıyla silindi.",
      allocationDeletedFailed: "Tahsis silme işlemi başarısız oldu."
    }
  },
  paymentTypeCorrection: {
    breadcrumb: "Ödeme Tipi Düzeltme",
    title: "Ödeme Tipi Düzeltme",
    subtitle:
      "ERP/Turpak üzerinde nakit olarak girilmiş ancak gerçekte kredi kartı ile ödenmiş satışları düzeltmek için bu sayfayı kullanın. Düzeltmeden sonra satış mutabakat çalışma alanında görünecektir.",
    description:
      "Bu sayfa, ERP/Turpak üzerinde nakit olarak girilmiş ancak gerçekte kredi kartı ile ödenmiş satışları düzeltmek içindir. Bu işlem banka eşleştirmesi oluşturmaz ve vardiya nakit / yatırma kayıtlarını değiştirmez.",
    loading: "Satışlar yükleniyor...",
    yes: "Evet",
    no: "Hayır",
    filters: {
      shiftIdPlaceholder: "Vardiya No giriniz, örn. 2026041401",
      search: "Ara"
    },
    sections: {
      cashSales: "Nakit Satışlar",
      correctedSales: "Düzeltilmiş Satışlar"
    },
    table: {
      shiftTransactionId: "Vardiya İşlem No",
      receiptNo: "Fiş No",
      dateTime: "Tarih / Saat",
      plate: "Plaka",
      pumpNo: "Pompa No",
      total: "Tutar",
      originalPaymentType: "Orijinal Ödeme Tipi",
      effectivePaymentType: "Efektif Ödeme Tipi",
      corrected: "Düzeltildi mi?",
      action: "İşlem",
      reason: "Düzeltme Nedeni",
      correctedBy: "Düzelten",
      correctedAt: "Düzeltme Zamanı"
    },
    paymentTypes: {
      cash: "Nakit",
      card: "Kredi Kartı"
    },
    actions: {
      convertToCard: "Kredi Kartına Çevir",
      openReconciliation: "Mutabakata Git",
      cancel: "İptal",
      confirm: "Onayla",
      processing: "İşleniyor..."
    },
    modal: {
      title: "Kredi Kartına Çevir",
      reason: "Neden",
      reasonPlaceholder: "Düzeltme nedenini giriniz",
      warning:
        "Bu işlem satışın efektif ödeme tipini nakitten kredi kartına çevirir. Otomatik banka eşleştirmesi oluşturmaz ve vardiya nakit / yatırma kayıtlarını değiştirmez."
    },
    empty: {
      cashSales: "Bu vardiya için nakit satış bulunamadı.",
      correctedSales: "Bu vardiya için düzeltilmiş satış bulunamadı."
    },
    alerts: {
      shiftIdRequired: "Lütfen bir vardiya no girin.",
      loadFailed: "Satışlar yüklenemedi.",
      reasonRequired: "Lütfen bir düzeltme nedeni girin.",
      convertSuccess: "Satış başarıyla kredi kartına çevrildi.",
      convertFailed: "Satış dönüştürme işlemi başarısız oldu."
    }
  }
};
